import * as React from "react";
import { forwardRef } from "react";
const SvgHardwareFig = (props: React.SVGProps<SVGSVGElement>, ref: React.ForwardedRef<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1em"
    fill="none"
    viewBox="0 0 29647 5226"
    ref={ref}
    {...props}
  >
    <path fill="#CBDEDC" d="M1 0h29646v5225H1z" />
    <path fill="#CDA024" fillOpacity={0.6} d="M0 3038h29647v2188H0z" />
    <path stroke="#424546" strokeWidth={100} d="M29647 2929H.999" />
    <path stroke="#5BB3E5" strokeWidth={70} d="M29647 2929H.999" />
    <path
      fill="#5BB3E5"
      d="M12255 2958h16v22h-16zM12288 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M12943 2958h16v22h-16zM12976 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M13278 2958h16v22h-16zM13311 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M13613 2958h16v22h-16zM13646 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M13948 2958h16v22h-16zM13981 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M14283 2958h16v22h-16zM14316 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M14618 2958h16v22h-16zM14651 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M14953 2958h16v22h-16zM14986 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M15288 2958h16v22h-16zM15321 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M15623 2958h16v22h-16zM15656 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M15958 2958h16v22h-16zM15991 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M16293 2958h16v22h-16zM16326 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M16628 2958h16v22h-16zM16661 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M11920 2958h16v22h-16zM11953 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M11491 2958h16v22h-16zM11524 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M11033 2958h16v22h-16zM11066 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M7916 2958h16v22h-16zM7949 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M5588 2958h16v22h-16zM5621 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M3243 2958h16v22h-16zM3276 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M18973 2958h16v22h-16zM19006 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M21318 2958h16v22h-16zM21351 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M23663 2958h16v22h-16zM23696 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M26008 2958h16v22h-16zM26041 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M28353 2958h16v22h-16zM28386 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M10698 2958h16v22h-16zM10731 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M7581 2958h16v22h-16zM7614 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M5253 2958h16v22h-16zM5286 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M2908 2958h16v22h-16zM2941 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M18638 2958h16v22h-16zM18671 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M20983 2958h16v22h-16zM21016 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M23328 2958h16v22h-16zM23361 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M25673 2958h16v22h-16zM25706 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M28018 2958h16v22h-16zM28051 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M10363 2958h16v22h-16zM10396 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M7246 2958h16v22h-16zM7279 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M4918 2958h16v22h-16zM4951 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M18303 2958h16v22h-16zM18336 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M2573 2958h16v22h-16zM2606 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M20648 2958h16v22h-16zM20681 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M22993 2958h16v22h-16zM23026 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M25338 2958h16v22h-16zM25371 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M27683 2958h16v22h-16zM27716 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M10028 2958h16v22h-16zM10061 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M6911 2958h16v22h-16zM6944 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M17968 2958h16v22h-16zM18001 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M4583 2958h16v22h-16zM4616 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M2238 2958h16v22h-16zM2271 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M20313 2958h16v22h-16zM20346 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M22658 2958h16v22h-16zM22691 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M25003 2958h16v22h-16zM25036 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M27348 2958h16v22h-16zM27381 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M9693 2958h16v22h-16zM9726 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M17633 2958h16v22h-16zM17666 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M6576 2958h16v22h-16zM6609 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M4248 2958h16v22h-16zM4281 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M1903 2958h16v22h-16zM1936 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M19978 2958h16v22h-16zM20011 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M22323 2958h16v22h-16zM22356 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M24668 2958h16v22h-16zM24701 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M27013 2958h16v22h-16zM27046 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M17298 2958h16v22h-16zM17331 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M9358 2958h16v22h-16zM9391 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M6241 2958h16v22h-16zM6274 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M3913 2958h16v22h-16zM3946 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M1568 2958h16v22h-16zM1601 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M19643 2958h16v22h-16zM19676 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M21988 2958h16v22h-16zM22021 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M24333 2958h16v22h-16zM24366 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M26678 2958h16v22h-16zM26711 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M9023 2958h16v22h-16zM9056 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M5906 2958h16v22h-16zM5939 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M3578 2958h16v22h-16zM3611 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M1233 2958h16v22h-16zM1266 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M16963 2958h16v22h-16zM16996 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M19308 2958h16v22h-16zM19341 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M21653 2958h16v22h-16zM21686 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M23998 2958h16v22h-16zM24031 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M26343 2958h16v22h-16zM26376 3041.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M8558 2958h16v22h-16zM8591 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95M8223 2958h16v22h-16zM8256 3041.95c0 13.83-11.19 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M11418.1 886.55s-68.8-276.148-69.7-356.212c-.7-54.161 43.5-165.091 43.5-165.091s-11 144.841-2.5 213.377c10.7 86.911 61.4 279.754 61.4 279.754zM12045.5 2213.99s277.5 63.11 357.6 62.41c54.1-.48 164.1-46.92 164.1-46.92s-144.6 13.96-213.2 6.9c-87.2-8.95-281-55.72-281-55.72z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.589}
      d="M11303.1 2306.08s-502.4-194.88-651.5-233.71c-100.9-26.28-330.3 8.28-330.3 8.28s291.4 33.67 415.2 81.8c157 61.04 544.3 230.92 544.3 230.92z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M11652.2 2306.13s475.7-183.11 615.1-224.21c94.3-27.81 299.9-25.33 299.9-25.33s-255.7 57.79-372.9 102.99c-148.7 57.32-519.2 240.93-519.2 240.93z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.376}
      d="M11134.4 1404.65s-127.2 168.85-175.8 202.89c-32.9 23.03-128.1 34.53-128.1 34.53s95.6-51.64 132.5-86.79c46.8-44.58 134-164.61 134-164.61z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M11405.3 1373.57s-507.2-51.26-652.6-54.17c-98.3-1.97-295.9 54.61-295.9 54.61s261.9-11.64 386.9 1.06c158.5 16.11 564.3 95.59 564.3 95.59z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M12980.7 977.035s205.8-102.122 268-119.997c42.1-12.095 134.3-8.802 134.3-8.802s-114.2 24.516-166.4 44.547c-66.2 25.405-209.5 98.383-209.5 98.383z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.672}
      d="M11876.2 913.318s-183.5-38.257-231.5-60.125c-32.5-14.79-86.6-70.856-86.6-70.856s83.4 46.742 126.6 61.117c54.7 18.227 183.6 43.417 183.6 43.417zM10872.5 1377.63s-132.7 132.39-177.4 160.52c-30.2 19.03-106.7 33.48-106.7 33.48s84.8-44.05 120.5-72.27c45.4-35.78 137.2-129.69 137.2-129.69zM12330.3 1191.81s141.7 122.79 188.2 147.72c31.4 16.87 108.8 25.93 108.8 25.93s-87.7-38.01-125.3-63.65c-47.7-32.53-145.9-119.78-145.9-119.78zM11882.5 1805.72s141.7-122.79 188.2-147.73c31.4-16.87 108.8-25.92 108.8-25.92s-87.7 38-125.3 63.65c-47.7 32.52-145.9 119.78-145.9 119.78zM11850.9 836.012s95.5-161.366 111.7-211.577c10.9-33.965 6-111.723 6-111.723s-21.7 93.117-40.2 134.717c-23.4 52.753-91.7 164.955-91.7 164.955z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M12360.8 611.395s112.3-200.356 133.3-261.572c14.2-41.41 15.6-133.703 15.6-133.703s-30.3 112.828-52.9 163.969c-28.7 64.852-108.8 204.324-108.8 204.324z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M12720.3 620.041s279.1-46.876 353.8-75.597c50.6-19.424 140.3-92.718 140.3-92.718s-130.6 63.734-197.4 81.198c-84.7 22.143-282.6 46.266-282.6 46.266z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M11437.8 1803.28s315.4-13.33 420.5-8.19c71 3.46 209.7 38.98 209.7 38.98s-188.1-17.2-279.1-16.81c-115.5.5-413.6 19.81-413.6 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.982}
      d="M11962.9 1182.95s-151.5-380.008-176.7-496.641c-17.1-78.843-45.1-335.532-45.1-335.532s68.8 268.373 96.5 367.883c35 126.191 182.7 430.06 182.7 430.06zM11310.5 1244.28s163.3-382.104 192.1-499.855c19.5-79.599 55.4-339.361 55.4-339.361s-77.1 270.706-107.8 371.034c-39 127.228-196.1 432.182-196.1 432.182z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M11997.1 1191.4s315.4-13.33 420.5-8.19c71 3.47 209.7 38.98 209.7 38.98s-188.1-17.2-279.1-16.81c-115.5.5-413.6 19.81-413.6 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M12420.1 829.864s-105.5-254.276-129.4-342.819c-16.2-59.896-14-188.485-14-188.485s33.4 161.827 59.8 236.624c33.4 94.85 127.4 300.145 127.4 300.145z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M11027.3 668.82s162.9-161.962 199.8-215.099c25-35.944 51.6-124.343 51.6-124.343s-60 100.247-95.8 143.242c-45.3 54.521-160.5 166.749-160.5 166.749z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M11020.8 924.324s-31.9-273.429-30.6-365.131c.8-62.033 38-185.133 38-185.133s-12.1 164.791-7.2 243.955c6.2 100.389 44.6 358.379 44.6 358.379z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M11258 3039h148s-177.7-699.7 18.7-1151.04c207.5-513.15 1003.8-1026.482 1095.3-1086.46s172.6 121.178 297.7 153.795c247.1 64.405 565.3 104.965 565.3 104.965s-324.1-48.84-550.3-139.453c-107-42.876-200.8-116.98-222.2-160.807-22.4-46.027 95.9-101.407 144.9-182.9 96.3-160.097 209.3-299.565 204.8-304.06s-231.4 266.718-371.9 403.355c-269.9 262.406-1007.2 636.945-1217.6 1153.085-175.4 385.36-100.4 473.28-112.7 1209.52"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M11721.5 3039h-120s64.7-830.16-53.8-1185.53c-167.9-503.75-483.4-846.7-694.1-1009.141-49.6-38.221-51.5 21.64-133.8 54.257-162.6 64.402-272.7-57.256-272.7-57.256s287.8 79.472 331.5-56.979c14.8-46.028-77.7-158.937-138.4-222.251-84.3-88.123-83.7-157.047-83.7-157.047s174.5 152.694 267 289.331c177.5 262.406 669 605.456 807.4 1121.596 149.3 556.8 60.4 489.28 90.6 1223.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12561.3 1350.99 132.4-68.52s-53.4-9.23-81.7 3.29c-28.4 12.52-50.7 65.23-50.7 65.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12560.9 1351.58 132.8-67.73s-23.9 48.95-50.6 64.7-82.2 3.03-82.2 3.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12037.2 1848.66 132.4-68.52s-53.4-9.23-81.7 3.29c-28.4 12.52-50.7 65.23-50.7 65.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12036.8 1849.25 132.8-67.74s-23.9 48.96-50.6 64.7c-26.7 15.75-82.2 3.04-82.2 3.04"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12087.4 1653.16 82.2 89.94s-4-44.1-19.9-63.8c-15.9-19.69-62.3-26.14-62.3-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12086.9 1652.98 81.6 90.43s-43.7-8.48-61.7-26.2c-18.1-17.72-19.9-64.23-19.9-64.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12108.5 1662.35 122.8-20.06s-40-21.14-65.7-18.55c-25.8 2.59-57.1 38.61-57.1 38.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12108 1662.71 122.9-19.32s-31.6 32.62-56.9 38.2c-25.2 5.58-66-18.88-66-18.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12016.3 1823.78 42.8 120.93s14.1-44.44 6.8-70.06-49.6-50.87-49.6-50.87"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12015.8 1823.38 42.1 121.18s-38.9-26.15-49.2-50.76c-10.2-24.6 7.1-70.42 7.1-70.42"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12548.1 1353.74 45.7-141.96s-44.4 31.09-55.7 59.94 10 82.02 10 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12548.2 1354.42 46.6-141.67s17.5 51.6 9.7 81.59c-7.9 29.99-56.3 60.08-56.3 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13013.1 998.655-155.6 73.855s61.3 12.77 94.5-.56 61.1-73.295 61.1-73.295"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13013.6 997.998-156.1 72.922s29.6-55.56 61-72.676c31.5-17.121 95.1-.246 95.1-.246"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11739.2 1800.47 87.4-120.91s-51.9 15.86-71.5 39.82c-19.7 23.96-15.9 81.09-15.9 81.09"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11739.2 1801.16 88-120.38s.7 54.48-16 80.58-72 39.8-72 39.8"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12470.1 2053.7 82.2 89.94s-4.1-44.1-19.9-63.8c-15.9-19.7-62.3-26.14-62.3-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12469.6 2053.51 81.6 90.43s-43.7-8.48-61.8-26.2c-18-17.72-19.8-64.23-19.8-64.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11980.4 1746.11 122.8-20.06s-40-21.15-65.7-18.55c-25.7 2.59-57.1 38.61-57.1 38.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11980 1746.47 122.8-19.33s-31.6 32.63-56.8 38.21c-25.3 5.57-66-18.88-66-18.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12230.1 2216.74-76.2 103.26s44.8-13.21 61.9-33.65c17.1-20.43 14.3-69.61 14.3-69.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12230.1 2216.14-76.7 102.79s-.2-46.86 14.4-69.17c14.7-22.3 62.3-33.62 62.3-33.62"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11841.9 2303.72-76.1 103.25s44.7-13.21 61.8-33.64c17.1-20.44 14.3-69.61 14.3-69.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11842 2303.11-76.8 102.8s-.1-46.87 14.5-69.18c14.6-22.3 62.3-33.62 62.3-33.62"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11947.1 1765.47 45.7-141.96s-44.4 31.09-55.7 59.94 10 82.02 10 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11947.2 1766.15 46.6-141.67s17.5 51.6 9.7 81.59c-7.9 29.99-56.3 60.08-56.3 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11739.7 1819.39 127.1 116.3s-11.3-61.59-36.1-87.33c-24.9-25.74-91-28.97-91-28.97"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11739 1819.2 126.3 117.06s-62.6-6.44-90.3-29.12c-27.7-22.67-36-87.94-36-87.94"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12078.5 1652.27 90.5-118.55s-52.2 14.48-72.5 37.91-18 80.64-18 80.64"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12078.4 1652.96 91.2-118.01s-.7 54.49-18.1 80.13c-17.4 25.65-73.1 37.88-73.1 37.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12385.9 537.094 147.5 21.754s-38-38.698-68.3-45.092-79.2 23.338-79.2 23.338"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12385.2 537.34 147.4 22.637s-48 25.757-78.9 22.941c-30.8-2.816-68.5-45.578-68.5-45.578"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12478 335.989 120.7-16.046s-38.5-21.866-63.7-20.08c-25.3 1.787-57 36.126-57 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12477.5 336.332 120.9-15.324s-32 31.012-56.9 35.733c-24.8 4.721-64-20.409-64-20.409"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12216.4 561.784 120.8-16.046s-38.5-21.867-63.8-20.08c-25.2 1.786-57 36.126-57 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12216 562.126 120.8-15.323s-31.9 31.012-56.8 35.733-64-20.41-64-20.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12495.6 271.424 53.7-112.221s-40.2 20.726-52.7 43.31c-12.6 22.584-1 68.911-1 68.911"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12495.7 272.005 54.3-111.895s8.7 44.611-1.1 68.521c-9.9 23.91-53.2 43.374-53.2 43.374"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12384.5 701.904-139.7-52.202s29 45.8 57.3 58.406 82.4-6.204 82.4-6.204"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12385.2 701.8-139.4-53.035s52.3-15.12 81.9-5.894 57.5 58.929 57.5 58.929"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12423.9 489.049 53.7-112.221s-40.2 20.726-52.8 43.31c-12.5 22.584-.9 68.911-.9 68.911"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12423.9 489.632 54.4-111.895s8.7 44.611-1.2 68.521c-9.8 23.909-53.2 43.374-53.2 43.374"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12430 489.342-90.4-118.663s.1 54.219 17.4 79.977c17.2 25.757 73 38.686 73 38.686"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12430.6 489.621-89.6-119.198s52.3 15.125 72.4 38.713c20.2 23.587 17.2 80.485 17.2 80.485"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12331.1 549.428-120.4-87.995s15.5 51.935 39.4 71.718c23.8 19.782 81 16.277 81 16.277"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12331.8 549.516-119.9-88.712s54.5-.419 80.5 16.457 39.4 72.255 39.4 72.255"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12472.1 342.772-45.5-142.008s-18 51.155-10.4 81.182c7.7 30.027 55.9 60.826 55.9 60.826"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12472.7 343.254-44.8-142.274s44.3 31.722 55.4 60.671-10.6 81.603-10.6 81.603"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.571}
      d="M10786 2126.46s-110-220.07-164.8-281.2c-37.1-41.36-151-92.47-151-92.47s109.7 101.23 150.3 159.22c51.3 73.54 144.5 250.44 144.5 250.44s21-4.5 25.5-11.99c4.5-7.5-4.5-24-4.5-24"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10569 1819.25 112.1-72.06s-16.6 45.5-39 61.88c-22.3 16.37-73.1 10.18-73.1 10.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10568.4 1819.29 111.7-72.73s-48.6-3.29-72.7 10.37c-24.1 13.67-39 62.36-39 62.36"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10654.9 1904.37 132.9 10.59s-40.8 26.11-68.5 25.61c-27.7-.51-64.4-36.2-64.4-36.2"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10654.4 1904.02 132.9 9.8s-36.6-32.05-64.1-35.78c-27.4-3.73-68.8 25.98-68.8 25.98"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10493.1 1773.3-108.6 55.08s19.4-39.82 41.2-52.63c21.8-12.8 67.4-2.45 67.4-2.45"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10493.7 1773.33-108.3 55.73s43.9 7.51 67-2.67c23.2-10.18 41.3-53.06 41.3-53.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10492.3 1766.33-107.8-62.17s44.9-5.64 68 5.87c23.2 11.52 39.8 56.3 39.8 56.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10492.6 1766.83-108.1-61.52s18 41.7 39.7 55.85c21.6 14.14 68.4 5.67 68.4 5.67"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m10603.9 1873.01-89.3 105.74s2.7-50.25 19.9-73.32c17.1-23.06 69.4-32.42 69.4-32.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m10604.6 1872.78-88.7 106.27s49.2-11.56 69-32.48c19.7-20.91 19.7-73.79 19.7-73.79"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10571.7 1839.54-124.1 8.84s34-29.8 59.6-33.22 64.5 24.38 64.5 24.38"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10572.2 1839.79-124 9.58s38.3 24.44 64.2 24.03c25.8-.4 59.8-33.61 59.8-33.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10575.4 1814.25-7.4-148.96s-30.5 44.78-30.9 75.76c-.4 30.99 38.3 73.2 38.3 73.2"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10575.8 1814.84-6.5-148.99s34.6 42.08 37.8 72.91c3.3 30.83-31.3 76.08-31.3 76.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10495.3 1773.86-42.7-142.89s43.7 32.02 54.4 61.1-11.7 81.79-11.7 81.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10495.2 1774.55-43.6-142.63s-18.6 51.22-11.4 81.37c7.2 30.14 55 61.26 55 61.26"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10612.7 1878.29 16.1 123.35s-31.7-32.19-36.7-57.56c-4.9-25.38 20.6-65.79 20.6-65.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10612.9 1877.75 16.9 123.25s22.1-39.7 20.2-65.49c-2-25.79-37.1-57.76-37.1-57.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10587.1 2039.19 124.3-6.28s-37.4-25.46-63.3-25.74c-25.8-.29-61 32.02-61 32.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10586.6 2039.5 124.3-5.54s-35.1 28.91-60.8 31.64c-25.7 2.74-63.5-26.1-63.5-26.1"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10759.5 2111.52 102.2-108.65s-5.7 53.91-25.5 77.74c-19.8 23.84-76.7 30.91-76.7 30.91"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10758.9 2111.73 101.5-109.26s-53.6 9.62-76.1 30.99-25.4 78.27-25.4 78.27"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m10712.7 2001.85 120.6-30.72s-28.2 35.39-52.8 43.3-67.8-12.58-67.8-12.58"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m10712.1 2001.71 120.5-31.44s-42.1-17.27-67.5-12.28c-25.4 4.98-53 43.72-53 43.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10656 1905.42 83.5-123.54s2.9 54.14-12.8 80.82-70.7 42.72-70.7 42.72"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10655.4 1905.74 82.8-124.04s-51.5 18.04-70.2 42.72c-18.8 24.68-12.6 81.32-12.6 81.32"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12535.4 1341.7 82.1 89.94s-4-44.1-19.9-63.8-62.2-26.14-62.2-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12534.8 1341.52 81.7 90.43s-43.7-8.48-61.8-26.2-19.9-64.23-19.9-64.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12425.5 1194.34 46.8-115.26s-38.8 23.11-50 46.42c-11.2 23.3 3.2 68.84 3.2 68.84"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12425.6 1194.92 47.5-114.97s11.4 44 3 68.46c-8.4 24.47-50.5 46.51-50.5 46.51"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12368.8 1212.19 42.8 120.93s14.2-44.43 6.8-70.06c-7.3-25.62-49.6-50.87-49.6-50.87"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12368.4 1211.79 42 121.18s-38.9-26.14-49.1-50.75c-10.3-24.61 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12619.7 1232.07 45.8-141.95s-44.4 31.08-55.7 59.93 9.9 82.02 9.9 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12619.9 1232.76 46.6-141.67s17.5 51.6 9.6 81.59c-7.8 29.98-56.2 60.08-56.2 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12398.8 2265.28 141.6-98.16s-62.6-2.63-93.2 15.91c-30.6 18.55-48.4 82.25-48.4 82.25"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12398.5 2266.01 142.1-97.32s-20.1 59.62-48.4 81.63c-28.2 22-93.7 15.69-93.7 15.69"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12904.1 946.749 132.5-68.528s-53.4-9.228-81.8 3.292c-28.3 12.519-50.7 65.236-50.7 65.236"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12903.8 947.333 132.8-67.732s-23.9 48.952-50.6 64.7-82.2 3.032-82.2 3.032"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12208.8 1195.13 82.1 89.94s-4-44.1-19.9-63.8-62.2-26.14-62.2-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12208.2 1194.95 81.6 90.42s-43.6-8.47-61.7-26.2c-18.1-17.72-19.9-64.22-19.9-64.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m13243.5 870.357 54.3-111.912s-40.3 20.496-53 43.007c-12.7 22.512-1.3 68.905-1.3 68.905"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m13243.5 870.94 55-111.581s8.4 44.66-1.5 68.513c-10 23.853-53.5 43.068-53.5 43.068"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12559 1091.83 42.8 120.93s14.1-44.44 6.8-70.06-49.6-50.87-49.6-50.87"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12558.5 1091.43 42.1 121.18s-38.9-26.15-49.2-50.75c-10.2-24.61 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12149.8 1336.88 45.8-141.95s-44.5 31.09-55.8 59.94 10 82.01 10 82.01"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12150 1337.57 46.5-141.67s17.5 51.6 9.7 81.59c-7.9 29.99-56.2 60.08-56.2 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13017.1 996.144 55.6 163.026s19.6-59.45 10.2-93.96c-9.5-34.51-65.8-69.066-65.8-69.066"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13016.5 995.605 54.6 163.345s-51.8-35.7-65.3-68.89c-13.4-33.2 10.7-94.455 10.7-94.455"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13184.5 1027.21 39.1 143.93s20.3-50.29 14-80.63-53.1-63.3-53.1-63.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13184 1026.71 38.2 144.16s-42.8-33.7-52.6-63.12c-9.7-29.42 14.4-81.04 14.4-81.04"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12230.8 2131.75 109 54.44s-19.6-39.71-41.5-52.39c-21.9-12.67-67.5-2.05-67.5-2.05"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12230.2 2131.77 108.7 55.09s-43.8 7.77-67.1-2.27c-23.2-10.04-41.6-52.82-41.6-52.82"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12906.6 947.788-33.3-119.871s-16.7 42.043-11.3 67.323c5.3 25.28 44.6 52.548 44.6 52.548"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12907 948.201-32.6-120.065s35.9 27.907 44.2 52.402c8.2 24.496-11.6 67.663-11.6 67.663"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11666.7 1819.58 42.8 120.93s14.1-44.43 6.8-70.05c-7.3-25.63-49.6-50.88-49.6-50.88"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11666.2 1819.18 42.1 121.19s-38.9-26.15-49.2-50.76c-10.2-24.6 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12304.2 1207.63 45.8-141.96s-44.5 31.09-55.8 59.94c-11.2 28.85 10 82.02 10 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12304.4 1208.31 46.6-141.67s17.5 51.6 9.6 81.59-56.2 60.08-56.2 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13150.9 1015.98 140.7-99.347s-62.6-2.107-93 16.698c-30.5 18.805-47.7 82.649-47.7 82.649"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13150.5 1016.71 141.3-98.506s-19.6 59.786-47.7 82.026c-28 22.24-93.6 16.48-93.6 16.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12225.2 2216.37 120.2 123.44s-7.7-62.15-31.1-89.27c-23.3-27.13-89.1-34.17-89.1-34.17"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12224.5 2216.13 119.4 124.15s-62.2-10.03-88.5-34.27c-26.4-24.24-30.9-89.88-30.9-89.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12049.5 2216.91-28.2 169.92s45.5-43.04 53.5-77.91-25.3-92.01-25.3-92.01"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12049.3 2216.15-29.3 169.74s-28.7-55.99-24.8-91.58 54.1-78.16 54.1-78.16"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12201.4 1207.27 69.9-131.75s-49.2 22.83-65.4 49.25c-16.1 26.43-4.5 82.5-4.5 82.5"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12201.4 1207.96 70.7-131.32s8.2 53.86-4.8 82.01-65.9 49.31-65.9 49.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12869.2 569.524 111.6 131.255s-3.5-62.521-25-91.16c-21.4-28.638-86.6-40.095-86.6-40.095"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12868.5 569.24 110.7 131.916s-61.3-14.202-86-40.159c-24.6-25.957-24.7-91.757-24.7-91.757"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11868.4 2245.61 78.9-126.6s-50.7 19.37-68.6 44.61c-18 25.25-10.3 81.99-10.3 81.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11868.4 2246.31 79.6-126.13s4.5 54.31-10.5 81.49c-14.9 27.19-69.1 44.64-69.1 44.64"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12511.5 2235.37 108.8 60.36s-18.2-41.38-40-55.28-68.8-5.08-68.8-5.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12511 2235.37 108.4 61s-45.1 6-68.3-5.28c-23.3-11.27-40.1-55.72-40.1-55.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11830.2 2303.87 158 68.51s-30.7-54.55-62.6-70.77-95.4 2.26-95.4 2.26"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11829.4 2303.95 157.6 69.46s-61.3 14.32-94.9 1.92-62.7-71.38-62.7-71.38"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13277.7 1044.65 64.5 134.5s10.8-53.12-.8-81.83c-11.7-28.72-63.7-52.67-63.7-52.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m13277.2 1044.24 63.6 134.88s-48.2-25.41-63.1-52.59c-15-27.17-.5-82.29-.5-82.29"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m13186.6 750.608 59 120.3s9.3-47.812-1.4-73.51c-10.7-25.697-57.6-46.79-57.6-46.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m13186.1 750.253 58.2 120.648s-43.5-22.432-57.1-46.721-1.1-73.927-1.1-73.927"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11870.5 2242.06-26.7-121.52s-18.9 41.06-15 66.6c4 25.53 41.7 54.92 41.7 54.92"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11870.9 2242.5-26-121.68s34.3 29.84 41.3 54.75c6.9 24.92-15.3 66.93-15.3 66.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12366.4 2150.35 42.8 120.93s14.1-44.44 6.8-70.06-49.6-50.87-49.6-50.87"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12365.9 2149.95 42.1 121.18s-38.9-26.15-49.2-50.75c-10.2-24.61 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12411.4 1948.26 42.8 120.93s14.1-44.43 6.8-70.05c-7.3-25.63-49.6-50.88-49.6-50.88"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12410.9 1947.86 42.1 121.19s-38.9-26.15-49.2-50.76c-10.3-24.6 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13276.3 1046.37 159.9-64.012s-60.4-16.561-94.4-5.329c-34 11.233-65.5 69.341-65.5 69.341"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13275.7 1047 160.3-63.056s-32.9 53.606-65.4 68.736c-32.4 15.12-94.9-5.68-94.9-5.68"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M12446 1281.3c-25.8 1.95-45.5 20.82-43.9 42.15 1.6 21.34 23.9 37.06 49.7 35.11 25.9-1.94 45.6-20.81 44-42.15-1.6-21.33-23.9-37.05-49.8-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12413.1 1337.75s-8.8-21.77.9-30.73c12.6-11.63 29.2-2.14 29.2-2.14-8.4 1.38-17.9 1.64-22.7 7.26-5.3 6.15-5.6 17.92-7.4 25.61"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M12444 1332.59s9.8 3.26 10.5 4.29c4.2 6.76 5.9 8.23 5.9 8.23s-9.7 3.33-14.2 2.73c-4.6-.6-9.5-3.83-9.5-3.83s.1 5.32-1.1 7.15c-1.5 2.18-7.9 5.93-7.9 5.93s-5.7-4.29-6.8-7.14c-1.2-2.93 5-9.06 5-9.06s-5.7.76-9-1.01c-3.5-1.84-8.2-7.53-8.2-7.53s4.6-3.71 8-4.14c3.2-.4 12.7 1.56 12.7 1.56s-6.4-4.65-8.5-8.08c-2.2-3.58 4.4-9.51 4.4-9.51s7.2 4.08 10.5 7.32c2.6 2.48.5 8.3.5 8.3s2.7-6.01 5.8-8.1c3.1-2.1 11.1-1.57 11.1-1.57s2.5 7.3.7 10.2c-1.7 2.74-9.9 4.26-9.9 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M12435.3 1343.59c1.4-.1 3.8.3 4.7-.38 1-.69 2.1-2.85 2.4-4.11.8-3.3.7-5.7-2.5-7.94-1.2-.8-3.4-.04-4.6.05-.7.05-1.5 0-2.1.16-2.5.59-4.4 2.37-6 4.03-.6.67-1.2 2.17-.6 3.03.5.77 1.4 1.48 1.9 2.32.7 1.1 1.8 3.34 3.4 3.85 1 .34 1.4-.43 2.1-.69.8-.27.4-.05 1.3-.32"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M12535.1 1193.67c-22.1 1.66-38.9 17.82-37.6 36.08 1.4 18.25 20.5 31.71 42.6 30.04 22.2-1.66 39-17.81 37.6-36.07s-20.4-31.71-42.6-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12507 1241.98s-7.5-18.64.7-26.3c10.8-9.96 25-1.84 25-1.84-7.1 1.18-15.3 1.41-19.4 6.21-4.5 5.27-4.7 15.35-6.3 21.93"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12533.4 1237.56s8.4 2.79 9 3.68c3.6 5.78 5.1 7.04 5.1 7.04s-8.3 2.85-12.2 2.33c-4-.51-8.2-3.28-8.2-3.28s.2 4.56-.9 6.13c-1.3 1.86-6.7 5.07-6.7 5.07s-4.9-3.67-5.9-6.11c-1-2.51 4.3-7.75 4.3-7.75s-4.8.65-7.7-.87c-2.9-1.57-7-6.44-7-6.44s4-3.18 6.9-3.54c2.7-.35 10.8 1.33 10.8 1.33s-5.4-3.98-7.2-6.92c-1.9-3.06 3.7-8.13 3.7-8.13s6.2 3.49 9 6.26c2.2 2.12.4 7.1.4 7.1s2.3-5.14 5-6.93c2.6-1.79 9.5-1.34 9.5-1.34s2.1 6.25.6 8.72c-1.4 2.35-8.5 3.65-8.5 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M12526 1246.98c1.2-.09 3.2.25 4-.33.8-.59 1.8-2.44 2.1-3.51.6-2.83.6-4.88-2.2-6.8-1-.69-2.9-.04-3.9.04-.6.05-1.3 0-1.8.14-2.2.51-3.8 2.03-5.2 3.44-.5.58-1 1.86-.5 2.6.5.66 1.3 1.26 1.7 1.98.5.95 1.5 2.87 2.8 3.3.9.29 1.3-.37 1.9-.59.6-.23.3-.04 1.1-.27"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M11842.6 1808.68c-22.2 1.67-39 17.82-37.6 36.08 1.3 18.26 20.4 31.71 42.5 30.05 22.2-1.67 39-17.82 37.6-36.08-1.3-18.26-20.4-31.71-42.5-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11814.4 1856.99s-7.5-18.64.8-26.3c10.7-9.96 25-1.83 25-1.83-7.2 1.18-15.3 1.4-19.5 6.21-4.5 5.26-4.7 15.34-6.3 21.92"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11840.9 1852.58s8.3 2.78 8.9 3.67c3.7 5.79 5.1 7.04 5.1 7.04s-8.3 2.85-12.2 2.34c-3.9-.52-8.1-3.28-8.1-3.28s.1 4.55-1 6.12c-1.2 1.87-6.7 5.08-6.7 5.08s-4.9-3.68-5.9-6.11c-1-2.51 4.3-7.76 4.3-7.76s-4.8.65-7.7-.86c-2.9-1.58-6.9-6.44-6.9-6.44s3.9-3.18 6.8-3.55c2.7-.35 10.8 1.33 10.8 1.33s-5.4-3.98-7.2-6.91c-1.9-3.06 3.8-8.14 3.8-8.14s6.1 3.49 9 6.27c2.1 2.12.3 7.1.3 7.1s2.4-5.15 5-6.94 9.5-1.34 9.5-1.34 2.2 6.25.6 8.73c-1.4 2.35-8.4 3.65-8.4 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M11833.4 1861.99c1.2-.09 3.2.26 4-.32.9-.59 1.8-2.45 2.1-3.52.6-2.83.6-4.88-2.2-6.8-1-.69-2.9-.03-3.9.05-.6.04-1.3 0-1.8.13-2.2.51-3.8 2.03-5.1 3.45-.6.57-1.1 1.85-.6 2.59.5.66 1.3 1.27 1.7 1.99.6.94 1.5 2.86 2.8 3.29 1 .29 1.3-.37 1.9-.58.7-.24.3-.05 1.1-.28"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M11978.6 1822.41c-25.9 1.95-45.5 20.82-43.9 42.15 1.6 21.34 23.8 37.06 49.7 35.11 25.9-1.94 45.5-20.81 43.9-42.15-1.6-21.33-23.9-37.05-49.7-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11945.7 1878.86s-8.8-21.78.9-30.73c12.5-11.64 29.2-2.15 29.2-2.15-8.4 1.38-17.9 1.64-22.7 7.26-5.3 6.15-5.6 17.93-7.4 25.62"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M11976.6 1873.7s9.8 3.26 10.4 4.29c4.3 6.76 6 8.23 6 8.23s-9.7 3.33-14.3 2.73-9.5-3.83-9.5-3.83.2 5.32-1.1 7.15c-1.5 2.18-7.8 5.93-7.8 5.93s-5.8-4.29-6.9-7.14c-1.1-2.93 5-9.06 5-9.06s-5.6.76-9-1.01c-3.4-1.84-8.1-7.53-8.1-7.53s4.6-3.71 8-4.14c3.2-.41 12.7 1.56 12.7 1.56s-6.4-4.65-8.5-8.08c-2.2-3.58 4.4-9.51 4.4-9.51s7.2 4.08 10.5 7.32c2.6 2.48.4 8.3.4 8.3s2.8-6.01 5.8-8.1c3.1-2.1 11.2-1.57 11.2-1.57s2.5 7.3.7 10.2c-1.7 2.74-9.9 4.26-9.9 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M11967.9 1884.7c1.3-.1 3.7.3 4.7-.38 1-.69 2.1-2.86 2.4-4.11.8-3.31.7-5.7-2.5-7.95-1.2-.8-3.4-.03-4.6.06-.7.05-1.5 0-2.2.16-2.5.59-4.4 2.37-5.9 4.02-.7.67-1.2 2.17-.6 3.03.5.77 1.4 1.48 1.9 2.32.6 1.11 1.7 3.35 3.3 3.85 1.1.34 1.5-.43 2.2-.68.8-.27.3-.05 1.3-.32"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12564.5 1355.67c24.4-2.7 42.3-21.16 40-41.23-2.2-20.07-23.7-34.15-48.1-31.44-24.3 2.7-42.2 21.16-40 41.23 2.3 20.07 23.8 34.15 48.1 31.44"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12563.7 1306.13s-9.4-2.74-10-3.7c-4.3-6.23-5.9-7.56-5.9-7.56s9-3.47 13.4-3.06c4.3.42 9 3.3 9 3.3s-.3-5.01.8-6.79c1.3-2.1 7.2-5.86 7.2-5.86s5.6 3.86 6.7 6.51c1.2 2.73-4.4 8.71-4.4 8.71s5.3-.9 8.5.66c3.3 1.62 8 6.82 8 6.82s-4.3 3.66-7.4 4.18c-3 .49-12-1.04-12-1.04s6.1 4.17 8.2 7.33c2.2 3.3-3.8 9.12-3.8 9.12s-6.9-3.61-10.2-6.55c-2.5-2.26-.7-7.82-.7-7.82s-2.3 5.76-5.2 7.84c-2.8 2.08-10.4 1.85-10.4 1.85s-2.6-6.8-1-9.59c1.5-2.64 9.2-4.35 9.2-4.35"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12553.4 1345.48s-22.1 1.52-27.3-9.78c-6.8-14.67 6.6-26.83 6.6-26.83-1.2 7.9-3.7 16.51-.1 22.49 4 6.54 14.5 10.23 20.8 14.12"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12572.5 1296.56c-1.3.14-3.5-.15-4.4.52-.9.68-1.9 2.76-2.1 3.96-.6 3.14-.5 5.4 2.6 7.41 1.2.71 3.2-.08 4.4-.21.6-.07 1.4-.05 2-.22 2.3-.64 4-2.39 5.4-4 .6-.65 1.1-2.09.5-2.88-.5-.71-1.4-1.35-1.9-2.12-.6-1.02-1.7-3.1-3.2-3.52-1.1-.29-1.4.45-2.1.72-.7.28-.3.06-1.2.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12369.6 1201.3c24.3-2.71 42.3-21.17 40-41.24-2.2-20.07-23.7-34.15-48.1-31.44-24.3 2.7-42.2 21.16-40 41.23 2.3 20.07 23.8 34.15 48.1 31.45"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12368.8 1151.75s-9.4-2.74-10.1-3.7c-4.2-6.23-5.8-7.56-5.8-7.56s9-3.47 13.3-3.05c4.4.41 9.1 3.29 9.1 3.29s-.3-5.01.8-6.78c1.3-2.11 7.2-5.86 7.2-5.86s5.6 3.85 6.7 6.5c1.2 2.73-4.4 8.72-4.4 8.72s5.3-.91 8.5.65c3.3 1.62 7.9 6.83 7.9 6.83s-4.2 3.65-7.3 4.17c-3.1.49-12.1-1.04-12.1-1.04s6.2 4.17 8.3 7.34c2.2 3.29-3.8 9.11-3.8 9.11s-6.9-3.6-10.2-6.55c-2.5-2.25-.7-7.81-.7-7.81s-2.4 5.76-5.2 7.84c-2.8 2.07-10.4 1.85-10.4 1.85s-2.6-6.81-1-9.6c1.5-2.64 9.2-4.35 9.2-4.35"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12358.5 1191.11s-22.1 1.51-27.3-9.79c-6.8-14.67 6.6-26.82 6.6-26.82-1.2 7.89-3.7 16.5-.1 22.48 4 6.54 14.5 10.23 20.8 14.13"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12377.6 1142.19c-1.3.14-3.6-.16-4.4.52-.9.68-1.9 2.76-2.1 3.95-.7 3.15-.5 5.4 2.6 7.41 1.1.72 3.2-.08 4.4-.21.6-.07 1.3-.05 1.9-.22 2.4-.64 4.1-2.38 5.5-3.99.6-.66 1.1-2.09.5-2.88-.5-.71-1.4-1.35-1.9-2.12-.6-1.03-1.7-3.11-3.3-3.53-1-.28-1.3.46-2 .72-.7.28-.3.06-1.2.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12123.6 1651.93c24.3-2.71 42.3-21.17 40-41.24-2.2-20.07-23.7-34.14-48.1-31.44-24.3 2.7-42.2 21.16-40 41.23 2.3 20.07 23.8 34.15 48.1 31.45"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12122.8 1602.38s-9.4-2.74-10.1-3.7c-4.2-6.23-5.8-7.56-5.8-7.56s9-3.47 13.3-3.05c4.4.41 9.1 3.29 9.1 3.29s-.3-5.01.8-6.78c1.3-2.11 7.2-5.86 7.2-5.86s5.6 3.85 6.7 6.5c1.2 2.73-4.4 8.72-4.4 8.72s5.3-.91 8.5.65c3.3 1.62 7.9 6.83 7.9 6.83s-4.2 3.65-7.3 4.17c-3.1.49-12-1.04-12-1.04s6.1 4.17 8.2 7.34c2.2 3.29-3.8 9.11-3.8 9.11s-6.9-3.6-10.2-6.55c-2.5-2.25-.7-7.81-.7-7.81s-2.3 5.76-5.2 7.84c-2.8 2.08-10.4 1.85-10.4 1.85s-2.6-6.81-1-9.6c1.5-2.64 9.2-4.35 9.2-4.35"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12112.5 1641.74s-22.1 1.51-27.3-9.79c-6.8-14.67 6.6-26.82 6.6-26.82-1.2 7.89-3.7 16.5-.1 22.48 4 6.54 14.5 10.23 20.8 14.13"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12131.6 1592.81c-1.3.15-3.5-.15-4.4.52-.9.69-1.9 2.77-2.1 3.96-.7 3.14-.5 5.4 2.6 7.41 1.1.72 3.2-.08 4.4-.21.6-.07 1.4-.05 2-.22 2.3-.64 4-2.38 5.4-4 .6-.65 1.1-2.08.5-2.87-.5-.71-1.4-1.35-1.9-2.13-.6-1.02-1.7-3.1-3.3-3.52-1-.28-1.3.46-2 .72-.7.28-.3.06-1.2.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M12146.8 1710.11c24.5 0 44.4-16.37 44.4-36.57 0-20.19-19.9-36.56-44.4-36.56s-44.3 16.37-44.3 36.56c0 20.2 19.8 36.57 44.3 36.57"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M12151.5 1660.77s-9-3.76-9.6-4.78c-3.5-6.67-5-8.17-5-8.17s9.4-2.45 13.6-1.56c4.3.89 8.7 4.28 8.7 4.28s.2-5.02 1.5-6.65c1.6-1.95 7.9-5.03 7.9-5.03s5 4.45 5.9 7.2c.9 2.85-5.4 8.18-5.4 8.18s5.4-.32 8.4 1.58c3.1 1.98 7.1 7.67 7.1 7.67s-4.6 3.17-7.8 3.33c-3 .16-11.8-2.36-11.8-2.36s5.7 4.82 7.4 8.2c1.8 3.52-4.8 8.64-4.8 8.64s-6.5-4.35-9.4-7.63c-2.2-2.52.2-7.84.2-7.84s-3 5.46-6 7.21c-3.1 1.75-10.6.69-10.6.69s-1.9-7.05 0-9.65c1.8-2.46 9.7-3.31 9.7-3.31"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12136.9 1698.76s-22.1-.94-26-12.74c-5.2-15.33 9.5-25.93 9.5-25.93-2.1 7.71-5.6 15.99-2.6 22.33 3.2 6.94 13.2 11.77 19.1 16.34"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M12161.3 1652.24c-1.3 0-3.5-.54-4.5.03-.9.58-2.1 2.54-2.5 3.7-1 3.05-1.1 5.31 1.8 7.65 1.1.84 3.2.28 4.4.28.6 0 1.3.1 2 0 2.4-.38 4.3-1.92 5.9-3.37.6-.58 1.3-1.95.8-2.81-.5-.76-1.3-1.49-1.7-2.31-.5-1.09-1.4-3.28-2.9-3.87-.9-.39-1.4.31-2.1.49-.7.21-.3.03-1.2.21"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M12425.3 1265.28c21.4-2.38 37.2-18.45 35.3-35.89-2-17.44-20.9-29.65-42.3-27.27-21.5 2.38-37.3 18.45-35.3 35.89 1.9 17.44 20.8 29.65 42.3 27.27"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M12424.6 1222.21s-8.2-2.36-8.8-3.19c-3.7-5.42-5.2-6.57-5.2-6.57s8-3.03 11.8-2.67c3.8.35 8 2.85 8 2.85s-.3-4.36.7-5.9c1.2-1.83 6.4-5.1 6.4-5.1s4.8 3.35 5.9 5.65c1 2.36-4 7.58-4 7.58s4.7-.8 7.5.55c3 1.41 7 5.92 7 5.92s-3.7 3.19-6.5 3.64c-2.7.43-10.6-.89-10.6-.89s5.4 3.62 7.3 6.37c1.9 2.86-3.4 7.92-3.4 7.92s-6.1-3.12-8.9-5.68c-2.2-1.95-.6-6.78-.6-6.78s-2.1 5.01-4.6 6.82-9.2 1.62-9.2 1.62-2.3-5.91-.9-8.34c1.3-2.3 8.1-3.8 8.1-3.8"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12415.5 1256.44s-19.5 1.34-24-8.47c-6-12.74 5.8-23.32 5.8-23.32-1 6.86-3.3 14.35-.1 19.54 3.5 5.68 12.7 8.87 18.3 12.25"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M12432.4 1213.89c-1.1.13-3.1-.13-3.9.46s-1.7 2.4-1.9 3.44c-.5 2.73-.4 4.69 2.4 6.44 1 .62 2.8-.08 3.8-.19.5-.06 1.2-.04 1.7-.19 2.1-.56 3.6-2.08 4.9-3.49.5-.56.9-1.81.4-2.5-.5-.61-1.2-1.17-1.7-1.84-.5-.89-1.5-2.69-2.8-3.06-.9-.24-1.2.4-1.8.63-.7.25-.3.05-1.1.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12752.5 895.853 123.2-120.416s-62.1 7.851-89.2 31.248-34 89.168-34 89.168"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12752.3 896.63 123.9-119.673s-9.9 62.144-34.1 88.554-89.8 31.119-89.8 31.119"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11736.2 1814.23 4.8-149.07s-34.1 42.15-37 72.99c-2.9 30.85 32.2 76.08 32.2 76.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11736.6 1814.85 5.6-149.03s31.1 44.76 31.8 75.76c.7 30.99-37.4 73.27-37.4 73.27"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12518.7 1912.85-57.1 162.5s52.2-34.55 66.2-67.51c13.9-32.97-9.1-94.99-9.1-94.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12518.6 1912.05-58.1 162.15s-18.6-60.11-8.7-94.49c10-34.38 66.8-67.66 66.8-67.66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12256.8 1962.37-24.8 170.45s44.6-43.94 51.9-78.97-27.1-91.48-27.1-91.48"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12256.5 1961.6-25.8 170.3s-29.9-55.4-26.7-91.06 52.5-79.24 52.5-79.24"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m12101.9 2034.27-22.2 152.53s39.9-39.33 46.4-70.67c6.6-31.34-24.2-81.86-24.2-81.86"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m12101.6 2033.59-23.1 152.39s-26.7-49.57-23.9-81.48c2.9-31.92 47-70.91 47-70.91"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12753.1 739.801-.9 149.141s33-43.017 35.1-73.931-34.2-75.21-34.2-75.21"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12752.8 739.184-1.8 149.129s-32.2-43.938-33.7-74.903c-1.6-30.964 35.5-74.226 35.5-74.226"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12656.1 971.086 122.7-20.057s-39.9-21.146-65.7-18.553c-25.7 2.592-57 38.61-57 38.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12655.6 971.45 122.9-19.321s-31.7 32.625-56.9 38.202c-25.3 5.577-66-18.881-66-18.881"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12730.8 1099.94 56.9-162.571s-52.2 34.611-66.1 67.591c-13.8 32.99 9.2 94.98 9.2 94.98"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12730.9 1100.74 57.9-162.226s18.7 60.078 8.8 94.476c-9.9 34.4-66.7 67.75-66.7 67.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12969.8 569.859 75.4-128.655s-50.1 20.714-67.4 46.428c-17.2 25.715-8 82.227-8 82.227"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12969.8 570.556 76.2-128.198s5.9 54.167-8.3 81.738-67.9 46.46-67.9 46.46"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m13069.4 1003.11 82.2 89.94s-4.1-44.11-20-63.8c-15.8-19.7-62.2-26.14-62.2-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m13068.9 1002.93 81.6 90.42s-43.7-8.48-61.8-26.2-19.8-64.22-19.8-64.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m13120.3 814.615-20.2 122.747s32.8-31.118 38.6-56.311c5.7-25.194-18.4-66.436-18.4-66.436"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m13120.1 814.061-20.9 122.621s-20.8-40.415-18-66.124c2.7-25.71 38.9-56.497 38.9-56.497"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12929 448.293 42.8 120.933s14.2-44.437 6.8-70.059c-7.3-25.621-49.6-50.874-49.6-50.874"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12928.6 447.895 42 121.184s-38.8-26.148-49.1-50.755c-10.3-24.606 7.1-70.429 7.1-70.429"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13098.7 521.217 164 52.863s-35.9-51.31-69.3-64.363c-33.3-13.052-94.7 11.5-94.7 11.5"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13097.9 521.367 163.6 53.842s-59.6 20.202-94.2 11.118-69.4-64.96-69.4-64.96"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13321.5 345.608-126 117.419s62.3-6.354 89.9-29.093c27.7-22.739 36.1-88.326 36.1-88.326"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m13321.8 344.839-126.7 116.659s11.4-61.888 36.2-87.709 90.5-28.95 90.5-28.95"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11828.3 570.27 82 151.499s9.5-61.892-5.5-94.351c-15.1-32.459-76.5-57.148-76.5-57.148"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11827.7 569.832 81 151.982s-57-26.582-75.8-57.082c-18.7-30.499-5.2-94.9-5.2-94.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11819.6 763.519-75.4-128.671s-6.4 53.841 7.6 81.483 67.8 47.188 67.8 47.188"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11820.2 763.879-74.7-129.116s50.2 21.312 67.3 47.149c17.2 25.837 7.4 81.967 7.4 81.967"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11755.5 444.012-114.6-48.367s22.6 39.181 45.7 50.672c23.2 11.491 68.9-2.305 68.9-2.305"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11756.1 443.946-114.3-49.05s44.1-10.78 68.5-2.062c24.3 8.719 45.8 51.112 45.8 51.112"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11910 700.708 159.9-64.132s-60.4-16.516-94.4-5.258-65.5 69.39-65.5 69.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11909.5 701.332 160.2-63.171s-32.9 53.629-65.3 68.78c-32.5 15.152-94.9-5.609-94.9-5.609"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11771.5 1048.99 141.6-46.63s-51.2-17.589-81.2-9.727c-30 7.857-60.4 56.357-60.4 56.357"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11771 1049.51 141.9-45.78s-31.4 44.53-60.2 55.84c-28.9 11.31-81.7-10.06-81.7-10.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11838.5 765.87-118 39.567s42.9 14.431 67.9 7.732c24.9-6.7 50.1-47.299 50.1-47.299"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11838.9 765.44-118.2 38.859s26-37.295 50-46.866 68.2 8.007 68.2 8.007"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11912.4 1002.36-157-70.741s30 54.978 61.6 71.651c31.7 16.67 95.4-.91 95.4-.91"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11913.3 1002.29-156.7-71.682s61.5-13.458 94.9-.585 61.8 72.267 61.8 72.267"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11943.1 1047.33 92.7-116.892s-52.6 13.532-73.3 36.588c-20.6 23.055-19.4 80.304-19.4 80.304"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11943 1048.02 93.3-116.326s-1.7 54.46-19.6 79.786c-17.8 25.33-73.7 36.54-73.7 36.54"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m11641.2 518.057 117.1-65.265s-48.3-6.782-73.4 5.258-43.7 60.007-43.7 60.007"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11640.9 518.591 117.4-64.562s-20.1 44.631-43.6 59.524c-23.6 14.894-73.8 5.038-73.8 5.038"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.505}
      d="m11966.7 569.761-52.8-114.161s-9.8 44.681-.3 69.026c9.5 24.346 53.1 45.135 53.1 45.135"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11967.2 570.107-52.2-114.472s40.4 21.973 52.7 45.059-.5 69.413-.5 69.413"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m11483.5 824.568 102.6-33.942s-37.2-12.7-58.9-6.972c-21.7 5.729-43.7 40.914-43.7 40.914"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m11483.1 824.939 102.9-33.327s-22.8 32.312-43.7 40.538c-20.9 8.227-59.2-7.211-59.2-7.211"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11703.4 971.878-26.5-121.553s-19 41.04-15 66.582c3.9 25.542 41.5 54.971 41.5 54.971"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11703.8 972.313-25.7-121.705s34.2 29.878 41.1 54.801-15.4 66.904-15.4 66.904"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11718.2 700.115-32.6 169.132s46.6-41.847 55.5-76.501-22.9-92.631-22.9-92.631"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11718 699.343-33.6 168.928s-27.3-56.708-22.5-92.187 56.1-76.741 56.1-76.741"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12283.3 358.571-116.2-93.515s13.2 52.605 36.1 73.478 80.1 20.037 80.1 20.037"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m12284 358.695-115.6-94.206s54.4 2.122 79.6 20.192c25.2 18.071 36 74.014 36 74.014"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11898.4 929.887 85.5-86.809s-43.8 6.385-62.7 23.294c-18.8 16.91-22.8 63.515-22.8 63.515"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11898.2 930.436 86-86.293s-6.1 44.08-22.9 63.081c-16.7 19.002-63.1 23.212-63.1 23.212"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11661.9 562.82 123.6 13.761s-32.8-31.134-58.2-35.565c-25.5-4.431-65.4 21.804-65.4 21.804"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11661.4 563.048 123.5 14.5s-39.2 22.895-65.1 21.463c-25.8-1.432-58.4-35.963-58.4-35.963"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12167.5 398.098 118.5-49.114s-45.1-11.788-70.3-3.116-48.2 52.23-48.2 52.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12167.1 398.567 118.8-48.402s-24 40.217-48.1 51.775c-24 11.558-70.7-3.373-70.7-3.373"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11024 386.254 109.3-61.117s-45.1-6.291-68.6 4.987c-23.4 11.278-40.7 56.13-40.7 56.13"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11023.6 386.755 109.7-60.459s-18.7 41.735-40.7 55.679c-22 13.943-69 4.78-69 4.78"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11208.9 464.94 120.8-16.046s-38.6-21.866-63.8-20.08c-25.3 1.787-57 36.126-57 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11208.4 465.283 120.9-15.323s-31.9 31.011-56.8 35.732c-24.9 4.722-64.1-20.409-64.1-20.409"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10893.4 729.542 120.7-16.047s-38.5-21.866-63.7-20.079c-25.3 1.786-57 36.126-57 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10892.9 729.884 120.9-15.323s-31.9 31.012-56.8 35.733-64.1-20.41-64.1-20.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11171.4 812.863-139.7-52.202s29 45.8 57.3 58.406c28.4 12.607 82.4-6.204 82.4-6.204"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11172.1 812.759-139.4-53.035s52.4-15.12 82-5.894 57.4 58.929 57.4 58.929"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11138.9 536.119 28.1 121.188s18.5-41.288 14.2-66.776c-4.3-25.487-42.3-54.412-42.3-54.412"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11138.5 535.687 27.4 121.351s-34.6-29.42-41.9-54.248c-7.2-24.829 14.5-67.103 14.5-67.103"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11134 539.692 144.7 36.279s-34-42.273-63.5-51.642c-29.6-9.368-81.2 15.363-81.2 15.363"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11133.3 539.875 144.5 37.144s-50.4 20.868-80.8 15.005c-30.5-5.864-63.7-52.149-63.7-52.149"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11013.5 719.391-120.5-87.995s15.6 51.935 39.5 71.717c23.8 19.783 81 16.278 81 16.278"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11014.1 719.479-119.8-88.712s54.4-.419 80.5 16.457c26 16.876 39.3 72.255 39.3 72.255"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11203.1 471.727-45.6-142.008s-18 51.155-10.4 81.182c7.7 30.027 56 60.826 56 60.826"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11203.6 472.209-44.8-142.274s44.3 31.723 55.4 60.671c11.1 28.949-10.6 81.603-10.6 81.603"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11014.2 487.524-116.2-93.515s13.2 52.605 36.1 73.478 80.1 20.037 80.1 20.037"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11014.9 487.65-115.6-94.206s54.4 2.122 79.6 20.192c25.2 18.071 36 74.014 36 74.014"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10898.4 527.051 118.5-49.114s-45.1-11.788-70.3-3.116-48.2 52.23-48.2 52.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10898.1 527.52 118.8-48.402s-24.1 40.217-48.1 51.775c-24.1 11.559-70.7-3.373-70.7-3.373"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11785.3 540.024 97.1-142.253s-59.3 19.895-81.3 48.152c-21.9 28.257-15.8 94.101-15.8 94.101"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11785.2 540.823 98-141.665s2.5 62.877-16 93.52-82 48.145-82 48.145"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m11750.7 385.969 33.8-127.816s-37.8 29.595-46.5 55.665 12.7 72.151 12.7 72.151"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m11750.8 386.57 34.7-127.606s17.9 44.869 12.3 71.787-47 55.819-47 55.819"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10709.7 886.883 82 151.497s9.5-61.89-5.6-94.349c-15-32.459-76.4-57.148-76.4-57.148"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10709 886.449 81.1 151.981s-57-26.58-75.8-57.081c-18.8-30.499-5.3-94.9-5.3-94.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10599 886.026-75.4-128.67s-6.4 53.841 7.6 81.483 67.8 47.187 67.8 47.187"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10599.6 886.381-74.6-129.116s50.1 21.312 67.2 47.149c17.2 25.837 7.4 81.967 7.4 81.967"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10844.6 1007.16 159.9-64.127s-60.4-16.516-94.4-5.258-65.5 69.385-65.5 69.385"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10844.1 1007.79 160.2-63.172s-32.9 53.629-65.3 68.782c-32.5 15.15-94.9-5.61-94.9-5.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10655.8 776.065-57.5 110.339s40.9-19.354 54.2-41.5c13.4-22.145 3.3-68.839 3.3-68.839"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10655.8 775.476-58.1 109.99s-7.2-44.88 3.4-68.443c10.7-23.562 54.7-41.547 54.7-41.547"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10608.4 640.794 123.6 13.762s-32.8-31.134-58.2-35.565c-25.5-4.431-65.4 21.803-65.4 21.803"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10607.8 641.02 123.6 14.501s-39.3 22.895-65.1 21.463-58.5-35.964-58.5-35.964"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10789.4 667.928 97.2-142.252s-59.4 19.894-81.4 48.151c-21.9 28.257-15.8 94.101-15.8 94.101"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10789.4 668.729 97.9-141.664s2.5 62.876-16 93.519-81.9 48.145-81.9 48.145"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m10794.9 668.305-40.7-125.826s-15.8 45.386-9 71.995c6.8 26.608 49.7 53.831 49.7 53.831"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m10795.4 668.732-40-126.063s39.4 28.048 49.3 53.695-9.3 72.368-9.3 72.368"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10959.9 1358.84 151.7-81.66s-61.9-9.64-94.4 5.36-57.3 76.3-57.3 76.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10959.5 1359.52 152.1-80.75s-26.7 56.98-57.2 75.68-94.9 5.07-94.9 5.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10983.6 1378.83-128.8 75.17s53.9 6.5 81.5-7.44c27.7-13.94 47.3-67.73 47.3-67.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10984 1378.23-129.3 74.39s21.4-50.1 47.3-67.18c25.9-17.09 82-7.21 82-7.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10606.5 1562.68-99.2 75.1s45.2.02 66.7-14.29c21.6-14.3 32.5-60.81 32.5-60.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10606.7 1562.15-99.6 74.5s12.7-43.63 32.4-60.36c19.8-16.72 67.2-14.14 67.2-14.14"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10963 1363.92-63.8-159.99s-16.6 60.37-5.4 94.36c11.1 33.99 69.2 65.63 69.2 65.63"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10963.6 1364.43-62.8-160.36s53.5 33.02 68.6 65.49-5.8 94.87-5.8 94.87"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m10478.3 1367.38-129.1 102.24s59.9-1.3 87.9-20.85c28.1-19.56 41.2-81.39 41.2-81.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m10478.5 1366.67-129.6 101.46s15.6-58.09 41.2-80.8c25.6-22.7 88.4-20.66 88.4-20.66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10965.2 1375.79 39.4 118.02s14.5-42.83 7.8-67.81c-6.6-24.97-47.2-50.21-47.2-50.21"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10964.8 1375.39 38.6 118.26s-37.2-26.05-46.7-50.09 8.1-68.17 8.1-68.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10658.5 1339.42-80.4 152.31s56.7-26.47 75.3-57.02c18.7-30.56 5.1-95.29 5.1-95.29"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10658.5 1338.62-81.4 151.82s-9.5-62.19 5.4-94.73 76-57.09 76-57.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10487.4 1375-71.2-131.06s-8.1 53.61 5 81.69 66.2 49.37 66.2 49.37"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10488 1375.37-70.4-131.47s49.4 22.93 65.7 49.31 4.7 82.16 4.7 82.16"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m10673.7 1679.17-65-117.15s-6.9 48.22 5.1 73.34 59.9 43.81 59.9 43.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10674.2 1679.5-64.3-117.53s44.6 20.2 59.5 43.76c14.8 23.56 4.8 73.77 4.8 73.77"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10478.2 1370.57-23.2 170.67s44.2-44.36 51.2-79.45c6.9-35.09-28-91.22-28-91.22"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10477.9 1369.81-24.2 170.53s-30.4-55.11-27.6-90.8c2.9-35.69 51.8-79.73 51.8-79.73"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11199.7 1419.82-116.9 126.51s61.6-10.99 87.5-35.74c25.8-24.74 29.4-90.77 29.4-90.77"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11199.9 1419.03-117.7 125.81s6.8-62.56 29.6-90.17c22.8-27.6 88.1-35.64 88.1-35.64"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11207 1575.69-6.7-149s-30.7 44.64-31.3 75.62c-.5 30.98 38 73.38 38 73.38"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11207.4 1576.28-5.8-149.02s34.4 42.24 37.5 73.09c3.1 30.84-31.7 75.93-31.7 75.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11246.8 1336.54-121.6 26.26s41 19.09 66.6 15.2c25.5-3.9 55-41.46 55-41.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11247.3 1336.15-121.8 25.54s29.9-34.19 54.9-41.04c24.9-6.85 66.9 15.5 66.9 15.5"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11169 1201.32-48.5 165.26s50.3-37.22 62.5-70.87c12.2-33.64-14-94.39-14-94.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11168.9 1200.53-49.6 164.96s-21.7-59.05-13.6-93.91c8.2-34.85 63.2-71.05 63.2-71.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10439.6 2089.95-72.4 130.4s49.6-21.89 66.3-48.01c16.7-26.11 6.1-82.39 6.1-82.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10439.6 2089.24-73.2 129.96s-7.1-54.01 6.4-81.91 66.8-48.05 66.8-48.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10754.4 1335.75 88.9-83.4s-44.1 4.66-63.6 20.82c-19.4 16.16-25.3 62.58-25.3 62.58"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10754.3 1336.29 89.3-82.86s-7.9 43.8-25.4 62.13c-17.5 18.34-63.9 20.73-63.9 20.73"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10677.1 1523.75 14-123.62s-31.2 32.74-35.7 58.2c-4.5 25.45 21.7 65.42 21.7 65.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10677.3 1524.29 14.8-123.53s22.8 39.3 21.3 65.12-36.1 58.41-36.1 58.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10291.5 892.843 165.3-48.321s-58.5-22.298-93.4-14.388c-34.9 7.911-71.9 62.709-71.9 62.709"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10290.9 893.42 165.6-47.329s-38 50.183-71.7 62.116c-33.8 11.932-93.9-14.787-93.9-14.787"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10751.3 1487.33-4.8 149.06s34.1-42.14 37-72.99-32.2-76.07-32.2-76.07"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10751 1486.71-5.7 149.03s-31.1-44.76-31.8-75.76c-.7-30.99 37.5-73.27 37.5-73.27"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10601.9 911.868-71.4 101.912s43.1-13.864 59.2-34.085 12.2-67.827 12.2-67.827"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10601.9 911.281-71.9 101.479s-1.3-45.433 12.3-67.406c13.7-21.973 59.6-34.073 59.6-34.073"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10767.9 1335.76-29.1-169.77s-28.9 55.59-25 91.16 54.1 78.61 54.1 78.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10768.4 1336.39-28.1-169.93s45.5 43.44 53.5 78.34-25.4 91.59-25.4 91.59"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10664.4 540.471 59.1-136.928s-47.2 26.696-61.2 54.334 2.1 82.594 2.1 82.594"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10664.5 541.168 59.9-136.568s12.5 53.037 1.8 82.137c-10.7 29.099-61.7 54.431-61.7 54.431"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10861.5 1531.34 120.9 29.39s-28.5-35.05-53.2-42.69-67.7 13.3-67.7 13.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10861 1531.49 120.7 30.12s-41.9 17.71-67.3 13-53.4-43.12-53.4-43.12"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10679 560.046-172-9.989s47.6 40.648 83.2 44.914c35.5 4.265 88.8-34.925 88.8-34.925"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10679.7 559.694-171.9-11.018s52.6-34.524 88.4-34.431 83.5 45.449 83.5 45.449"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10602.8 479.369 33.4-145.352s-41.6 34.779-50.3 64.492c-8.8 29.712 16.9 80.86 16.9 80.86"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10603 480.042 34.3-145.145s21.9 49.91 16.6 80.462-50.9 64.683-50.9 64.683"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m10645.8 1039.41-39.2-128.121s-16.8 45.737-10.3 72.803c6.5 27.068 49.5 55.318 49.5 55.318"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10646.3 1039.84-38.5-128.341s39.4 29.029 49.1 55.168c9.6 26.138-10.6 73.173-10.6 73.173"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10612 458.905-164.9-49.592s36.9 50.586 70.5 62.973c33.5 12.388 94.4-13.381 94.4-13.381"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10612.8 458.736-164.6-50.577s59.2-21.383 94-12.99 70.6 63.567 70.6 63.567"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11001.1 1562.61 45 166.25s23.5-58.06 16.3-93.11c-7.3-35.05-61.3-73.14-61.3-73.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11000.5 1562.03 44.1 166.51s-49.5-38.95-60.7-72.93c-11.3-33.99 16.6-93.58 16.6-93.58"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11110.2 1657.63-114.1-96.08s54.2 2.79 79 21.26c24.9 18.47 35.1 74.82 35.1 74.82"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11110.4 1658.29-114.6-95.4s12.5 53.03 35.1 74.28c22.6 21.26 79.5 21.12 79.5 21.12"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10873 1642.19-124.4.39s36.1 27.2 61.9 28.71c25.8 1.5 62.5-29.1 62.5-29.1"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10873.5 1641.9-124.4-.36s36.4-27.21 62.2-28.72 62.2 29.08 62.2 29.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10548.3 1222.58 117.6 125.81s-6.5-62.28-29.2-89.87c-22.8-27.59-88.4-35.94-88.4-35.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10547.5 1222.33 116.9 126.51s-61.9-11.28-87.8-36.03c-25.9-24.76-29.1-90.48-29.1-90.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10445.5 845.811-66.9-101.805s-2.9 44.192 9.6 66.155c12.6 21.963 57.3 35.65 57.3 35.65"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10446 846.071-66.3-102.2s41.8 15.282 56.9 35.641 9.4 66.559 9.4 66.559"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10846.1 1748.24 10.3-123.98s24.2 38.2 23.7 64.03c-.6 25.84-34 59.95-34 59.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10845.7 1748.73 9.6-124.04s-30 34.11-33.6 59.72c-3.6 25.62 24 64.32 24 64.32"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10273.5 2168.01 90.7-90.69s-46.2 6.36-66.2 24c-19.9 17.65-24.5 66.69-24.5 66.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10273.3 2168.59 91.3-90.14s-6.9 46.36-24.7 66.22c-17.8 19.87-66.6 23.92-66.6 23.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10512.3 2241.86-81.5-151.7s56.9 26.04 75.8 56.46c18.8 30.42 5.7 95.24 5.7 95.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10512.3 2242.67-82.5-151.21s-9.1 62.26 6.1 94.69c15.2 32.42 76.4 56.52 76.4 56.52"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10363.7 2083.75-153.5-78.12s27.3 56.34 58.2 74.49c30.8 18.16 95.3 3.63 95.3 3.63"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10364.5 2083.72-153-79.04s62-10.52 94.8 3.93c32.8 14.44 58.2 75.11 58.2 75.11"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M12072.4 1665.12c-25.8 1.94-45.5 20.81-43.9 42.15 1.6 21.33 23.9 37.05 49.7 35.11 25.9-1.95 45.6-20.82 44-42.15-1.6-21.34-23.9-37.06-49.8-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M12039.5 1721.56s-8.8-21.78.9-30.73c12.6-11.64 29.2-2.14 29.2-2.14-8.3 1.38-17.9 1.64-22.7 7.25-5.3 6.15-5.5 17.93-7.4 25.62"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M12070.4 1716.4s9.8 3.26 10.5 4.29c4.2 6.76 5.9 8.23 5.9 8.23s-9.7 3.33-14.2 2.73c-4.6-.6-9.5-3.83-9.5-3.83s.1 5.32-1.1 7.15c-1.5 2.18-7.9 5.94-7.9 5.94s-5.7-4.3-6.8-7.15c-1.2-2.93 5-9.06 5-9.06s-5.7.76-9-1.01c-3.5-1.84-8.1-7.53-8.1-7.53s4.6-3.71 7.9-4.14c3.2-.4 12.7 1.56 12.7 1.56s-6.4-4.65-8.5-8.08c-2.2-3.58 4.5-9.51 4.5-9.51s7.1 4.08 10.4 7.32c2.6 2.48.5 8.3.5 8.3s2.7-6.01 5.8-8.1c3.1-2.1 11.1-1.57 11.1-1.57s2.5 7.31.7 10.2c-1.6 2.74-9.9 4.26-9.9 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M12061.7 1727.4c1.4-.1 3.8.3 4.7-.38 1-.69 2.2-2.85 2.4-4.11.8-3.3.7-5.7-2.5-7.94-1.2-.8-3.4-.04-4.6.05-.7.05-1.5 0-2.1.16-2.5.59-4.4 2.37-6 4.03-.6.67-1.2 2.17-.6 3.03.5.77 1.4 1.48 1.9 2.31.7 1.11 1.8 3.35 3.4 3.86 1 .34 1.4-.43 2.1-.69.8-.27.4-.05 1.3-.32"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M10860.6 1601.13c-22.1 1.67-39 17.82-37.6 36.08s20.4 31.71 42.6 30.04c22.1-1.66 38.9-17.81 37.6-36.07-1.4-18.26-20.5-31.71-42.6-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10832.4 1649.44s-7.5-18.63.8-26.3c10.7-9.96 25-1.83 25-1.83-7.2 1.18-15.3 1.4-19.4 6.21-4.6 5.26-4.8 15.34-6.4 21.92"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M10858.9 1645.03s8.4 2.78 8.9 3.67c3.7 5.79 5.1 7.04 5.1 7.04s-8.3 2.85-12.2 2.34c-3.9-.52-8.1-3.28-8.1-3.28s.1 4.55-.9 6.12c-1.3 1.87-6.8 5.08-6.8 5.08s-4.9-3.68-5.8-6.11c-1-2.51 4.2-7.76 4.2-7.76s-4.8.65-7.6-.86c-3-1.58-7-6.44-7-6.44s3.9-3.18 6.8-3.55c2.8-.35 10.9 1.33 10.9 1.33s-5.5-3.98-7.3-6.92c-1.9-3.05 3.8-8.13 3.8-8.13s6.1 3.49 9 6.27c2.2 2.12.3 7.1.3 7.1s2.4-5.15 5-6.94 9.5-1.34 9.5-1.34 2.2 6.25.7 8.73c-1.5 2.35-8.5 3.65-8.5 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M10851.4 1654.44c1.2-.09 3.3.26 4.1-.32.8-.59 1.8-2.45 2-3.52.7-2.83.6-4.88-2.1-6.8-1.1-.69-3-.03-4 .05-.6.04-1.3 0-1.8.13-2.1.51-3.8 2.03-5.1 3.45-.6.57-1 1.85-.5 2.59.4.66 1.2 1.27 1.6 1.98.6.95 1.5 2.87 2.9 3.3.9.29 1.2-.37 1.8-.58.7-.24.3-.05 1.1-.28"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M10955.2 1589.97c-25.9 1.95-45.6 20.82-44 42.15 1.6 21.34 23.9 37.06 49.8 35.11 25.8-1.94 45.5-20.81 43.9-42.15-1.6-21.33-23.9-37.05-49.7-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10922.3 1646.42s-8.8-21.77.8-30.73c12.6-11.63 29.2-2.14 29.2-2.14-8.3 1.38-17.8 1.64-22.7 7.25-5.2 6.16-5.5 17.93-7.3 25.62"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M10953.2 1641.26s9.8 3.25 10.4 4.29c4.3 6.76 5.9 8.23 5.9 8.23s-9.6 3.33-14.2 2.73c-4.6-.61-9.5-3.84-9.5-3.84s.2 5.33-1.1 7.16c-1.5 2.18-7.9 5.93-7.9 5.93s-5.7-4.29-6.8-7.14c-1.2-2.93 5-9.06 5-9.06s-5.6.76-9-1.01c-3.4-1.84-8.1-7.53-8.1-7.53s4.6-3.71 8-4.14c3.2-.41 12.6 1.56 12.6 1.56s-6.3-4.65-8.4-8.09c-2.2-3.57 4.4-9.5 4.4-9.5s7.1 4.08 10.5 7.32c2.5 2.48.4 8.3.4 8.3s2.7-6.01 5.8-8.11c3.1-2.09 11.1-1.56 11.1-1.56s2.5 7.3.8 10.2c-1.7 2.74-9.9 4.26-9.9 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M10944.4 1652.26c1.4-.11 3.8.29 4.8-.39.9-.68 2.1-2.85 2.4-4.1.7-3.31.7-5.7-2.6-7.95-1.1-.8-3.4-.04-4.6.05-.6.06-1.5 0-2.1.16-2.5.6-4.4 2.38-6 4.03-.6.67-1.2 2.17-.6 3.03.6.77 1.5 1.48 2 2.32.6 1.1 1.7 3.35 3.3 3.85 1.1.34 1.4-.43 2.2-.69.7-.27.3-.05 1.2-.31"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M10986.4 1465.54c-22.1 1.67-39 17.82-37.6 36.08s20.5 31.71 42.6 30.04c22.1-1.66 39-17.81 37.6-36.07s-20.4-31.71-42.6-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10958.3 1513.85s-7.6-18.64.7-26.3c10.8-9.96 25-1.84 25-1.84-7.1 1.19-15.3 1.41-19.4 6.21-4.5 5.27-4.8 15.35-6.3 21.93"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M10984.7 1509.44s8.4 2.78 9 3.67c3.6 5.79 5 7.04 5 7.04s-8.3 2.85-12.2 2.34c-3.9-.52-8.1-3.28-8.1-3.28s.2 4.55-.9 6.12c-1.3 1.87-6.8 5.08-6.8 5.08s-4.9-3.68-5.8-6.11c-1-2.51 4.3-7.76 4.3-7.76s-4.9.65-7.7-.86c-3-1.58-7-6.44-7-6.44s4-3.18 6.8-3.55c2.8-.35 10.9 1.33 10.9 1.33s-5.5-3.98-7.3-6.92c-1.8-3.05 3.8-8.13 3.8-8.13s6.1 3.49 9 6.27c2.2 2.12.4 7.1.4 7.1s2.3-5.15 4.9-6.94c2.7-1.79 9.6-1.34 9.6-1.34s2.1 6.25.6 8.73c-1.5 2.35-8.5 3.65-8.5 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M10977.2 1518.85c1.2-.09 3.3.26 4.1-.33.8-.58 1.8-2.44 2-3.51.7-2.83.6-4.88-2.1-6.8-1-.69-2.9-.03-4 .04-.5.05-1.2 0-1.8.14-2.1.51-3.7 2.03-5.1 3.45-.5.57-1 1.85-.5 2.59.5.66 1.2 1.27 1.6 1.98.6.95 1.5 2.87 2.9 3.3.9.29 1.2-.37 1.9-.59.6-.23.2-.04 1-.27"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12082.6 2183.16-44.2-116.3s-12.7 43.39-5.1 68.07c7.7 24.68 49.3 48.23 49.3 48.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12083 2183.54-43.5-116.56s38.3 24.49 48.8 48.12-5.3 68.44-5.3 68.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10458.5 1966.88 36.5 116.25s14.9-41.69 8.9-66.26c-6.1-24.56-45.4-49.99-45.4-49.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10458.1 1966.49 35.8 116.46s-36-26.15-45-49.86c-8.9-23.71 9.2-66.6 9.2-66.6"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11008.7 2259.06-112.6 61.4s46.1 6.94 70.2-4.36c24.2-11.29 42.4-57.04 42.4-57.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11009 2258.55-113 60.72s19.7-42.54 42.4-56.58c22.6-14.04 70.6-4.14 70.6-4.14"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10690.3 2150.75-112.7 61.39s46.2 6.94 70.3-4.35 42.4-57.04 42.4-57.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10690.6 2150.24-113 60.72s19.7-42.54 42.3-56.58c22.7-14.04 70.7-4.14 70.7-4.14"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11054.5 2254.87 158.1-68.49s-60.9-14.85-94.5-2.67c-33.7 12.19-63.6 71.16-63.6 71.16"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11054 2255.51 158.5-67.53s-31.5 54.51-63.5 70.54-95-3.01-95-3.01"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11032.2 2136.96 34.6 116.82s15.6-41.45 9.9-66.11-44.5-50.71-44.5-50.71"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11031.8 2136.56 33.8 117.02s-35.5-26.73-44.1-50.58c-8.5-23.85 10.3-66.44 10.3-66.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10983.6 2255.27 56.7 162.65s19.2-59.58 9.6-94.03c-9.7-34.45-66.3-68.62-66.3-68.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10983 2254.73 55.7 162.98s-52.1-35.35-65.7-68.46c-13.7-33.1 10-94.52 10-94.52"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10845 2182.94-97.4 142.06s59.4-19.78 81.5-47.99c22-28.22 15.9-94.07 15.9-94.07"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10845.1 2182.12-98.2 141.48s-2.4-62.88 16.2-93.49c18.5-30.61 82-47.99 82-47.99"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10885.5 2159.15 125-81.41s-54.1-3.85-81 11.44c-27 15.28-44 69.97-44 69.97"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10885.2 2159.77 125.5-80.66s-19 51.09-44 69.43-81.5 11.23-81.5 11.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11139.5 2354.04 73.1 100.68s.9-45.22-13-67.03c-13.8-21.81-60.1-33.65-60.1-33.65"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11139 2353.79 72.4 101.11s-43.3-13.61-59.7-33.66c-16.3-20.05-12.7-67.45-12.7-67.45"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10683.6 2128.83 15.4 171.55s33.2-53.1 32.2-88.87-47.6-82.68-47.6-82.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10683.1 2128.16 14.5 171.63s-41.9-46.94-47.1-82.37 32.6-89.26 32.6-89.26"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10672.1 2130.06 27.2-121.4s-34.5 29.2-41.7 54.03c-7.2 24.82 14.5 67.37 14.5 67.37"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10672.3 2130.62 27.9-121.23s18.5 41.53 14.2 67.04c-4.2 25.51-42.1 54.19-42.1 54.19"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11139.6 2354.33-12.3 127.69s31.6-34.29 35.7-60.61c4.2-26.32-23.4-67.08-23.4-67.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11139.3 2353.78-13.1 127.6s-24.1-40.13-23.1-66.78c1.1-26.64 36.2-60.82 36.2-60.82"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10889.2 2166.29 9.1-124.07s-29.8 33.94-33.3 59.56c-3.5 25.61 24.2 64.51 24.2 64.51"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10889.5 2166.82 9.8-124.01s24.4 38.38 23.9 64.23c-.5 25.86-33.7 59.78-33.7 59.78"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m12226.5 2124.8-44.2-116.3s-12.7 43.39-5 68.07 49.2 48.23 49.2 48.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m12227 2125.18-43.5-116.56s38.3 24.49 48.8 48.12-5.3 68.44-5.3 68.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11553.5 433.964-79.6-92.199s43.3 9.23 61 27.331c17.7 18.102 18.6 64.868 18.6 64.868"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11553.7 434.525-80.2-91.718s3.3 44.388 18.7 64.441c15.5 20.053 61.5 27.277 61.5 27.277"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11401 704.194-111.5 63.442s18.4-42.863 40.7-57.44 70.8-6.002 70.8-6.002"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11401.6 704.184-111.1 64.106s46.5 5.677 70.4-6.206 40.7-57.9 40.7-57.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11227.6 966.637-111.5 63.443s18.4-42.863 40.7-57.44 70.8-6.003 70.8-6.003"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11228.2 966.633-111.1 64.107s46.5 5.68 70.4-6.21c23.9-11.88 40.7-57.897 40.7-57.897"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11372.7 530.842 114.1-128.998s-4.7 62.439-26.7 90.643c-22.1 28.203-87.4 38.355-87.4 38.355"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11371.9 531.116 113.4-129.675s-61.6 12.973-86.8 38.432c-25.1 25.459-26.6 91.243-26.6 91.243"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11485.5 713.435-41.2-114.645s37.1 24.167 47.1 47.413-5.9 67.232-5.9 67.232"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11485.4 714-41.9-114.393s-12.9 42.605-5.6 66.874c7.2 24.269 47.5 47.519 47.5 47.519"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11275.4 341.187-57.3-107.527s40.2 18.58 53.5 40.146c13.2 21.565 3.8 67.381 3.8 67.381"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m11275.4 341.762-57.9-107.18s-6.6 44.013 4 66.99c10.7 22.977 53.9 40.19 53.9 40.19"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11400.8 709.003-108.4-133.832s60.8 14.972 85 41.338c24.2 26.367 23.4 92.494 23.4 92.494"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11401 709.799-109.3-133.177s2.7 62.87 23.7 91.896c20.9 29.025 85.6 41.281 85.6 41.281"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11418.6 883.404-172.1 8.021s48.1-40.1 83.7-43.959c35.5-3.858 88.4 35.938 88.4 35.938"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11419.3 883.768-172 9.051s52.2 35.123 88 35.44c35.8.316 84-44.491 84-44.491"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11333.6 1110.23 135-63.39s-25.2 48.01-52.4 62.88c-27.2 14.86-82.6.51-82.6.51"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m11332.9 1110.19 134.6-64.2s-53.4-10.81-82.1.79c-28.8 11.6-52.5 63.41-52.5 63.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11387.4 386.212 45.4-115.828s12.2 43.53 4.3 68.126-49.7 47.702-49.7 47.702"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11386.9 386.588 44.7-116.094s-38.5 24.083-49.3 47.6c-10.7 23.517 4.6 68.494 4.6 68.494"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11331.5 1093.25-49.4-165.006s50.5 36.958 62.9 70.54c12.3 33.586-13.5 94.466-13.5 94.466"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11331.3 1094.04-50.4-164.7s-21.4 59.161-13.1 93.98c8.4 34.81 63.5 70.72 63.5 70.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11333.3 1115.27 117.5 40.76s-43 14-67.9 7.04c-24.9-6.95-49.6-47.8-49.6-47.8"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11332.9 1114.83 117.8 40.07s-25.6-37.56-49.5-47.38c-24-9.81-68.3 7.31-68.3 7.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11483 576.62-115-56.738s45.8-8.82 70.4 1.477c24.5 10.296 44.6 55.261 44.6 55.261"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11483.4 577.114-115.4-56.046s21.4 41.701 44.6 54.801 70.8 1.245 70.8 1.245"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12795.9 472.44-126-24.119s41.8-20.674 68.3-17.28c26.4 3.394 57.7 41.399 57.7 41.399"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12796.4 472.827-126.1-23.364s31.7 34.517 57.5 40.973c25.9 6.457 68.6-17.609 68.6-17.609"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11136.9 860.253-12 171.827s-34.2-52.425-33.9-88.207 45.9-83.62 45.9-83.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11137.4 859.57-11 171.89s40.9-47.779 45.4-83.303-34.4-88.587-34.4-88.587"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12823.1 684.262 43.1-113.968s12.5 42.477 5.1 66.658c-7.5 24.181-48.2 47.31-48.2 47.31"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12822.7 684.632 42.4-114.221s-37.5 24.048-47.7 47.206c-10.3 23.158 5.3 67.015 5.3 67.015"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12957.3 278.494 12.4-121.198s23.1 37.843 22 63.132c-1 25.289-34.4 58.066-34.4 58.066"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m12957 278.962 11.7-121.267s-30 32.843-34 57.855 22.3 63.412 22.3 63.412"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12792.6 475.953 4.4-172.191s36.6 50.858 37.9 86.618c1.2 35.76-42.3 85.573-42.3 85.573"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12792.2 476.655 3.4-172.209s-38.8 49.546-41.7 85.233 38.3 86.976 38.3 86.976"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12695.9 605.163-136.1-105.589s62.7.716 92.2 20.874c29.6 20.158 43.9 84.715 43.9 84.715"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m12696.2 605.901-136.7-104.769s16.9 60.61 44 84.092c27 23.482 92.7 20.677 92.7 20.677"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12956.3 448.861-50.7-117.843s40.5 23.017 52.5 46.805c12.1 23.789-1.8 71.038-1.8 71.038"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m12956.2 449.461-51.4-117.534s-10.8 45.603-1.6 70.645c9.1 25.042 53 46.889 53 46.889"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11649.6 556.626-115-56.738s45.8-8.82 70.4 1.476c24.5 10.297 44.6 55.262 44.6 55.262"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m11650 557.118-115.4-56.046s21.4 41.701 44.6 54.801 70.8 1.245 70.8 1.245"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11173 436.956-168.1 37.598s40.5-47.8 74.8-57.74c34.4-9.941 93.3 20.142 93.3 20.142"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11173.8 437.184-167.9 38.602s57.5 25.585 92.8 19.718 75.1-58.32 75.1-58.32"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11671.8 629.64-172.1 4.565s48.9-39.127 84.5-42.27 87.6 37.705 87.6 37.705"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m11672.6 630.017-172.2 5.595s51.5 36.165 87.3 37.2 84.9-42.795 84.9-42.795"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m11554.8 925.884-154 4.085s43.7-35.013 75.6-37.826 78.4 33.741 78.4 33.741"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m11555.5 926.219-154.1 5.006s46.1 32.363 78.1 33.29c32.1.926 76-38.296 76-38.296"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11419.6 932.666 110.3 57.553s-44.6 7.54-68.2-2.987-42.1-54.566-42.1-54.566"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11419.3 932.18 110.6 56.891s-19.8-40.904-42-54.119-68.6-2.772-68.6-2.772"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m11491.9 718.508 110.3 57.553s-44.6 7.54-68.2-2.987-42.1-54.566-42.1-54.566"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m11491.6 718.02 110.6 56.891s-19.8-40.904-42-54.119c-22.3-13.216-68.6-2.772-68.6-2.772"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M11748 533.485c-25.9 1.944-45.5 20.815-43.9 42.15s23.8 37.054 49.7 35.11 45.5-20.815 43.9-42.15-23.8-37.054-49.7-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11715.1 589.934s-8.8-21.777.9-30.73c12.5-11.637 29.2-2.143 29.2-2.143-8.4 1.379-17.9 1.638-22.7 7.255-5.3 6.151-5.6 17.928-7.4 25.618"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M11746 584.77s9.8 3.256 10.5 4.292c4.2 6.761 5.9 8.23 5.9 8.23s-9.7 3.33-14.3 2.727c-4.5-.602-9.5-3.833-9.5-3.833s.2 5.323-1 7.156c-1.5 2.181-7.9 5.932-7.9 5.932s-5.7-4.294-6.9-7.141c-1.1-2.931 5-9.06 5-9.06s-5.6.758-8.9-1.011c-3.5-1.843-8.2-7.528-8.2-7.528s4.6-3.714 8-4.14c3.2-.409 12.7 1.553 12.7 1.553s-6.4-4.648-8.5-8.081c-2.2-3.573 4.4-9.502 4.4-9.502s7.2 4.075 10.5 7.318c2.6 2.48.4 8.298.4 8.298s2.8-6.01 5.9-8.104c3-2.093 11.1-1.565 11.1-1.565s2.5 7.304.7 10.196c-1.7 2.744-9.9 4.263-9.9 4.263"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M11737.3 595.769c1.4-.104 3.8.296 4.7-.383 1-.687 2.1-2.853 2.4-4.109.8-3.306.7-5.698-2.5-7.944-1.2-.802-3.4-.038-4.6.054-.7.05-1.5 0-2.2.159-2.5.592-4.4 2.372-5.9 4.025-.7.67-1.2 2.17-.6 3.031.5.769 1.4 1.479 1.9 2.317.6 1.106 1.7 3.35 3.3 3.854 1.1.339 1.5-.432 2.2-.686.8-.271.3-.053 1.3-.318"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11801.9 464.999c24.3-2.704 42.2-21.165 40-41.235s-23.8-34.149-48.1-31.445-42.3 21.166-40 41.236c2.2 20.07 23.7 34.148 48.1 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11801 415.45s-9.3-2.741-10-3.696c-4.2-6.234-5.9-7.564-5.9-7.564s9.1-3.467 13.4-3.052 9.1 3.296 9.1 3.296-.4-5.015.8-6.786c1.3-2.108 7.2-5.861 7.2-5.861s5.5 3.858 6.7 6.506c1.2 2.726-4.4 8.715-4.4 8.715s5.3-.905 8.5.651c3.3 1.622 7.9 6.827 7.9 6.827s-4.2 3.658-7.4 4.174c-3 .493-12-1.039-12-1.039s6.2 4.17 8.3 7.338c2.2 3.296-3.9 9.111-3.9 9.111s-6.9-3.603-10.1-6.55c-2.5-2.253-.7-7.812-.7-7.812s-2.4 5.761-5.2 7.839c-2.9 2.078-10.5 1.85-10.5 1.85s-2.6-6.804-1-9.592c1.5-2.646 9.2-4.355 9.2-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11790.8 454.809s-22.1 1.512-27.4-9.785c-6.7-14.669 6.7-26.825 6.7-26.825-1.2 7.896-3.8 16.504-.2 22.483 4 6.539 14.5 10.233 20.9 14.127"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11809.9 405.884c-1.3.145-3.6-.152-4.5.521-.9.68-1.9 2.762-2.1 3.956-.6 3.144-.5 5.399 2.7 7.409 1.1.716 3.2-.079 4.3-.206.6-.07 1.4-.05 2-.222 2.3-.642 4.1-2.385 5.5-3.997.6-.654 1.1-2.088.5-2.88-.6-.707-1.4-1.347-1.9-2.121-.7-1.021-1.8-3.1-3.3-3.522-1-.285-1.4.455-2 .72-.7.281-.3.06-1.2.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11752.2 886.214c24.4-2.704 42.3-21.166 40.1-41.236-2.3-20.07-23.8-34.148-48.1-31.444-24.4 2.704-42.3 21.166-40 41.236 2.2 20.07 23.7 34.148 48 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11751.4 836.665s-9.4-2.741-10-3.696c-4.3-6.235-5.9-7.564-5.9-7.564s9-3.467 13.4-3.052c4.3.415 9.1 3.296 9.1 3.296s-.4-5.015.7-6.786c1.4-2.108 7.3-5.861 7.3-5.861s5.5 3.858 6.7 6.506c1.1 2.726-4.5 8.715-4.5 8.715s5.3-.905 8.5.651c3.4 1.622 8 6.827 8 6.827s-4.2 3.658-7.4 4.173c-3 .494-12-1.038-12-1.038s6.1 4.17 8.2 7.338c2.2 3.296-3.8 9.111-3.8 9.111s-6.9-3.603-10.1-6.55c-2.5-2.253-.7-7.812-.7-7.812s-2.4 5.761-5.2 7.839c-2.9 2.078-10.5 1.85-10.5 1.85s-2.6-6.804-1-9.592c1.5-2.646 9.2-4.355 9.2-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11741.1 876.024s-22.1 1.512-27.3-9.785c-6.7-14.669 6.6-26.825 6.6-26.825-1.2 7.896-3.7 16.504-.1 22.483 4 6.539 14.5 10.233 20.8 14.127"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11760.3 827.099c-1.3.145-3.6-.152-4.5.52-.9.681-1.9 2.763-2.1 3.957-.6 3.144-.5 5.399 2.6 7.409 1.2.716 3.2-.08 4.4-.207.6-.069 1.4-.049 2-.221 2.3-.643 4.1-2.385 5.5-3.998.6-.653 1-2.087.5-2.879-.6-.707-1.5-1.347-1.9-2.121-.7-1.021-1.8-3.1-3.3-3.522-1-.285-1.4.455-2 .72-.8.281-.3.06-1.2.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M10980.4 581.337c-25.9 1.944-45.5 20.815-43.9 42.149 1.6 21.335 23.8 37.054 49.7 35.11s45.5-20.815 43.9-42.149c-1.6-21.335-23.8-37.054-49.7-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10947.5 637.789s-8.8-21.777.9-30.729c12.5-11.638 29.2-2.144 29.2-2.144-8.4 1.379-17.9 1.639-22.7 7.255-5.3 6.151-5.6 17.928-7.4 25.618"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M10978.4 632.624s9.8 3.255 10.5 4.292c4.2 6.761 5.9 8.229 5.9 8.229s-9.7 3.33-14.3 2.728c-4.5-.603-9.5-3.833-9.5-3.833s.2 5.323-1 7.155c-1.5 2.182-7.9 5.933-7.9 5.933s-5.8-4.294-6.9-7.142c-1.1-2.931 5-9.06 5-9.06s-5.6.759-8.9-1.01c-3.5-1.843-8.2-7.528-8.2-7.528s4.6-3.715 8-4.141c3.2-.408 12.7 1.554 12.7 1.554s-6.4-4.648-8.5-8.082c-2.2-3.572 4.4-9.502 4.4-9.502s7.2 4.076 10.5 7.318c2.6 2.481.4 8.298.4 8.298s2.8-6.009 5.9-8.103c3-2.094 11.1-1.566 11.1-1.566s2.5 7.304.7 10.196c-1.7 2.745-9.9 4.264-9.9 4.264"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M10969.7 643.624c1.4-.104 3.8.297 4.7-.382 1-.688 2.1-2.854 2.4-4.109.8-3.306.7-5.699-2.5-7.945-1.2-.802-3.4-.037-4.6.054-.7.05-1.5 0-2.2.16-2.5.591-4.4 2.371-5.9 4.025-.7.67-1.2 2.169-.6 3.03.5.769 1.4 1.48 1.9 2.318.6 1.105 1.7 3.349 3.3 3.853 1.1.339 1.5-.431 2.2-.686.8-.271.3-.052 1.3-.318"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11212 535.995c24.3-2.704 42.3-21.165 40-41.235-2.2-20.07-23.7-34.148-48.1-31.445-24.3 2.704-42.2 21.166-40 41.236s23.8 34.148 48.1 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11211.2 486.446s-9.4-2.741-10.1-3.696c-4.2-6.234-5.8-7.563-5.8-7.563s9-3.468 13.3-3.053c4.4.415 9.1 3.296 9.1 3.296s-.3-5.015.8-6.786c1.3-2.107 7.2-5.861 7.2-5.861s5.6 3.858 6.7 6.507c1.2 2.726-4.4 8.714-4.4 8.714s5.3-.905 8.5.651c3.3 1.622 7.9 6.827 7.9 6.827s-4.2 3.658-7.3 4.174c-3.1.493-12.1-1.039-12.1-1.039s6.2 4.17 8.3 7.338c2.2 3.296-3.8 9.111-3.8 9.111s-6.9-3.603-10.2-6.549c-2.5-2.254-.7-7.813-.7-7.813s-2.4 5.761-5.2 7.839-10.4 1.85-10.4 1.85-2.6-6.804-1.1-9.592c1.5-2.646 9.3-4.355 9.3-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11200.9 525.803s-22.1 1.513-27.3-9.785c-6.8-14.669 6.6-26.825 6.6-26.825-1.2 7.896-3.7 16.504-.1 22.484 4 6.538 14.4 10.232 20.8 14.126"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11220 476.88c-1.3.145-3.6-.152-4.4.521-.9.68-1.9 2.762-2.1 3.956-.7 3.144-.5 5.399 2.6 7.409 1.1.716 3.2-.079 4.3-.206.7-.07 1.4-.05 2-.222 2.4-.642 4.1-2.385 5.5-3.997.6-.654 1.1-2.088.5-2.88-.5-.707-1.4-1.347-1.9-2.121-.6-1.021-1.8-3.1-3.3-3.522-1-.285-1.3.456-2 .72-.7.281-.3.06-1.2.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M11066.7 884.247c24.3-2.704 42.2-21.165 40-41.235s-23.8-34.148-48.1-31.445-42.2 21.166-40 41.236 23.8 34.148 48.1 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M11065.8 834.698s-9.3-2.741-10-3.696c-4.2-6.234-5.8-7.564-5.8-7.564s9-3.467 13.3-3.052 9.1 3.296 9.1 3.296-.3-5.015.8-6.786c1.3-2.107 7.2-5.861 7.2-5.861s5.5 3.858 6.7 6.507c1.2 2.725-4.4 8.714-4.4 8.714s5.3-.905 8.5.651c3.3 1.622 7.9 6.827 7.9 6.827s-4.2 3.658-7.4 4.174c-3 .493-12-1.039-12-1.039s6.2 4.17 8.3 7.338c2.2 3.296-3.9 9.111-3.9 9.111s-6.8-3.603-10.1-6.549c-2.5-2.254-.7-7.813-.7-7.813s-2.4 5.761-5.2 7.839-10.4 1.85-10.4 1.85-2.6-6.804-1.1-9.592c1.5-2.646 9.2-4.355 9.2-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11055.6 874.057s-22.1 1.512-27.3-9.785c-6.8-14.669 6.6-26.825 6.6-26.825-1.2 7.896-3.8 16.504-.1 22.483 3.9 6.539 14.4 10.233 20.8 14.127"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M11074.7 825.134c-1.3.145-3.6-.152-4.4.521-.9.68-1.9 2.762-2.2 3.956-.6 3.144-.4 5.399 2.7 7.409 1.1.716 3.2-.079 4.3-.206.7-.07 1.4-.05 2-.222 2.4-.642 4.1-2.385 5.5-3.997.6-.654 1.1-2.088.5-2.88-.5-.707-1.4-1.347-1.9-2.121-.7-1.021-1.8-3.1-3.3-3.522-1-.285-1.3.455-2 .72-.7.281-.3.06-1.2.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M10994.8 526.438c21.4-2.382 37.2-18.451 35.3-35.892-2-17.44-20.9-29.647-42.3-27.265-21.5 2.382-37.3 18.451-35.3 35.891 1.9 17.44 20.8 29.647 42.3 27.266"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M10994.1 483.371s-8.3-2.37-8.8-3.199c-3.8-5.413-5.2-6.566-5.2-6.566s8-3.025 11.8-2.67 8 2.853 8 2.853-.3-4.359.7-5.899c1.2-1.834 6.4-5.104 6.4-5.104s4.8 3.346 5.8 5.646c1.1 2.368-3.9 7.58-3.9 7.58s4.7-.794 7.5.555c3 1.405 7 5.923 7 5.923s-3.7 3.185-6.5 3.637c-2.7.433-10.6-.887-10.6-.887s5.4 3.616 7.3 6.366c1.9 2.862-3.4 7.924-3.4 7.924s-6.1-3.123-8.9-5.679c-2.2-1.955-.6-6.789-.6-6.789s-2.1 5.01-4.6 6.82-9.2 1.622-9.2 1.622-2.3-5.911-.9-8.336c1.3-2.301 8.1-3.797 8.1-3.797"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M10985 517.594s-19.5 1.344-24-8.468c-6-12.74 5.8-23.323 5.8-23.323-1 6.864-3.3 14.349-.1 19.541 3.5 5.678 12.7 8.874 18.3 12.25"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M11001.9 475.048c-1.1.127-3.1-.128-3.9.458-.8.593-1.7 2.403-1.9 3.441-.5 2.734-.4 4.693 2.3 6.436 1 .621 2.9-.073 3.9-.185.5-.062 1.2-.045 1.7-.196 2.1-.561 3.6-2.078 4.9-3.481.5-.568.9-1.815.4-2.503-.5-.614-1.2-1.169-1.7-1.841-.5-.886-1.5-2.692-2.9-3.057-.8-.246-1.1.398-1.7.629-.7.245-.3.052-1.1.299"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M11874 746.09c15.4-15.154 17.8-37.56 5.5-50.046s-34.8-10.321-50.1 4.833-17.8 37.561-5.5 50.046c12.4 12.485 34.8 10.322 50.1-4.833"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M11846.8 712.716s-7.9 3.248-8.9 2.954c-6.3-1.937-8.1-1.954-8.1-1.954s4.4-7.311 7.6-9.393 8-2.718 8-2.718-2.9-3.236-3.1-5.059c-.2-2.17 1.9-7.96 1.9-7.96s5.9-.394 8.1.784c2.3 1.211 1.6 8.372 1.6 8.372s3.2-3.519 6.2-4.211c3.2-.709 9.2.325 9.2.325s-1 4.802-2.9 6.887c-1.8 1.988-8.8 5.861-8.8 5.861s6.5-.52 9.6.49c3.3 1.053 2.3 8.325 2.3 8.325s-6.7 1.307-10.6 1.078c-2.9-.177-4.6-4.963-4.6-4.963s1.4 5.241.6 8.207c-.8 2.965-6.2 6.964-6.2 6.964s-5.5-3.212-5.9-5.981c-.4-2.626 4-8.008 4-8.008"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M11860.9 745.203s-14.4 13.127-24.1 8.259c-12.6-6.313-9.9-21.936-9.9-21.936 3.4 6.051 6.3 13.323 12 15.422 6.3 2.291 15.5-.923 22-1.745"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M11847.8 701.333c-.8.812-2.6 1.858-2.8 2.793-.2.949.2 2.922.7 3.86 1.2 2.482 2.5 3.948 5.8 3.611 1.2-.133 2.2-1.805 2.9-2.517.4-.391.9-.798 1.2-1.243 1.3-1.719 1.6-3.855 1.7-5.732 0-.763-.4-2.012-1.2-2.228-.8-.19-1.7-.151-2.5-.41-1-.341-2.9-1.153-4.2-.614-.8.358-.6 1.051-1 1.598-.3.586-.1.207-.6.882"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M11257 3037.57s-259.8 359.51-425.1 505.53c-168.7 149-633.3 138.35-633.3 138.35s488.5 19.51 657.2-114.41c155.6-123.5 403.1-439.01 403.1-439.01s-124.6 420.66-232.6 609.3c-108.4 189.36-854.3 513.51-854.3 513.51s765.9-291.35 879.4-478.92c113.5-187.58 238.1-633.24 238.1-633.24s-101.1 495.87-146 715.82c-41.1 201.28-352 792.78-352 792.78s385.4-680.39 428.1-870.04c49.7-220.84 99.2-643.89 99.2-643.89s62.1 560.08 71.8 790.22c8.4 196.76-5.3 332.59-5.3 332.59s40.7-145.81 37.3-348.55c-4-231.93-69.2-784.9-69.2-784.9s116.2 548.98 157 779.58c35.4 200.32 484.2 752.97 484.2 752.97s-406.1-560.55-436.4-763.61c-35-235.47-170.2-798.21-170.2-798.21s324.5 441.68 394.2 662.51c62 196.94 513.1 454.98 513.1 454.98s-432.9-284-489.6-478.92c-67-230.15-398.7-694.44-398.7-694.44z"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M10890.1 3512.18c-68.7-20.59-50.2-50.82-120.1-62.47-52.5-8.76-166-17.14-216.2-17.14-30.9 0-138-12.34-152.5-16.49-10.9-3.14-270.8 61.99-263.1 54.27 30-29.95 244.4-84.98 285.1-83.14 78.2 3.56 158.6 6.62 234.2 23.44 48.3 10.72 101.9 1.04 149.9 11.71 21.2 4.71 73.9 23.6 89 38.63 1.6 1.65 16 17.56 17.5 17.56M10856.6 3907.08c-26.7-5.32-51.1-17.75-77.3-24.59-33.1-8.62-68.2-7.1-100.7-15.22-55.3-13.83-108.2-17.56-166.3-17.56-41 0-81.9 5.86-121.7 5.86-12.7 0-30.5 4.68-42.2 9.36-5.4 2.18-17.6 0-17.6 0s4.7-1.57 7.1-2.34c9.8-3.27 21.3-12.96 30.4-15.22 31.3-7.82 59.1-16.47 93.7-21.07 55.4-7.4 213.1-9.26 270.4 3.51 30.4 6.76 156.6 33.21 165.1 50.34 8.3 16.6-19.2 17.56-33.9 17.56-2.3 0-7 11.63-7 9.37M11618.2 3375.18c76.5 0 149.8 17.54 225 23.79 107.8 8.99 216.7 7.32 325.6 7.32 63 0 129.3.5 192.1-5.48 20.5-1.95 41.8-1.39 62.2-3.65 5.9-.66 10.5-1.84 16.5-1.84h11c-47.9 0-91.4 19.11-137.2 29.27-89.3 19.85-245.4 22.3-334.2 6.15-60.6-11.02-136.9 6.7-197-8.3-22.2-5.56-138.4 5.21-141.6 1.99-8.1-8.17-9.4-49.25-22.4-49.25M11815.7 3779.5c79.7 0 196.4 32.03 281.8 42.09 103.3 12.16 183.2-31.1 272.6-31.1 12.1 0 65.4-7.75 113.4-14.64 43.5-6.25-122.1 46.88-153 55.72-105.5 30.12-225.6 19.29-335.5 19.29-31.6 0-151.8 7.63-151.8-23.79M11585.3 3988.07c84.7 36.29 156.5 90.41 241.4 124.39 24.3 9.71 52.5 10.37 76.9 20.14 30.8 12.34 73.9 15.03 102.4 29.27 9.5 4.71 25.3 14.63 36.6 14.63 4.7 0 142.5 48.05 137.9 48.05-12.4 0-259.6-43.02-291.6-59.04-49.2-24.58-110.6-36.8-168.3-51.22-25.8-6.44-108.9-54.89-118.9-54.89M11157.1 3931.34c12.8 57.58 43.3 115.37 54.9 173.8 11.7 58.11.6 148.12 23.5 201.57 53.8 125.51 69.8 106.11 69.8 252.15 0 44.52 58.6 176.83 58.6 221.37v45.71c0 7.96-60.3-153.55-71.4-164.64-6.5-6.52-14.2-79.1-18.3-93.31-10.8-38.05-3.1-102.6-14.3-130.56-15.5-38.69-51.7-103.29-60.7-143.84-18.7-84.15-27.8-166.77-43.9-246.99-2.2-10.93-10.8-69.52-20.1-69.52"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M10385.4 3389.58c-14.3-14.29-32.6-22.03-51.9-30.31-18.1-7.77-37.2-16.09-54.4-32.03-16.2-15.09-31.2-46.03-48.8-68.35-13.1-16.5-27.8-28.26-44.6-28.26-3 0-5.5 2.47-5.5 5.53s2.5 5.54 5.5 5.54c13.8 0 25.2 10.56 35.9 24.08 18 22.75 33.5 54.19 50 69.57 18.2 16.9 38.3 25.86 57.5 34.11 18 7.69 35.1 14.66 48.4 27.94 2.2 2.18 5.7 2.18 7.9 0 2.1-2.16 2.1-5.67 0-7.82M10546.2 3404.45c-10.3-41.11-29.2-61.38-51.8-80.17-14.4-11.97-30.5-23.31-46.6-39.48-6.6-6.57-8.6-19-10.4-31.8-2.2-14.76-3.8-30.06-8.7-39.96-3-6.01-8.2-12.88-12.6-19.96-3.7-5.96-7-12-7-17.8 0-3.06-2.5-5.53-5.5-5.53-3.1 0-5.6 2.47-5.6 5.53 0 6.23 2.5 12.8 6.1 19.27 4.7 8.3 11.1 16.44 14.7 23.46 5.4 10.97 6.1 29.25 9 45.1 2.2 12.22 5.7 23.07 12.1 29.51 16.5 16.47 32.7 28.02 47.4 40.18 21 17.42 38.6 36.21 48.1 74.34.8 2.98 3.8 4.78 6.7 4.04 3-.75 4.8-3.75 4.1-6.73M10479.6 3414.13c-45.2 22.64-92.3 67.69-138.7 100.15-29.7 20.81-59 36.48-87.5 36.48-3.1 0-5.5 2.5-5.5 5.56s2.4 5.53 5.5 5.53c30.5 0 62.1-16.23 93.9-38.5 45.9-32.14 92.4-76.89 137.3-99.29 2.7-1.36 3.8-4.71 2.4-7.43-1.3-2.74-4.7-3.86-7.4-2.5M10681.8 3432.06c-35.4 10.12-61.9 29.01-88.5 49.25-25.7 19.61-51.5 40.5-86 55.27-15.7 6.75-63.4 30.11-126.4 37.01-3.1.32-5.3 3.06-4.9 6.12.3 3.03 3 5.24 6.1 4.89 64.6-7.05 113.5-30.92 129.6-37.83 35.4-15.17 61.9-36.51 88.3-56.62 25.5-19.45 50.9-37.73 84.8-47.42 3-.85 4.7-3.91 3.9-6.86-.9-2.93-4-4.66-6.9-3.81M10749.7 3434.96c-10.1-35.44-27.6-63.43-42.7-92.38-14.5-27.85-26.6-56.64-26.6-94.53 0-9.95-2.1-28.87-8.4-42.41-4.9-10.7-12.6-18.02-22.8-18.02-3 0-5.5 2.48-5.5 5.54s2.5 5.56 5.5 5.56c6.1 0 9.8 5.24 12.8 11.57 5.5 12.06 7.3 28.9 7.3 37.76 0 39.91 12.6 70.29 27.9 99.64 14.7 28.31 31.9 55.64 41.8 90.33.9 2.93 3.9 4.63 6.9 3.81 2.9-.86 4.6-3.92 3.8-6.87"
      clipRule="evenodd"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M10255.2 3302.57c0-11.28-3.9-32.43 1-42.2 3.8-7.63 9.6-16.25 9.6-25.43 0-3.49-3.5-23.02-5.8-23.02M10293.1 3345.25c-21.2 0-43.8-5.69-65.2-2.39-6.1.93-12.5 2.39-18.7 2.39-7.4 0-15.5 4.07-22.1 6.71-1.2.48-15.4 1.35-16.8 0M10323.8 3360.07c6.1-24.42 12.3-38.29 26.4-59.41 10.7-16.13 34.1-25.68 23.9-46.03M10424.5 3213.84c2.7-14.66 7.7-33.1 17.3-45.07 10-12.51 20.9-24.96 25.4-40.76 2-7.03-5.6-16.05-8.2-22.06-.8-1.84-1.4-7.18-3.3-7.18M10445.6 3295.39c-13.3 4.42-24 21.95-35 30.2-2.6 1.97-4.9 6.76-7.7 8.17M10504.6 3339.51c-2.2-14.21-7.2-27.04-9.6-41.24-2.1-12.38 2.5-25.86 4.8-37.41 2.6-13.12 16.1-22.96 20.6-36.45 1.5-4.55 2.2-15.2-2.9-17.75M10688.7 3311.19c4.7-10.88 6.3-27.51 14.9-35.94 10.6-10.4 28.2-17.14 34.5-31.66 3.8-8.7 7.2-29.8 4.4-39.81-1.7-5.8-3.9-12.48-3.9-18.7M10669.1 3234.94c-27 0-59.5 13.7-84-.96-15.3-9.2-19.9-31.45-31.6-44.59-2.6-2.98-6.7-14.39-11.5-14.39M10228.3 3450.29c-8.8 8.81-14.6 16.58-21.1 27.33-5.2 8.7-7.8 19.21-13.9 27.32-12.6 16.82-28.9 31.35-47.4 41.27-13.9 7.42-29.5 16.71-45.1 19.18M10180.4 3455.08c-7.4-7.34-12.4-17.11-20.2-23.97-17.7-15.8-38-26.07-59.9-34.06-7.9-2.87-15.3-8.62-22.5-12.95-1.4-.83-5.8-3.6-5.8-5.27M10306 3548.13c-1.4 6.94-5.6 11.89-8.1 18.7-2 5.38-2.4 11.92-6.7 16.31-5 4.95-11.6 10.67-15.9 16.29-8.1 10.72-14.4 19.55-24.9 27.83-8.8 6.89-21.7 13.46-31.6 18.7M10351.6 3514.55c-7.5-5.13-17.5-15.24-26.4-18.22-17.7-5.91-37-5.54-55.1-10.09-4.1-.98-24.5-8.59-24.5-11.97M10561.6 3511.68c-4.4-3.81-10.6-10.22-16.3-13.44-16.5-9.44-39.8-8.96-57.5-14.87-9.9-3.3-13.5-9.15-20.6-16.31-1.8-1.78-9.4-7.18-8.2-7.18M10507.2 3541.95c-9.2 12.82-14.5 27.64-26.4 36.93-9.1 7.1-23.2 8.25-33.1 15.35-8.4 5.96-19.5 9.45-28.8 13.41"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.095}
      d="M11998.5 3415.83c-.8-1.57.3-3.67 2.2-2.68M11887.3 3424.48c-44 0-41.4 92.01-16.5 115.34 12.7 11.9 30.1 16.82 41 30.89 9.3 11.98 15.2 26.8 21.2 40.58 9.6 21.95 11.7 44.89 7.5 68.35-.6 3.33-11.4 35.44-6.3 37.15M12215.6 3425.98c-.7-.72 5.4-6.9 5.5-7 11-12.03 19.8-22.25 21-39.09 1.9-25.97-4.2-52.6 8.4-77 12.5-24.16 36.7-36.16 57.3-52.52 28.5-22.72 48.3-68.56 56.8-102.81M12390.2 3403.89c0-1.03-.4-1.09.4-1.49 19.2-9.6 41.5-9.73 57.9-26.1 13.8-13.81 13.5-38.23 23.7-54.46 16.8-26.63 44.3-45.31 62.1-71.92M12294.1 3423.74c-5.4 1.36 16 19.05 15.3 30.44-1.2 21.21-22.5 44.35-19.2 64.76 3 19.1 41.9 37.12 26.4 60.29M12071 3832.13c6.2-6.2 17.1-8.3 22.8-16.87 17.4-26.02-9.5-59.09 9.4-88.63 10.5-16.36 50.5-36.85 50.5-57.15M12281.5 3832.71c-.3-.34-.6-.61-.9 0-10.8 21.63-13.5 43.98-16.4 67.9-6 49.52 62.8 78.28 24.1 138.6M12348.8 3810.92c60.7-22.99 18.9-49.83 38.1-88.17 14.2-28.52 46.8-46.67 64.6-73.25M12008.4 3847.93c-13.7 10.22 4.6 38.74 11.6 47.44 29.9 37.28 81 48.64 81 104.3M12112.6 4088.14c0-7.91 28-40.13 35-42.81 14.2-5.51 29.4-1.95 43.1-10.75 17-10.97 10.3-47.55 23.1-52.66M11678.2 3524.31c-6.1 12.21-6.1 30.87-16.6 43.72-13.8 16.87-38.5 21.84-47.5 42.81-15.7 37.17-7 84.85-30.7 118.03M11779.2 3734.53c-52.6 26.32-47.6 80.86-71.3 125.19-12.7 23.76-36.1 29.48-53.2 48.18M11759.6 4097.4c6.5 0 16.7-10.62 21.5-14.32 39.5-30.33 18.8-58.58 25.5-99.66 2.1-12.96 10.2-23.79 16-35.23 2.2-4.39 12.9-40.87 16.4-40.87M11929 4147.52c2.1-19.47-11.6-36.39-7.6-56.08.1-.64 45.8-66.6 53.4-77.88M11855.3 4146.94c-8.9-8.81-17.5 52.57-17.8 56.83-4.3 57.87 62.7 99.56 30.7 155.49M12073.4 4203.34c1.1-3.27 14.8 34.59 16 44.91 4 34.7-5 77.56-36.3 98.47M11633.3 4146.19c-8-23.78-52.7 25.28-56.3 30.44-22.2 32.04 5.1 56.59-8.5 86.53-12.4 27.22-52.5 41.02-73.3 61.78M11423.9 4040.11c-8.1-6.07 31.4-9.84 32.4-9.55 21.8 6.54 33.6 36.45 53.1 47.89M11392.3 3681.42c-13-19.55-62.6 35.42-67 41.48-20.8 28.63-.4 70.33-28.8 106.67-11 14.1-46.5 28.87-49.7 46.4M11225.6 4266.3c57.3-28.63 79.3 39 114.6 68.32 26.1 21.63 63.6 31.82 96.9 33.29M11070.9 4103.68c-10.6-5.35-33.1 27.62-45.5 31.18-83.7 23.92-117.5 24.8-189.8 80.41M10678.4 4034.29c-14.8 14.79-14.9 59.75-24.9 79.82-15.7 31.39-41.2 57.55-58.5 88.17-21.8 38.37-32 87.14-44 129.36M10469.5 4125.31c-6.4-25.47-45.2-39.43-66.7-41.64-63.9-6.52-116.2 18.22-178.6-10.88M10578.9 3846.44c-7.1 2.34-45.6 45.63-72.1 58.19-58.9 27.91-129.6 33.58-185.2 67.74M10694.5 3841.23c-11.9-23.81-8.2-51.03-31.5-70.72-19.1-16.21-108.2-38.47-108.2-63.43M10844.6 3863.6c-4.8-5.99-1.8-76.79-8.1-94.61-10.4-29.59-55.2-65.96-50.6-98.31M11065.2 3692.18c0-35.28-38.9-54.79-55.9-80.28-18.6-27.99-14.9-59.44-14.9-91.02M11010.5 3805.25c-16.6 24.96-33.8 116.14-32.8 145.94 1 32.01 11.7 61.86 4.1 94.43-7.8 33.95-33.1 33.68-48.4 57.74M11770.1 4356.57c-7.3-3.64-41.8 54.28-46.1 63.11-20.2 41.38-9.9 88.1-28.2 130.11-16.3 37.06-56.4 57.12-73.1 93.26M11870 4481.3c36.7-36.61 78.2 24.88 115.8 33.58 39 8.97 68.6-13.97 103.3-26.13M10995 4283.91c-18.6 9.29 27.8 94.19 30.4 103.39 14.5 51.65-6.8 109.3.9 162.94M11181 4150.66c-52.2 16.07-47.4 105.13-65.5 143.84-9.7 20.81-33.9 35.01-41 56.25M11285.3 4521.88c-18.5-10.57-42.5 19.55-51.6 32.38-20.9 29.45-23.6 68.14-46 96.39-22 27.83-62 31.56-81.9 64.74"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11321.7 4656.32c4-15.85 39.3-20.83 50.5-17.77 34.4 9.47 43.2 50.07 86.9 53.43 31.2 2.39 59-22.38 90.2-22.38M11915.9 3567.66c19.7-19.69 48.9-11.18 76.6-24.83 14.7-7.21 32-29.37 42.8-32.99M11859.1 3521.02c2.9-2.85-8.4 4.01-9.4 4.84-6 5.11-12 10.27-16.6 16.79-12.3 17.74-7.8 41.48-21.5 58.11-4.2 5.02-9.3 8.86-14.2 13.14-.9.77-8.1 7.4-6.7 7.1M11945.4 3673.58c-3.5-2.32 15.9-6.52 17.5-6.44 11.9.77 21.8 9.9 33.3 12.48 32.1 7.1 55.7-19.48 84.2-26.58M12292 3518.14c1.7-.85-16.5-1.06-18.5-.87-11.6 1.01-24 7.84-33.2 14.6-12.8 9.42-19.8 29.27-34.2 35.68-18.4 8.22-38.8 5.3-57.7 14.72M12312.8 3553.9c22.9-34.43 74.1-11.54 103.5-35.06M12483.1 3309.15c-1.3 2.68.7-5.99.5-9-.5-6.36-2.2-12.71-4.5-18.67-10.5-26.77-14.3-27.22-5.3-54.34M12460.2 3365.69c-.6-1.23 8.4-.27 9.4 0 6.5 1.62 9.9 6.09 12.5 12.05 10 22.85 25.2 18.36 46.8 17.77M12406.3 3706.38c-5-2.02-2-20.91-5.1-29.45-4-11.09-14.8-18.01-19.7-28.55-7.9-17-4.1-43.29 1.7-60.66M12388.1 3764.57c6.8-6.75 19.1-6.46 28.2-10.45 23.1-10.17 57.8-28.07 83.2-28.07M12277.3 3937.01c-1.8-.58.1-2.85.9-3.94 5.7-7.85 17.6-17.45 27.7-17.69 8.3-.21 15.5 4.52 23.9 4.26 15.7-.54 36.1-13.68 48.7-23.15M12296.3 3996.1c3.1-6.14-30.8 9.58-35 13.25-10.9 9.48-16.9 22.7-27.3 32.52-9 8.46-21.8 13.35-28.8 23.81M12066.4 3937.3c14.3-7.13 17.1-25.99 30.4-33.2 14.3-7.66 41.3-1.6 63.8-12.83M12095.7 3765.37c-1.5-.59 2.2-3.78 2.8-4.34 9-7.55 19.7-12.58 32-10.37 13.6 2.47 23.3 15.67 37.1 17.37 14.1 1.76 25.4-7.93 38.8-10.16M12143.6 3692.55c-2.9 5.69-21.6-14.93-23.1-17.4-7.9-12.27.2-24.88-3-36.45-2.1-7.5-11.4-15.41-16.4-20.94-2.3-2.56-10.6-13.65-14.5-13.65M11697.6 3871.69c0 .03-5.7-7.13-7.1-8.48-3.8-3.84-12.4-6.1-17.6-6.74-7.2-.87-13.8 4.05-21.1 3.57-9.4-.64-45.2-14.95-49.8-24.11M11727.4 3820.31c23.5 0 19.1 39.33 33 53.46 2.6 2.63 20.4 18.01 24.2 10.48M11607.2 3671.98c0 4.69 10.1-4.36 13.9-1.57 24.1 17.96 19.8 65.27 68.1 45.95M11627.4 3595.04c0-11.07-26.5-7.93-33.3-10.19-18.8-6.26-34.6-49.55-25.1-66.2M11806.9 4041.55c0-20.25 37.1-17.99 45.4-20.25 17.9-4.84 36.1-18.39 52.7-26.69M11809.2 3979.02c-.1.03-3.7-2.34-6.4-3.86-5.5-3.16-11.8-4.81-17.6-7.31-13.9-5.96-23.3 3.64-33-13.84-.9-1.68-5.2-8.86-3-11.07M11947.4 4060.33c-6.1-3.06 11.9-3.38 12.6-3.16 3.7 1.19 8.7 11.28 10.5 14.42 14 24.55 36.6 7.69 56.3 8.99M11858.2 4265.98c0-11.17 26.7-12.45 31.1-12.26 21.2.9 65.8-1.65 77.8-25.6M11878.9 4325.04c-14.4-7.18-35.6 6.07-50.8 6.84-8.2.4-29.8-16.65-35.6-22.43M12092.5 4285.53c19.7-23.68 59.8-8.09 84.3-17.69 4.6-1.78 8.5-4.13 12.5-6.81 1.1-.69 18.7-15.17 15.5-16.79M12067.6 4330.28c-21.5-21.44-49.2 5.75-72.5 12.67-7.9 2.31-20.6-1.12-26.9 2.84M12342.2 3212.06c-1.9-3.91 10.8-6.49 13.8-6.68 10.4-.64 19.6 4.1 30-.16 16.7-6.78 26.9-39.59 45.5-39.59M12312.7 3243.29c-1.9-5.58-10.1-6.33-14.7-8.19-6.9-2.85-13.3-9.15-17.6-15.09-15-20.56-10.4-38.92-12.9-61.56M11931.4 3717.69c-12.2 6.12-12.3 19.26-22.5 26.66-8.7 6.28-25.9 2.45-30 15.46M12314.9 3580.75c3.5 0-5.5 4.15-7.9 6.6-5.9 5.83-11.9 11.44-17.8 17.29-9.2 9.21-6.7 20.86-14.5 28.66-8.3 8.35-22 6.38-31 14.55M12155.7 3673.5c-3-1.01-1.1-9.47-.1-11.57 5.4-10.62 17.8-11.5 25.6-18.92 3.9-3.64 5.3-24.77 8.3-25.28M12453.3 3653.52c3.4-6.66 7-9.66 7.4-18.02.3-5.98-2.6-13.51-.5-19.29 2.4-6.83 11.9-9.5 15.2-16.31 2.2-4.57.4-13.27 4.4-16.47M12535.8 3248.67c-.5 2.76.8-14.18-1.8-20.76-5-12.26-20.1-16.73-23.7-30.38-4.9-18.17 22.2-59.23 10.8-70.56M12535.2 3252.53c8.1-14.24 28.1-29.75 31.7-38.79 8.2-20.52-3.8-37.04 11.5-55.37"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12454.1 3654.24c0-15.06-17.3-26.35-14.4-43.56 1.3-7.88 19-41.27 8.8-46.38M12381.3 3406.66c-1.2-1.2 10.2-.45 11.4-.1 6.1 1.73 8.5 10.32 9 15.69 2.5 23.47-7.5 33.48 19.6 38.77 5.9 1.17 14-1.01 18.2 4.26M12292.9 4039.63c-17.3 17.3 2.3 37.44 5.2 57.93 2 13.78-5.3 25.41-5.3 38.28"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12292.4 4037.82c0 .06-14.3 10.89-18.3 14.88-8.6 8.64-7.4 21.58-14.7 29.98-8.1 9.24-22.8 11.9-31.6 22.49M12101.9 4003.4c-5.3 21.04 22.3-3.2 31-9.85 4.6-3.56 23.8 2.05 23.8-3.94M12098.3 4003.47c-5.3 10.54-11 34.27-6.9 46.48M12213.5 3988.61c8.6-17.17-5-64.87 16.1-73.33"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12212 3989.61c-1.7 3.28 14.4-10.61 17.7-11.65 18-5.77 19.6-.21 35.1-12.13M11936.8 3718.62c0-1.35 12 6.47 17.4 14.9 12.2 19.19 11.2 31.13 37 27.35M11584.6 3729.66c-5.1 2.56 13.3 35.34 13.9 43.24.7 7.56-1.9 14.55-4.6 21.47-1.4 3.59-6.5 13.68-3.8 10.94M11580.5 3731.39c-1.3-1.33-9.7 10.33-10.9 11.45-14.9 13.99-15.6 29.77-18.4 49.32M11657.4 3907.29c-4 0 16.1 37.17 13.7 48.69-.5 2.66-3.7 16.42-7.8 16.42M11654.8 3904.95c-13.1 0-31.9 36.08-33.8 45.58M11836.8 3915.28c6.3-18.89-37.4-33.02-16.7-53.78M11840.1 3909.02c-2.2 2.24 6.1 2.37 9.2 2.61 9.5.74 16.4-5.06 24.9-5.06M12088.9 4489.15c0-8.88 10.4-16.15 13.1-25.09 2.2-7.29-1.2-15-.4-22.43 1.9-17.82 20.9-27.32 34.8-34.77M12091.9 4485.22c-.9-.45 11.5 2.47 13.6 3.09 8.2 2.39 15.8 6.49 23 11.09 26.2 16.9 43.9 4.5 71.9 2.02M12035.2 4508.15c-5.2 3.73-2 15.17-1.1 19.93 3.3 16.92 12.7 30.94 19.5 46.48 2.3 5.46 2 14.21-2.8 18.26M11979.6 4510.44c-.7 1.09 1.2-6.97 1.4-8.7.5-5.88-.9-11.71.7-17.56 4.4-16.66 21.9-29.21 23.2-46.24M12053.9 4345c-6.4 2.13-10.8 23.39-10.6 29.11.3 8.96 8.4 14.13 11.5 22.08 4.2 10.72.1 21.79-4.4 31.64-1.4 3.08-3.4 10.11-6.5 11.84M12048.6 4348.33c-12.5 0-30.9 15.62-38.3 24.56-2.8 3.32-3 8.22-6.2 11.22-4 3.76-11.3 4.93-16.1 7.69M11870.6 4356.6c-1.9.27 5.7 4.1 5.8 4.21 5.4 3.51 7.7 8.19 10.6 13.72 5.4 10.27 10.2 35.23 22.3 40.1M11867.5 4362.32c-8.3 1.65-7.8 10.22-6.5 17.16 2.8 15.59 14.2 27.03 18.2 41.8.9 3.35 0 20.97-7.3 17.83M11621.1 4635.92c-7.8 7.71 10.5 31.79 12.8 40.87 3.5 13.51-8 27.51-9.9 41.08M11618.2 4638.5c-23.4 10.93-28.4 48.82-56.6 52.36M11643.2 4608.73c-.9 2.82.1-6.01-.6-8.89-1.3-5.48-6.1-8.56-10.8-11.23-11.1-6.33-38-7.68-36.5-23.91M11680 4571.29c-3.6 0 7.1 1.46 10.3 3.14 7.2 3.88 14 9.2 19.6 15.3 19.9 21.52 35.8 37.43 65.8 44.27M11706.8 4502.91c.2 3.73-.7-5.56-2.6-8.09-3.8-4.92-10.8-7.05-16.8-6.94-9.4.13-17.8 6.73-27.3 6.46-18.4-.5-35.9-24.34-44.7-38.66M11724.3 4422.08c-.3.08-6.4-15.04-9.6-16.85-6.4-3.61-14.3-4.33-20.4-8.56-13.4-9.24-18.3-27.14-21.5-42.09-1.1-4.93-4.4-13.07-2.9-18.15M11716.6 4456.37c0 .46 13.4-1.73 14.9-1.62 6.7.53 12.3 5.85 16.7 10.3 14.4 14.42 16 38.31 33.8 50.58 8.2 5.61 18.6 4.47 27.2 8.8M11957.2 4505.81c-5.4-1.81-6.7 24.35-5.9 28.31 2.6 11.52 15.3 16.92 21.9 25.57 9.1 11.97 14.7 29.56 16.7 44.41M11557 4285.83c-.2-.43 6.4 5.8 7.7 8.3 3.8 7.31 6.7 15.93 7.1 24.18.8 14.24 1 25.73 8.8 38.29 7 11.39 18.7 19.5 23.8 32.19M11568.2 4215.21c-3 1.49-7.6-1.67-11-1.3-6.6.74-13.5 3.88-20.2 1.73-22.1-7.11-40.7-39.27-42.2-60.85M11592.2 4170.64c-8.6 5.17.4 25.63 4 31.19 7.9 12.29 22.4 18.6 32 29.42 13.6 15.22 13.6 30.82 16.1 49.71M11494 4327.25c-10.4 13.81 3.8 34.81 10.1 46.62 7 13.12 6.1 25.12-2.5 37.49-2.6 3.78-6.4 8.38-10.2 11.04M11489.9 4329.09c-9.8 0-26.3.45-33.4-7.4-7-7.71-6.6-24.4-6.6-34.27M11436.3 4370.59c-3.6 0-8.2 11.31-9.7 13.68-3.8 6.04-11 14.82-10.3 22.4 1.1 12.61 8.1 19.74 4.5 33.66-.8 2.87-1.7 7.88-4.8 9.07M11442.1 4371.63c-4.5-.42 5.2-7.61 9.1-6.94 4.9.8 7.9 6.33 13.2 5.4 6.6-1.14 8.2-9.82 13.3-11.52M11387.2 4648.93c0-7.29-3.6-17.72.7-24.24 7.4-11.39 25.4-11.63 33.3-23.87 7.3-11.28 2.3-28.49 11.5-38.76M11468.1 4691.47c1.4-.98 1.6-6.78 1.8-8.4.6-9.4-3.6-17.78-.9-27.43 3.7-13.36 18.9-17.67 25.5-28.93 6.4-10.83 3.9-25.43 6.1-37.41M11429.8 4681.1c-2.4-2.37-6.4 4.76-7.3 6.06-4.7 6.76-8.6 16.13-7.5 24.53 2.2 16.02 22.5 23.9 23.3 42.23.4 7.53-3.9 15.54-7.7 21.76-.4.75-5.1 8.62-6.1 6.49M11553.7 4668.59c0-12.29-5.2-29.8-4-42.67 1-11.1 10.2-18.2 10.2-30.63M11332.6 4332.07c-7.1-1.81-12.8 20.46-12.8 24.9 0 7.13 5.7 13.57 8.5 19.79 7 15.36 10.2 44.38-6.6 55.13M11292.8 4282.31c0-4.79 2.1-8.83 1.1-13.84-1.6-7.34-8.4-17.08-5.2-24.66 4.7-11.28 18.3-14.58 22-26.82 3.6-11.79-.6-24.66 2.8-36.61M11145.8 4683.81c-5.1 3.08 11.8 25.25 13.1 31.21 3.8 18.73-6.9 38.05-.2 56.3M11189.6 4646.59c0-22.94-29-21.71-43.3-28.31-10.4-4.84-13.8-21.47-15.3-31.58M11225.4 4562.54c0-18.68-20.5-26.79-32.7-37.3-16-13.73-20-37.92-11.2-57.34M11216.9 4597.44c-.8.37-2.9 1.09-2.5 2.34 1.3 3.54 6.9 5.8 9.5 8.52 5.6 5.77 9.8 13.14 12.6 20.7 7.7 21.31-.6 44.54 5.1 65.74M11076.9 4355.19c-.8-1.17 4.8 18.78 6.6 22.56 7.2 14.69 19.5 23.1 19.7 41 .1 4.95-.2 14.34-6.3 15.78M11071.3 4353.94c-14.3 14.34-8.6 35.89-4.6 53.1.9 4.23 4.7 19.67-1.1 22.01M11101.5 4312.64c-4.7-9.47-7.4-17.64-19.5-20.67-7.1-1.78-14.4.85-20.9-3.62-10-6.76-11.3-22.69-10.8-33.55M11133.2 4231.07c-7.3-9.79-25.8-18.44-28.2-29.91-1.7-7.79 1.8-16.39 2.8-24.05 1.7-12.48.7-25.44-4.9-36.61M11125.1 4272.55c0 2.5 5.1 3.8 6.6 4.44 5.2 2.34 9.4 6.09 12.7 10.67 7.5 10.19 9.3 40.68 22.9 44.96 4.9 1.52 9.5-1.62 14.3-.87M11027.8 4554.34c0 2.29 8.9 8.46 10.5 9.93 10.3 9.5 27.8 16.6 34.1 29.29 1.2 2.29 6 19.82 1.1 20.52M11025.2 4550.09c-8.6 12.98-9.9 38.26-4.3 52.15 2.9 7.44 10.1 14.44 10.6 22.74 1 15.62-12.1 26.42-16.7 40.23M11026.4 4474.6c-.5.26-6.2-3.65-7.4-3.89-5.7-1.09-11.8-.82-17 1.92-11.4 6.04-18.8 17.21-29.1 24.61-12.1 8.7-25.8 12.03-39.5 17.21M11022.7 4387.54c-3.4-6.76.4-26.5 4.5-32.43 4.6-6.63 12.2-8.14 15.5-16.44 3.4-8.49.9-21.16 6-28.82M11037.3 4442.99c-.8 0 1.9-.18 2.7 0 2.8.61 5.7 1.12 8.4 2.45 6.1 3.11 9.6 8.12 12.2 14.26 4.4 10.03 8.5 27.49 18.2 33.77 14.3 9.36 33.6-1.07 42.3 14.12M11453.6 4024.47c0-16.26-10.2-27.86-11.3-43.9-1-16.02 9.1-26.82 11.9-41.67 2.5-13.65-2.6-31.87 1.6-44.59M11485.6 4057.89c-8.1.48-13.2 14.26-14.5 20.72-2.7 12.91 3.7 26.74-.3 39.09-6.3 19.58-24.6 33.39-26 55.18M11513 4081.33c0-5.22 8.3-4.13 11-2.48 11.7 7.08 36.9 31.11 49.1 9.63"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11516.3 4080.58c-5.2 1.94-3.2 15.91-3.1 19.85.2 6.2-.2 13.86 3 19.42 6.2 10.94 23.6 20.57 15.9 36.03M11248.1 3880.87c3.7 0 12.9 9.63 15.6 12.21 11.9 11.76 16.9 33.68 14.5 50.13-1.6 11.09-5.3 22.61-2.5 33.84 3.5 14.47 14.5 26.08 17.8 40.95M11244 3882.79c-12 5.4-9.8 31.21-9.9 41.43-.3 18.99 8.4 33.36 12.8 51.05 3.7 14.37-2.6 37.31-11.5 48.77M11300.7 3829.89c0 2.98 6.7 6.84 8.7 8.76 3.9 3.83 6.2 9.79 7.5 15.03 3.9 16.15 1 33.15 3.7 49.46 2.9 16.71 11.5 31.69 14.3 48.53M11311.8 3758.9c-3.4-8.46-10.7-1.35-16.2 2.53-10.6 7.4-24.7 20.62-32.7 31.03M10834.4 4218.64c-2.6 0-1.3 10.43-1.3 11.76 0 14.19 11.6 21.48 13.6 34.54 3 19.77-19.9 41.13-23.8 60.56M10829 4221.28c-27.2 10.91-33.5 41.67-49.8 63.4-6.7 8.97-19.4 10.97-25.3 19.67M10922.8 4171.6c-9.8 2.8-11.2 22.24-9.6 30.2 2.1 10.4 9.3 19.1 12.4 29.16 3.5 11.12 2.4 23.18.6 34.54-.9 5.72-1.9 16.01-7.3 19.61M10880.1 4185.71c-2.2-1.44-.7-10.86-1.5-13.31-2.1-7.16-9.2-12.93-15.6-16.04-18-8.7-60.4-5.4-63.1-31.37M10992.6 4146.94c-1.9-2.8-2.4-6.63-3.6-9.74-10.1-27.67 15-31.05 27.2-51.99 8.1-13.94 7.4-32.54 9.2-48.03M10932.8 4101.86c-5.6 1.39-9.2 9.29-15.7 8.3-23.4-3.48-36.1-36.29-61-34.5M10932.7 4110.25c-11.3 4.09 1.3 28.94 7.5 31.68M10983.4 4018.74c-5.5-7.05-5.8-21.23-15.5-24.61-7-2.44-15.8 4.5-22.2 6.18-12.4 3.24-27-3.94-37.4-9.93-3.6-2.07-9.1-4.23-10.5-8.51M10976.7 3950.42c3.1-6.36 17.4-7.58 22.8-5.24 15.8 6.81 21.3 29.11 39.2 34.64 9.7 3.01 23.8-2.42 33.8-3.75M10649.1 4123.66c-.4-.08 8-2.13 9.2-2.29 7.5-1.03 14-1.35 19.8 4.39 4.7 4.74 7.2 12.67 13.4 15.89 4.3 2.26 8.7-.53 12.5-2.45 9.6-4.84 17-10.32 28.2-11.23M10589.4 4208.88c-5.4 1.78-11 1.09-16.3 3.51-13.6 6.15-29.6 20.33-40.4 30.57-7.7 7.24-13.4 18.12-21.7 24.24-7.2 5.27-19.2-3.3-28.2 3.38M10553.2 4325.71c-3.7 20.57 18.9 23.55 27.3 37.62 16.2 26.96 15.8 60.85 29.3 89.27M10547.9 4338.11c-2.6-7.77-21.6 17.45-24.3 19.98-15.3 14.42-36.5 32.38-57.7 36.61M10566.2 4268.3c-2.8-4.32 11.5-2.29 12.2-2.16 9 2.02 17 7.13 22.6 14.45 10.3 13.27 14.3 26.52 30.2 34.69 10.3 5.32 22.1 4.9 32.3 10.43M10607 4188.13c-3.1-3.16 3-1.19 6.6-1.78 7.6-1.28 16.1-1.12 21.5 5.11 5.5 6.25 5.9 15.27 10.6 22.08 9.1 13.12 27.6 23.79 42.6 28.79M10635.7 4145.53c-5-8.19-26 .74-31.5 2.55-26.2 8.6-50.3 19.43-77.2 6.52M10226.8 4070.07c2.4 1.2-4.4-10.21-4.7-10.53-4.7-6.76-10.6-13.97-12.2-22.27-3.4-17.46 13.3-35.23-1.8-50.98-3.4-3.59-6.6-6.47-10.8-9.08M10228.8 4072.12c-15.1 2.5-43.1-1.06-52.2 12.27-7.1 10.43-8 24.61-11.3 36.55-.7 2.83-2.1 11.61-6.2 11.61"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.554}
      d="M10286.7 4086.24c-3.8 0-7.5 23.44-8.2 26.34-4.4 19.19-11.4 63.86-40.9 61.7"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M10303.4 4090c0-13.22 10.2-22.22 2.7-36.88-8.1-15.83-44.7-29.58-32.7-52.78M10393.2 4080.42c-.6.11.4-6.12.3-7.02-.3-4.45-1.9-8.94-3.9-12.88-12.2-23.55-25.7-40.79-6.6-66.41M10379 4081.01c-4.6-.94-3.8 5.8-4.4 9.17-1.9 10.7-4.4 21.32-9.1 31.16-8.5 17.77-29.8 24.61-39.3 42.09M10322.7 3973.65c0-17.4-22.3-20.86-33.5-30.36-12.3-10.37-18.7-27.8-22.5-42.89M10321.4 3975.3c2.1-1.04-2.9 3.62-4 5.67-2.4 4.63-3.9 9.84-4.6 14.98-1.8 12.48 6.3 26.39 14.5 35.23M10379.6 3943.24c-.3 1.88-.3-3.6-.4-4.26-.3-3.03-1-6.01-2.3-8.81-3.8-8.49-7.7-21.76-14.3-28.18-8.4-8.11-27.8-3.99-38.7-6.17-1.9-.4-10.6-.69-10.6-3.88M10446.7 3924.38c-11.8 7.37-5.8 30.62-1.6 40.81 4.7 11.23 15.5 16.82 22.3 26.39 9.1 12.91 6.3 36.45-2 49.33M10499.5 3902.05c-.3.45-1.6 2.71-2.1 2.71-.2 0-1.4-4.01-1.5-4.17-1.2-2.21-3.3-3.97-5.3-5.51-8-6.33-16.3-9.37-26.3-11.89-20.4-5.19-35.9 10.98-53.9 15.85M10659 3766.78c-3.1 1.31.3-19.07 2.9-22.13 4.9-5.8 16.8-3.89 23.3-8.14 17.7-11.47 11.1-38.85 30-48.03M10682.4 3787.85c0 .93 9-1.06 9.8-1.17 5.2-.58 10.8-.77 16 .08 11.2 1.81 21.5 10.91 33 10.91 12.2 0 25.1-11.76 34.3-18.57M10580.5 3737.06c-2 0-4.5 6.33-5.9 8.06-5.7 7.27-11.6 15.6-18.9 21.34-11.7 9.24-36.2 9.05-50.4 12.96M10552.1 3709.68c-3.6 0-7.4-3.08-11-3.64-8.2-1.28-18.9.77-26.5 3.59-14.5 5.27-25.9 18.46-40.2 22.85M10566.3 3727c-2.3 0 1.7-4.68 2-4.92 4.6-4.36 10.7-7.29 16.1-10.48 14.6-8.65 32.1-13.7 44.3-25.92M10820 3734.96c7.3 5.48 27.5 6.09 35.2 1.12 8-5.22 13.4-14.61 20-21.34 13.4-13.73 32.2-24.43 51.4-26.9M10846.5 3809.38c9.9-4.92 23.4 6.38 32.6 7.9 12.4 2 36.3-9.9 47.7-14.98M10799.3 3713.06c3.1 6.07-7 14.72-10.8 17.32-11.7 8.12-40.5 21.45-55 16.05M11004.4 3597.51c4.9-12.26 28.8-10.75 37.1-20.94 9.5-11.73 7.5-29.51 13.2-43.05 6.8-15.88 20.7-26.58 31-39.96M10995 3548.87c-12.8 0-24.4 8.54-37.1 10.3-12.6 1.73-24.4-3.01-36.8-2.77-6.4.13-14.8 2.61-18.7 8.06M11024.4 3631.25c-7.8 5.83-7 19.93-12.5 27.7-13.1 18.38-39.8 20.09-41.1 46.53M11047.7 3651.36c5.2-10.46 2.6-22.88 9.1-32.94 6.4-9.98 20-14.74 24.1-26.13M10993.4 3523.91c5.6-11.23 12.5-21.92 21.6-30.52 6.3-5.88 14.1-8.59 19-16.04 6.4-9.55 7.5-21.58 10.6-32.38M10992.3 3522.05c0-21.52-5.1-37.3 9.7-56.4M10786.5 3670.84c-1.8 0 .2-5.11.5-5.75 2.1-4.79 6.7-10.03 11.2-12.56 6.1-3.46 12.1-2.07 18.6-3.4 9.4-1.92 29.6-14.53 31.4-25.47M10781.4 3673.42c0-16.2-13.9-30.94 1.6-43.82M10835.7 3282.27c-1.7 1.71 1 5.14-.2 7.27-4.5 8.25-12.6 17.05-12.4 26.95.5 27.7 15.7 42.22 2.7 70.11M10251 3559.59c-16.7 0-33.9 26.16-38 40.58-2.6 9.47-2 18.84-9.2 26.53-3.5 3.75-9.5 4.09-14.2 5.16M10251.9 3557.92c-25.7 0-29.1-15.62-40.3-35.58M10382.8 3581.55c-6.8-2.72-10.9 7.23-13.8 11.84-4.2 6.68-8 13.73-7.8 21.84.2 8.89 6.4 24.64-3 30.89M10375.6 3582c-2.5 2.53-7.8-1.41-10.8-1.73-13.1-1.36-23.6-2.93-32-14.13M10198.5 3237.09c-28.4 0-22-25.84-28.7-45.93"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M10195.5 3241.93c0-8.06-8.1-4.12-13.1-1.91-12.2 5.53-26.7 8.51-38.3 14.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M11600.5 3036.94s-353.6 359.19-491.5 569.38-516.2 468.28-516.2 468.28 439.5-243 577.4-436.35c128.5-180.13 436.3-500.21 436.3-500.21s-165.8 435.74-248.7 653.62c-105.4 276.71-513.6 854.98-513.6 854.98s527.5-595.99 639.9-872.7c82.5-202.87 165-635.9 165-635.9s34.6 508.83 34.6 763.62c0 262.95-8 1000.25-8 1000.25s57.7-750.15 74.5-1000.25c15.4-228.32-53.7-747.16-53.7-747.16s114.5 375.06 175.5 559.5c69.2 209.32 258.7 698.51 258.7 698.51s-145.5-526.82-206.7-737.01c-57.3-196.86-196.5-549.5-196.5-549.5s502.5 382.75 632 549.5c104.2 134.12 364.5 545.44 364.5 545.44s-171.3-437.79-274-574.71c-130.9-174.27-722.5-557.23-722.5-557.23s367.2 186.39 517.1 255.11c139.8 64.1 410.2 174.41 410.2 174.41l-426.3-245.39-506-236.19z"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11309.9 4048.71c43.4 37.22 93.6 118.05 101 175.15 9.8 75.86 24 67.61 35.3 146.53 6.8 47.68 30.7 99.56 30.7 148.81 0 68.06 27.6 140.67 27.6 209.98 0 9.02 27.8 347.51-6.2 153.81-9.6-54.44-32.9-248.93-52.3-307.31-28-83.91-22.1-201.17-61.1-279.23-8.6-17.25-40.8-116.06-56-146.45-11.7-23.33-33-39.3-49.1-55.39"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11309.9 4048.71c43.4 37.22 93.6 118.05 101 175.15 9.8 75.86 24 67.61 35.3 146.53 6.8 47.68 30.7 99.56 30.7 148.81 0 68.06 27.6 140.67 27.6 209.98 0 9.02 27.8 347.51-6.2 153.81-9.6-54.44-32.9-248.93-52.3-307.31-28-83.91-22.1-201.17-61.1-279.23-8.6-17.25-40.8-116.06-56-146.45-11.7-23.33-33-39.3-49.1-55.39"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11982.6 3856.24c-1.2-1.26 70.9 8.06 87.9 13.96 9.7 3.41 19.3 7.51 27.7 13.47 55 38.71 102.5 89.9 163.8 118.98 37.6 17.85 77.5 27.99 118.6 27.46 16.1-.21 32.6-3.17 48.1-3.17 2.1 0 80.1-16.01 76.7-12.47-29.2 30.35-125.5 54.33-155.4 55.58-90.7 3.78-194.7-43.51-261.2-102.68-2.3-1.97-4.3-4.2-6.5-6.14-1.7-1.49-3.4-2.8-5.2-4.18-1.7-1.33-3.4-2.72-5.1-3.99-32.3-23.18-82.7-47.95-81.7-48.93"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11982.6 3856.24c-1.2-1.26 70.9 8.06 87.9 13.96 9.7 3.41 19.3 7.51 27.7 13.47 55 38.71 102.5 89.9 163.8 118.98 37.6 17.85 77.5 27.99 118.6 27.46 16.1-.21 32.6-3.17 48.1-3.17 2.1 0 80.1-16.01 76.7-12.47-29.2 30.35-125.5 54.33-155.4 55.58-90.7 3.78-194.7-43.51-261.2-102.68-2.3-1.97-4.3-4.2-6.5-6.14-1.7-1.49-3.4-2.8-5.2-4.18-1.7-1.33-3.4-2.72-5.1-3.99-32.3-23.18-82.7-47.95-81.7-48.93"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11019.3 3729.93c-9.7-6.46-14.3-18.59-24.6-24.47-56.9-32.52-125.8-35.26-186.2-60.4-49.9-20.78-98.1-53.35-143.9-81.52-39.7-24.45-80.2-52.9-114.2-84.88-27.2-25.62-124.1-99.59-118.2-92.64 27.5 32.38 150.2 152.69 167 168.2 86.2 79.59 164.9 107.36 267.4 152.91 34.6 15.38 69.3 63.83 95.6 75.54 26.7 11.87 34.5-34.16 49.3-51.4 2.1-2.4 9.2-1.84 8.2-4.85"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11019.3 3729.93c-9.7-6.46-14.3-18.59-24.6-24.47-56.9-32.52-125.8-35.26-186.2-60.4-49.9-20.78-98.1-53.35-143.9-81.52-39.7-24.45-80.2-52.9-114.2-84.88-27.2-25.62-124.1-99.59-118.2-92.64 27.5 32.38 150.2 152.69 167 168.2 86.2 79.59 164.9 107.36 267.4 152.91 34.6 15.38 69.3 63.83 95.6 75.54 26.7 11.87 34.5-34.16 49.3-51.4 2.1-2.4 9.2-1.84 8.2-4.85"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M12454.7 3669.54c20.7 0 60 11.25 82.8 13.81 61.8 6.86 129.9-7.66 187.7-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.3 89.21-43.8 7.29-72.4 13.2-111-9.34-20.3-11.87-5.8-37.28-17.1-51.4-2.9-3.6-7 .53-4.5 2.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M12454.7 3669.54c20.7 0 60 11.25 82.8 13.81 61.8 6.86 129.9-7.66 187.7-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.3 89.21-43.8 7.29-72.4 13.2-111-9.34-20.3-11.87-5.8-37.28-17.1-51.4-2.9-3.6-7 .53-4.5 2.98"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11738 3991.85c-6.7-6.67 25.8 52.74 29.4 61.89 14.1 35.12 35.3 71.01 52.1 105.34 34.5 70.03 78.4 138.65 124.8 201.49 18.8 25.44 44.7 44.65 62.8 70.72 21.4 31.05 45.4 59.36 69.8 87.88 8.6 9.9 20.4 26.08 24.5 38.26.9 2.64 64 127.56 64 127.56s-93.7-141.71-105.3-150.84c-37.4-29.69-79.4-87.75-103.9-116.46-83.2-97.19-90-135.93-168.6-236.32-24.2-30.86-49.8-68.19-49.8-108.15 0-13.81-17-41.06-16.6-38.64"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11738 3991.85c-6.7-6.67 25.8 52.74 29.4 61.89 14.1 35.12 35.3 71.01 52.1 105.34 34.5 70.03 78.4 138.65 124.8 201.49 18.8 25.44 44.7 44.65 62.8 70.72 21.4 31.05 45.4 59.36 69.8 87.88 8.6 9.9 20.4 26.08 24.5 38.26.9 2.64 64 127.56 64 127.56s-93.7-141.71-105.3-150.84c-37.4-29.69-79.4-87.75-103.9-116.46-83.2-97.19-90-135.93-168.6-236.32-24.2-30.86-49.8-68.19-49.8-108.15 0-13.81-17-41.06-16.6-38.64"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M11239.6 4045.76c4.9-4.85-12.5 5.48-18.6 8.64-11.6 6.07-24.8 7.99-36.8 13.31-36.7 16.33-77.1 30.41-116.3 39.11-54 12-110.3 14.82-164.9 23.63-45.5 7.34-90 20.3-135.4 27.61-16.7 2.69-142 39.62-149.7 41.43-137.1 32.41 157.2-15.83 172.1-18.78 52.3-10.33 107.9-30.79 160.8-34.62 71.8-5.19 153.9 10.24 224-9.31 37.2-10.41 52.2-55.21 66-86.21.6-1.22 3.5-7.82 4.7-7.82"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M11239.6 4045.76c4.9-4.85-12.5 5.48-18.6 8.64-11.6 6.07-24.8 7.99-36.8 13.31-36.7 16.33-77.1 30.41-116.3 39.11-54 12-110.3 14.82-164.9 23.63-45.5 7.34-90 20.3-135.4 27.61-16.7 2.69-142 39.62-149.7 41.43-137.1 32.41 157.2-15.83 172.1-18.78 52.3-10.33 107.9-30.79 160.8-34.62 71.8-5.19 153.9 10.24 224-9.31 37.2-10.41 52.2-55.21 66-86.21.6-1.22 3.5-7.82 4.7-7.82"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.909}
      d="M12339.5 3353.53c3.3-13.22 29.4-13.59 38-12.77 37.2 3.57 65.6 34.7 117.5 31.56 70.5-4.29 75.3-41.91 126.2-60.85 41.7-15.49 85.4-3.49 127.6 1.86M12648 3691.91c-5.2-7.77 8.1-26.87 11.5-33.42 22.1-41.18 74.3-36.93 96.8-71.99 40.1-62.34 1.2-160.28 77.5-202.48M12795.5 3667.17c95.8 22.29 69.6 61.03 128.7 100.62 39.5 26.5 81.7 20.04 125.9 26.37M12660.9 4059.46c-9.3-16.95 53 18.39 66.7 34.62 51.4 60.71 48.5 72.93 129.6 78.41 13.9.93 51 7.85 57.9-9.05M12459.5 3817.98c-54.4 9.61-91.8 52.76-140.6 68.3-26.8 8.51-84.6-6.33-110.5-13.97M12263.5 4054.93c-23.2 5.8-26.5 50.66-18.2 67.24 15.2 30.41 52.6 44.38 69.3 74.66 23.1 41.5 8.8 88.78 11.8 133.54 1.3 20.54 7.4 39.96 7.4 60.82M12078.9 3873.37c17.1-11.44 1.7-91.76 11.3-120.87 17.4-53.06 69.6-81.1 112.4-113.16M12016.6 4113.5c-38.7 0-65.2 48.82-59.8 83.86 2.9 18.01 15.9 31.74 16.4 50.87.5 16.63-11.9 54.2-34.5 51.38M12070.5 4529.36c-8.8-23.94 44-38.04 57.4-33.12 18.5 6.78 28.4 24.93 44.6 35.38 55 35.71 107.7 44.92 164.7 4.4M11910 3602.6c-7.4-12.88 39.7-33.34 47.5-35.41 26-6.9 48.5 12.95 74.7 10.8 33.1-2.77 55.4-30.97 85-42.2M11697.9 4321.43c-12.5-3.11-21.8 2.82-32.2 9.21-51.2 31.53-26 74.07-57.5 107.41-20 21.2-53.7 5.51-72.4 33.55M11692.7 4567.57c-1.1-.45-.3-.45.3-.53 9.4-1.04 19.6 2.04 28.8 4.12 21.9 5 49.5 11.68 64.1 30.36 48.4 61.94 11.8 125.48 120.1 143.65 15 2.5 28.9 1.57 43.7-1.73M11697.3 4051.08c-14-14-45.1 17.05-56.5 25.83-16.7 12.94-32.8 29.59-54.6 33-44.5 6.97-75.1-27.97-89.8 35.81M11681 4771.99c.4-.45-20 11.79-24.8 17.69-13 15.91-14.4 34.99-16.9 54.71-2.8 22.16 2.7 42.97-6.5 64.17-28.2 64.63-53.2 54.6-59.1 124.87M11487.1 4787.95c-62.2-31.13-75.6 125.83-97.1 152.03-24.6 29.86-66.5 51.3-85.2 84.67M11454.4 4621.95c-43-48.37-112.9-39.27-156.8 5.86-21.2 21.76-25.3 59.41-51.1 77.08-19.9 13.59-81.4 4.52-108.1 9.84M11433.5 4388.08c12.4-43.47 60.1-21.58 84.2-30.09 23.2-8.17 40-39.78 58.4-54.86 15.4-12.67 38.8-21.58 49.5-38.98M11357.5 4207.68c-11.7-8.78-36.4 14.9-42.5 21.85-29.7 33.98-33.9 82.05-56.2 120.31-32.1 55.48-115.2 60.16-162.8 98.53M11482.3 4666.55c-1.6-1.68-.6-2.19 1.3-3.46 11.1-7.83 33.7-13.68 45.5-5.19 48.1 34.59 54.8 36.85 104.9 4.79M10914.9 4561.39c-9 2.98-18.6 46.3-16.5 57.9 2.8 16.23 13 32.41 18.6 47.79 16.4 44.99 13.8 92.53-7.9 135.77M10943.5 4497.09c-18.6-18.55-62.4 2.85-77.4 14.23-26.5 20.36-46 48.16-72.2 68.7-29.5 23.1-109.8 34.83-144.6 37.15M11055.2 4364.11c-20.7 3.86-18.5 53.48-15.9 67.34 4.2 21.69 22.7 41.05 31.8 61.12 18.5 40.41 24.5 88.76 17.8 132.44M11071.3 4296.88c-21-3.49-78.4 41.61-106.2 48.05-34.2 7.93-74.3 14.15-109.2 10.8-16.3-1.57-36.7-14.74-52.2-12.53M10659.2 4198.24c-9.3 0-30.9 57.07-31.7 65.61-5.2 55.53 28.2 149.06-37 180.13M10716.5 4175.87c0 7.95-1.6-5.88-2.4-7.85-4-10.09-14.2-21.58-23.1-27.54-8-5.35-19.2-4.66-26.7-10.54-16.9-13.35-3.1-59.44-.9-79.07M10938.7 4134.73c0-59.41-44-30.09-69.9-74.39-17.1-29.35 2.9-63.64-6-94.8M11102.8 4110.92c-6.5-8.78-2-40.84-7.2-53.64-8.9-22.35-32.5-33.15-42.4-54.47-18.9-40.28 8-70.16 21.3-105.54M11013.8 4126.48c-22.2 3.51-68.5 60.82-75.1 83.33-4.4 14.88-.9 36.45-9.9 49.12-15.7 22.35-63.8 40.57-85.8 55.26M10696.7 4005.61c-13.4-1.22-21.8-25.22-36.4-30.07-40.8-13.62-105.9 28.69-97.3-53M10791.9 3940c-2.3 13.78-11.6 68.43-12.7 82-1.4 19 11.1 36.5 14.7 55.23 2.8 15.28-19.2 45.26-27.1 57.5M10874.3 3878.48c-2.8 5.46-2.9-11.89-5.5-17.43-6.3-13.7-14.6-22.98-29.1-27.96-55.8-19.05-85 14.98-121.3-57.63M10911.3 3698.92c-21.7-11.47-19.2-60-14-79.35 8.2-30.91 40.6-52.81 57-79.2 17.4-28.07 16.5-75.35 9.8-106.64M10718.3 3603.61c-7.7-6.12 4.5-23.42 8.3-28.5 17.6-23.17 47.3-34.48 63.8-58.85 26.8-39.49 9.6-107.89-1.3-151.61M10577.7 3513.33c2 6.97-20.3 33.82-24.1 39.01-36.3 48.98-102.8 46.75-160.5 50.6M10772.7 3660.7c-19.3 3.62-33.7 52.29-46.7 66.44-29.7 32.22-72.5 44.94-111.3 59.89M10530 3481.67c-3-1.01 8-17.24 9.3-19.05 14.8-20.17 39.4-29.16 53.8-49.25 24.3-33.87-13.1-79.44 25.5-108.23"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10478.2 3197.51c-14 0-60.9 68.99-77.6 84.26M10808.3 3451.63c-.3 1.41 17.1-31.26 33.6-32.73 57-5.1 74.6 3.94 105.8-58.45M10784.9 3513.55c-1.2 2.39-16.9-19.75-25.7-21.85-12.3-2.93-41.3 10.91-49.4.8M10603.6 3335.44c0-10.04 3.1-26.35-3.2-35.02-9.4-12.85-47.4-22.72-35.3-44.59M10617 3312.4c-1-5.09 24-11.84 29.3-18.76 10.7-14.02 2.5-36.93 21.4-43.4"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10623.9 3305.88c-12.3-15.49 3.5-44.54-7.4-61.78M10968.6 3433.72c-26.9-26.87 60.8-38.66 65.7-60.87"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10968.6 3441.25c-11.7-23.28-11.2-72.34 8.9-88.38M10951.9 3551.88c35-34.93 49.4 54.33 111.5 50.32M10899.1 3607.12c-31.2-41.53-55.8-29.08-38.7-80.14M10790.2 3370.18c-2.7 0-.9-20.3 2.3-22.37 9.2-6.12 27.8-1.39 39.5-8.38M10618.9 3787.04c-1.7-1.73-3.3 6.62-3.2 6.86 1.8 9.29 5.8 24.19 2.3 33.42-7.7 20.14-46.2 33.9-46.2 55.23M10614.7 3786.79c-29.1-29.08-85 29.49-120.4 26.27M10721.8 3780.17c-4.5-4.47 18.3-20.7 20.7-22.48 15.5-11.49 29.2-28.42 24.7-48.98M10762.5 3824.1c-26.5-5.29-56.2 24.64-62.1 49.01-1.9 7.5 2.4 17.64.1 24.08-1.4 3.72-8.9 21.6-12.3 19.55M10824.9 3829.45c-6 3.99-3.4-14.03-5.5-20.92-5.4-17.27-9.1-33.95 5-48.05M10869.7 3972.8c4.9-24.53 27.5-19.93 38.7-30.62 17.7-16.85 19.9-42.52 37.2-59.76M11074.8 3897.26c-10.2-30.41-25.8-58.69 6.3-81.15M11073.9 3903.97c9.8-6.52 23.5-2.26 32.1-11.31 33.8-35.68 15.7-68.38 76.6-87.32M11085.5 4040.17c-4.2-8.4 15.5-27.14 21.1-29.69 15.9-7.26 38.4-.32 55.8-6.25 24.7-8.46 37.6-35.02 54-53M11046.7 3984.9c-38.7-38.66-66.7 14.27-110.5 14.27M10909.5 4085.16c0-35.49 72.2-16.25 76.1-16.79 10.1-1.35 18.6-8.94 25.7-15.69M10785.9 4045.23c-5.3-21.53 28.1-52.53 42.4-62.05M10657.4 4125.1c-17.5-26.21-49.9 12.53-68.2 10.24M10699.2 4141.46c-.9 0-1-.99-1.1-1.86-2.2-24.43 16-46.35 31.1-62.69M10633.8 4302.14c-1.7-1.73 1.8 2.26 2.4 2.79 7.3 6.57 18.2 9.26 27.5 11.31 25.5 5.61 52.1 10.27 77.9 13.46M10623.3 4387.07c-11.5-11.5-83 10.72-108.5-27.57M10591.7 4444.04c4.9 1.62 8 45.33 7.6 50.34M10590.8 4438.45c-33.4 12.95-68.9 22.45-94.8 48.31M10805.9 4344.74c-7.8-31.34-57.6-23.2-34.3-76.42M10797.5 4342.48c-29.6 5.16-54.1 39.64-66.3 64.01M10848.1 4309.32c-16.4 16.45-35.3-55.5-48.2-58.69M10938.4 4235.7c-.8-.24 12.3-9.92 13-10.37 7.5-4.98 19.5-12 28.8-11.71 12.8.4 12.6 16.92 21.1 23.55 13.2 10.27 33-1.44 44.8-8.39M10933.4 4354.71c-5-10.77-16.5 15.04-19 18.66-10.9 15.77-23.7 74.55-36.7 77.34M10973.8 4342.88c-17.5-34.97-23.2-41.27-4.3-71.5M10918.4 4802.58c-22.2 0-66.5 86.26-87.5 100.26"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10913.6 4801.39c8.9 8.91 4.3 41.99 7.7 54.6 3.2 11.49 14.2 18.38 20.4 28.07 13.6 21.23 19.3 45.79 19.3 70.56M10927.7 4722.74c-.6 1.89 2-8.57 4.1-11.73 5.2-7.48 14-15.19 22.4-18.36 25.1-9.45 48.4 12.27 68.4-15.46M10908.9 4656.97c-12.3 6.17-21.8 18.54-34.2 25.41-21.7 12.08-46.5 20.64-67.1 34.35M10650.6 4619.03c0-27.65-85.1-31.93-105.6-50.85"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10653.9 4618.63c-42.6-2.85-65.9 118.45-79.3 126.59M10743.1 4602.8c-2.2-53.3-106-60.72-55.7-131.12M10838.3 4542.48c-56.6 42.44-8.6 110.34-24.3 158.95M11091.6 4552.45c-3.7-7.34 24.4-16.84 25.7-17.16 17-4.25 30.8 7.67 43.1 17.43 37.4 29.64 70 12.37 110.5-4.12M11091.3 4625.55c-12.1 0-14.2 23.78-14.5 31.69-1.4 41.29 16.1 54.03-15.8 89.98"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M11091.3 4625.55c-3.1 0 6.2 4.33 9.3 4.52 6 .37 13.4 1.84 19.3 3.06 23.3 4.84 36.4 18.6 61.7 16.79M11141.2 4717.13c4-7.85-26.5 25.33-31 33.82-16.7 31.95 0 55.21-34.1 80M11138 4715.29c-12.7-1.97-33.7-9.15-28.2-23.04M11224.2 4715c-3.6-13.33-34.2 29.48-36.9 35.01-20.7 42.33 4.9 91.21-26.6 130.85M11328.7 4603.33c-14.7 2.45-19.2-24.72-18.7-34.48 1.6-31.61 40.7-50.4 28-85.46M11256.8 4353.6c-10.3-7.37-15.3 39.72-15.2 41.13 1.3 29.16 18.2 54.79 14.1 85.2M11294.2 4278.91c-19-18.97-70.9 6.84-61-39.4M11098.2 4447.71c-5.9 0 4.4 17.24 5.9 20.75 6 13.97 5.4 24.05-5.1 34.48M11552.3 4675.73c12.4 6.19 29.2-13.36 30.3-24.75 4.6-45.5-27.7-59.12 22.8-95.17M11405.9 4899.38c-29.9 19.87 16.2 60.74 23 76.41 10.3 23.95 2.4 50.88-1.9 74.93M11348 4977.93c-.6 1.65-25.7-5.72-38.9-.94-35.1 12.62-61.5 48.72-101 48.72M11430.9 4819.8c-5.7-3.8-2-5.24-9.6-8.27-44.5-17.8-65.6 42.14-104.2-15.73M11608.5 4950.1c-3.9 0 6.8-3.78 10.3-5.32 9.4-4.02 15.5-2.05 22.2 5.32 22.8 25.25 43.6 43.58 80.2 40.6M11573.7 5033.42c-7.8-1.65-6.7-7.71-16.6-5.85-28 5.24-39.3 52.18-79.9 56.43M11641.4 4824.7c-21.2-21.16-57.9-26.4-76.5-49.65M11785.9 4602.26c-1.9-1.91-.1-10.93-1.2-14.12-17.2-48.75 20.3-102.2 58.6-132.85M11834.6 4705.15c-13 7.82 45.1 16.55 63.1 8.12 36.8-17.19 44.8-51.89 72.8-76.82M11895.5 4746.58c5.4-23.97-47.5 42.2-50 56.97-6.5 39.03 41.3 56.96 8.2 94.64M11940.5 4746.58c-16.4-20.43 91.9-71.41 104.9-79.5M11941.1 4746.58c-6 12.08 32.9 15.57 40.6 21.82 20.9 16.89 38.5 55.53 68.3 32.33M11502.8 4151.39c0-7.35-7.5 13.01-4.6 23.41 5.7 20.49 16.8 38.02 13.8 60.45-.9 6.49-9.6 30.52-20.3 23.42M11500.5 4147.93c-35 5.53-53.5 16.12-82.9 40.47M11567.5 4111.98c-6.3 0-14.8-9.39-19.2-13.06-56.9-47.39-28.6-65.75-58-115.4M11638.3 4262.39c-8.8 8.81-20.2-9.42-21.6-15.43-4.8-20.75-12.3-54.28 6.7-69.9"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M11630 4262.53c10.9 12.69 37.4.82 50.6-1.33M11548.8 4332.31c-10.1-15.24-17.5-40.81-11.6-58.59 5.5-16.28 27.1-36.74 18-54.97M11551.9 4456.75c-3.1 3.09 1.6 27.17 1.3 31.96-1.4 21.82-13.5 40.25-21.4 60.02M11958 4192.66c-10.3-10.33-6-27.27-21.4-38.21-18.7-13.33-58.5-14.95-70.1-36.21M11966.7 4268.14c49.6 33.07 24.2 50.53 28.7 99.03M12177 4536.89c11.2 19.67 35.3-18.28 37-29.42 2.8-18.52-16.3-58.41-5.8-72M12283.4 4560.34c-7.7 13.62 15.8 41.56 16.6 57.49 1.4 27.97-17.8 51.46-24.9 77.35M12340.3 4537.82c8.5-30.54 42.8-47.49 71.7-52.57M12343.1 4537.03c35.8 15.75 71.1 66.33 115.6 45.79M12338.9 4393c-36 15.38-36 61.07-37.7 94.51"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M12336.9 4395.8c27.3 12.32 51.7 36.79 56.8 67.74M12330.1 4245.76c.6-11.12 22.8.53 33.1 4.79 31.1 12.88 46.1 48.88 76.4 31.96M12294.4 4180.12c-11.9-19.9-73.6 30.28-100.2 25.57M12093.4 3798.08c3.1-6.28 14.2-14.1 19.5-18.23 42.7-33.84 51.8 56.41 101.4 16.76M12138.5 3691.73c-14.3-39.33-88.1-42.26-58-99.73M12209.4 3878.62c0-19.56-45 6.25-55.8-7.19M12325.3 3877.02c-5.6-47.63-36.7-93.1-26.1-142.03M12287.9 3891.12c-17.4 5.81-9 64.82-6.8 78.81M12392.7 3844.8c54.8 38.21 46.7 54.17 43.5 112.09M12709.8 4081.36c64.3-42.86 17.6-77.99 70.9-120.61M12787.7 4163.09c32.4-50.31 32.6-132.15 98.2-147.48M12857.6 4174.93c-9.9 4.28-3.8 29.8-3.8 37.94 0 34.62 3.7 65.27-23.2 92.14M12917.3 4166.55c28.2-42.78 7.8-65.08 67.2-81.07"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M12915.8 4164.02s10.6.96 12.4 1.2c9.3 1.33 19 4.87 26.2 11.04 16.6 14.18 21.6 39.41 41.1 50.21M11981.5 3570.99c-4.4 1.09 7.4-5.3 10.2-8.78 6.4-7.85 8.9-15.81 7.7-25.84-2.9-25.78-19.2-68.75-.9-91.31M12086.2 3558.75c-1.2 2.52 5.6 1.19 8.4 1.46 10.5.9 22.9.96 32.9 4.79 18.5 7.08 19.3 30.14 31.9 43.26M13055 3788.23c-7.1 0 13-22.51 14.6-23.41 2.7-1.47 4.2-1.92 7.9-2.16 36.9-2.23 46.9-23.04 75.9-41.66M13053.4 3792.89c12.3 12.34 87 48.58 113 48.58M12938.6 3778.79c-2.8-11.28-20.6 26.44-22.3 31.02-13.2 35.76 12 75.88-23.6 103.82M12987.4 3786.1c-4.4-56.51 1.3-58.75 48.6-91.45M12877.7 3706.23c8.4-37.11 38.1-44.78 66.7-64.97M12787.7 3466.48c-2.8-5.48 9.3 8.03 14 12 7.1 6.04 13.7 12.32 20.3 18.89 20.8 20.46 46.4 16.68 73.4 14.9M12765 3571.12c-58.9-9.81-51.5-27.06-50-86.79M12840.8 3381.81c14.1-42.38 4.2-50.28 42.9-73.46M12838.8 3387c-4.5-4.52 12.7 2.13 18.8 4.02 9.9 3 19.3 7.37 29.2 10.51 31.7 10 57.1-9.08 83.8-23.05M12761.7 3317.53c-1.1-2.76-7.4-4.01-7.7-5.05-6.3-25.36 57.1-52.58 74.7-56.59"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M12756.7 3313.27c-5.9 26.61 42.5 16.23 69.9 7.19M12605.5 3322.98c-3.5-17.02 30.4-97.56 14.3-113.69M12537.3 3358.8c-28 35.97 57.4 52.55 36.6 101.82M12324.4 4268.14c-1.8 2.42-19.5-5.06-23.4-5.19-14.4-.56-30.3 7.58-43.3 12.9-21 8.6-39.5 47.2-62.5 35.68"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M8744.08 886.55s-68.79-276.148-69.73-356.212c-.63-54.161 43.54-165.091 43.54-165.091s-10.98 144.841-2.52 213.377c10.74 86.911 61.47 279.754 61.47 279.754zM9371.5 2213.99s277.5 63.11 357.57 62.41c54.16-.48 164.16-46.92 164.16-46.92s-144.58 13.96-213.28 6.9c-87.11-8.95-280.96-55.72-280.96-55.72z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.589}
      d="M8629.07 2306.08s-502.38-194.88-651.5-233.71c-100.87-26.28-330.25 8.28-330.25 8.28s291.35 33.67 415.16 81.8c157 61.04 544.31 230.92 544.31 230.92z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M8978.17 2306.13s475.74-183.11 615.16-224.21c94.32-27.81 299.9-25.33 299.9-25.33s-255.68 57.79-372.94 102.99c-148.68 57.32-519.2 240.93-519.2 240.93z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.376}
      d="M8460.41 1404.65s-127.22 168.85-175.8 202.89c-32.86 23.03-128.15 34.53-128.15 34.53s95.69-51.64 132.56-86.79c46.75-44.58 133.94-164.61 133.94-164.61z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.867}
      d="M8731.25 1373.57s-507.18-51.26-652.5-54.17c-98.31-1.97-295.97 54.61-295.97 54.61s261.87-11.64 386.89 1.06c158.54 16.11 564.34 95.59 564.34 95.59z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M10306.7 977.035s205.8-102.122 268-119.997c42.1-12.095 134.3-8.802 134.3-8.802s-114.2 24.516-166.4 44.547c-66.2 25.405-209.6 98.383-209.6 98.383z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.672}
      d="M9202.19 913.318s-183.52-38.257-231.54-60.125c-32.48-14.79-86.59-70.856-86.59-70.856s83.4 46.742 126.6 61.117c54.78 18.227 183.68 43.417 183.68 43.417zM8198.49 1377.63s-132.73 132.39-177.37 160.52c-30.19 19.03-106.76 33.48-106.76 33.48s84.86-44.05 120.58-72.27c45.31-35.78 137.13-129.69 137.13-129.69zM9656.31 1191.81s141.67 122.79 188.16 147.72c31.45 16.87 108.84 25.93 108.84 25.93s-87.73-38.01-125.34-63.65c-47.7-32.53-145.86-119.78-145.86-119.78zM9208.52 1805.72s141.67-122.79 188.16-147.73c31.45-16.87 108.84-25.92 108.84-25.92s-87.73 38-125.34 63.65c-47.7 32.52-145.86 119.78-145.86 119.78zM9176.93 836.012s95.43-161.366 111.64-211.577c10.96-33.965 6.01-111.723 6.01-111.723s-21.68 93.117-40.17 134.717c-23.46 52.753-91.72 164.955-91.72 164.955z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M9686.75 611.395s112.36-200.356 133.35-261.572c14.2-41.41 15.56-133.703 15.56-133.703s-30.24 112.828-52.88 163.969c-28.71 64.852-108.81 204.324-108.81 204.324z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.635}
      d="M10046.3 620.041s279.1-46.876 353.8-75.597c50.6-19.424 140.3-92.718 140.3-92.718s-130.6 63.734-197.4 81.198c-84.7 22.143-282.6 46.266-282.6 46.266z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M8763.81 1803.28s315.43-13.33 420.45-8.19c71.05 3.46 209.75 38.98 209.75 38.98s-188.1-17.2-279.14-16.81c-115.46.5-413.62 19.81-413.62 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.982}
      d="M9288.88 1182.95s-151.48-380.008-176.71-496.641c-17.05-78.843-45.1-335.532-45.1-335.532s68.86 268.373 96.5 367.883c35.05 126.191 182.71 430.06 182.71 430.06zM8636.46 1244.28s163.3-382.104 192.13-499.855c19.49-79.599 55.46-339.361 55.46-339.361s-77.17 270.706-107.89 371.034c-38.96 127.228-196.09 432.182-196.09 432.182z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.999}
      d="M9323.12 1191.4s315.43-13.33 420.45-8.19c71.05 3.47 209.75 38.98 209.75 38.98s-188.1-17.2-279.14-16.81c-115.46.5-413.62 19.81-413.62 19.81z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M9746.07 829.864s-105.46-254.276-129.36-342.819c-16.16-59.896-14.04-188.485-14.04-188.485s33.41 161.827 59.8 236.624c33.47 94.85 127.41 300.145 127.41 300.145z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.844}
      d="M8353.28 668.82s162.89-161.962 199.83-215.099c24.99-35.944 51.55-124.343 51.55-124.343s-59.96 100.247-95.73 143.242c-45.36 54.521-160.57 166.749-160.57 166.749z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.899}
      d="M8346.76 924.324s-31.86-273.429-30.61-365.131c.84-62.033 38.07-185.133 38.07-185.133s-12.15 164.791-7.23 243.955c6.24 100.389 44.66 358.379 44.66 358.379z"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M8584 3039h148s-177.71-699.7 18.72-1151.04C8958.25 1374.81 9754.53 861.478 9846 801.5s172.6 121.178 297.7 153.795c247.1 64.405 565.3 104.965 565.3 104.965s-324.1-48.84-550.3-139.453c-107-42.876-200.85-116.98-222.2-160.807-22.43-46.027 95.9-101.407 144.9-182.9 96.3-160.097 209.3-299.565 204.8-304.06s-231.4 266.718-371.89 403.355C9644.4 938.801 8907.09 1313.34 8696.74 1829.48 8521.31 2214.84 8596.33 2302.76 8584 3039"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.87}
      d="M9047.5 3039h-120s64.66-830.16-53.8-1185.53c-167.91-503.75-483.37-846.7-694.13-1009.141-49.6-38.221-51.51 21.64-133.82 54.257-162.52 64.402-272.67-57.256-272.67-57.256s287.78 79.472 331.52-56.979c14.76-46.028-77.75-158.937-138.35-222.251-84.34-88.123-83.71-157.047-83.71-157.047s174.47 152.694 266.92 289.331c177.56 262.406 669.04 605.456 807.42 1121.596 149.29 556.8 60.38 489.28 90.62 1223.02"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9887.26 1350.99 132.44-68.52s-53.4-9.23-81.74 3.29-50.7 65.23-50.7 65.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9886.87 1351.58 132.83-67.73s-23.88 48.95-50.59 64.7c-26.7 15.74-82.24 3.03-82.24 3.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9363.16 1848.66 132.47-68.52s-53.43-9.23-81.77 3.29c-28.35 12.52-50.7 65.23-50.7 65.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9362.77 1849.24 132.87-67.73s-23.93 48.95-50.63 64.7c-26.71 15.75-82.24 3.03-82.24 3.03"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9413.45 1653.16 82.18 89.94s-4.07-44.1-19.96-63.8c-15.89-19.69-62.22-26.14-62.22-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9412.9 1652.98 81.64 90.43s-43.69-8.48-61.79-26.2c-18.09-17.72-19.85-64.23-19.85-64.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9434.47 1662.35 122.78-20.06s-39.98-21.14-65.69-18.55c-25.72 2.59-57.09 38.61-57.09 38.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9434.02 1662.71 122.89-19.32s-31.64 32.63-56.89 38.2c-25.26 5.58-66-18.88-66-18.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9342.3 1823.78 42.79 120.93s14.16-44.44 6.82-70.06c-7.33-25.62-49.61-50.87-49.61-50.87"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9341.85 1823.38 42.07 121.18s-38.9-26.15-49.17-50.76c-10.28-24.6 7.1-70.42 7.1-70.42"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9874.08 1353.74 45.76-141.96s-44.43 31.09-55.72 59.94c-11.3 28.85 9.96 82.02 9.96 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9874.22 1354.42 46.6-141.67s17.5 51.6 9.64 81.59-56.24 60.08-56.24 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10339.1 998.653-155.6 73.857s61.3 12.76 94.5-.56c33.2-13.33 61.1-73.297 61.1-73.297"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10339.6 997.996-156.1 72.924s29.6-55.56 61-72.678c31.5-17.121 95.1-.246 95.1-.246"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9065.24 1800.47 87.31-120.91s-51.84 15.86-71.49 39.82c-19.65 23.95-15.82 81.09-15.82 81.09"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9065.15 1801.16 88.04-120.38s.73 54.48-16 80.58-72.04 39.8-72.04 39.8"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9796.13 2053.7 82.18 89.94s-4.06-44.1-19.96-63.8c-15.89-19.7-62.22-26.14-62.22-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9795.59 2053.51 81.64 90.43s-43.69-8.48-61.79-26.2c-18.09-17.72-19.85-64.23-19.85-64.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9306.41 1746.1 122.78-20.05s-39.98-21.15-65.69-18.56c-25.72 2.6-57.09 38.61-57.09 38.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9305.95 1746.46 122.9-19.32s-31.64 32.63-56.9 38.2c-25.25 5.58-66-18.88-66-18.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="M9556.05 2216.74 9479.93 2320s44.72-13.21 61.83-33.65c17.1-20.43 14.29-69.61 14.29-69.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9556.13 2216.14-76.74 102.79s-.16-46.86 14.45-69.17c14.61-22.3 62.29-33.62 62.29-33.62"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9167.91 2303.72-76.13 103.25s44.73-13.21 61.83-33.64c17.1-20.44 14.3-69.61 14.3-69.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9167.98 2303.11-76.74 102.8s-.16-46.87 14.45-69.18c14.61-22.3 62.29-33.62 62.29-33.62"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9273.1 1765.47 45.75-141.96s-44.42 31.09-55.72 59.94 9.97 82.02 9.97 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9273.23 1766.15 46.6-141.67s17.5 51.6 9.64 81.59-56.24 60.08-56.24 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9065.74 1819.39 127.05 116.3s-11.27-61.59-36.13-87.33-90.92-28.97-90.92-28.97"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9064.95 1819.2 126.35 117.06s-62.59-6.44-90.3-29.12c-27.71-22.67-36.05-87.94-36.05-87.94"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9404.55 1652.27 90.49-118.55s-52.25 14.48-72.53 37.91c-20.27 23.43-17.96 80.64-17.96 80.64"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9404.44 1652.96 91.2-118.01s-.72 54.49-18.14 80.13c-17.41 25.65-73.06 37.88-73.06 37.88"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9711.86 537.094 147.54 21.754s-37.97-38.698-68.29-45.092-79.25 23.338-79.25 23.338"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9711.2 537.34 147.41 22.637s-48.01 25.757-78.89 22.941c-30.87-2.816-68.52-45.578-68.52-45.578"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9803.95 335.989 120.77-16.046s-38.51-21.866-63.76-20.08-57.01 36.126-57.01 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9803.49 336.332 120.86-15.324s-31.92 31.012-56.8 35.733c-24.89 4.721-64.06-20.409-64.06-20.409"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9542.44 561.782 120.77-16.046s-38.52-21.867-63.77-20.08c-25.24 1.787-57 36.126-57 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9541.98 562.124 120.86-15.323s-31.93 31.012-56.81 35.733-64.05-20.41-64.05-20.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9821.64 271.424 53.7-112.221s-40.19 20.726-52.76 43.31-.94 68.911-.94 68.911"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9821.68 272.003 54.37-111.895s8.69 44.611-1.16 68.521c-9.86 23.91-53.21 43.374-53.21 43.374"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9710.49 701.902 9570.78 649.7s29.02 45.8 57.33 58.406c28.3 12.607 82.38-6.204 82.38-6.204"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9711.19 701.8-139.4-53.035s52.35-15.12 81.95-5.894 57.45 58.929 57.45 58.929"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9749.9 489.047 53.7-112.221s-40.2 20.726-52.77 43.31c-12.56 22.584-.93 68.911-.93 68.911"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9749.93 489.63 54.37-111.895s8.69 44.611-1.16 68.521-53.21 43.374-53.21 43.374"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9755.97 489.344-90.35-118.663s.13 54.219 17.35 79.977c17.22 25.757 73 38.686 73 38.686"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9756.61 489.621-89.63-119.198s52.34 15.125 72.46 38.713c20.12 23.587 17.17 80.485 17.17 80.485"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9657.08 549.428-120.42-87.995s15.57 51.935 39.42 71.718c23.85 19.782 81 16.277 81 16.277"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9657.78 549.516-119.89-88.712s54.48-.419 80.49 16.457 39.4 72.255 39.4 72.255"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9798.15 342.772-45.58-142.008s-17.97 51.155-10.33 81.182c7.63 30.027 55.91 60.826 55.91 60.826"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9798.66 343.254-44.73-142.274s44.3 31.722 55.39 60.671c11.1 28.949-10.66 81.603-10.66 81.603"
      clipRule="evenodd"
    />
    <path
      fill="#736144"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.571}
      d="M8111.97 2126.46s-109.96-220.07-164.78-281.2c-37.07-41.36-150.99-92.47-150.99-92.47s109.75 101.23 150.27 159.22c51.37 73.54 144.51 250.44 144.51 250.44s20.99-4.5 25.49-11.99c4.5-7.5-4.5-24-4.5-24"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7894.98 1819.25 112.15-72.06s-16.68 45.5-39.01 61.88c-22.34 16.37-73.14 10.18-73.14 10.18"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7894.35 1819.29 111.72-72.73s-48.59-3.29-72.7 10.37c-24.11 13.67-39.02 62.36-39.02 62.36"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7980.93 1904.37 132.88 10.59s-40.83 26.11-68.52 25.61c-27.69-.51-64.36-36.2-64.36-36.2"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7980.41 1904.02 132.94 9.8s-36.67-32.05-64.13-35.78-68.81 25.98-68.81 25.98"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7819.15 1773.3-108.67 55.08s19.39-39.82 41.22-52.63c21.83-12.8 67.45-2.45 67.45-2.45"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7819.72 1773.33-108.33 55.73s43.87 7.51 67.06-2.67 41.27-53.06 41.27-53.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7818.3 1766.33-107.77-62.17s44.88-5.64 68.01 5.87c23.14 11.52 39.76 56.3 39.76 56.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7818.6 1766.83-108.13-61.52s18.06 41.7 39.71 55.85c21.65 14.14 68.42 5.67 68.42 5.67"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m7929.95 1873.01-89.33 105.74s2.67-50.25 19.84-73.32c17.17-23.06 69.49-32.42 69.49-32.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m7930.55 1872.78-88.69 106.27s49.23-11.56 68.99-32.48c19.76-20.91 19.7-73.79 19.7-73.79"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7897.68 1839.54-124.1 8.84s34.02-29.8 59.64-33.22 64.46 24.38 64.46 24.38"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7898.21 1839.79-124.04 9.58s38.33 24.44 64.18 24.03c25.86-.4 59.86-33.61 59.86-33.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7901.41 1814.25-7.39-148.96s-30.56 44.78-30.93 75.76c-.37 30.99 38.32 73.2 38.32 73.2"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7901.78 1814.84-6.49-148.99s34.61 42.08 37.85 72.91c3.25 30.83-31.36 76.08-31.36 76.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7821.31 1773.86-42.74-142.89s43.75 32.02 54.44 61.1c10.68 29.08-11.7 81.79-11.7 81.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7821.16 1774.55-43.59-142.63s-18.59 51.22-11.37 81.37c7.23 30.14 54.96 61.26 54.96 61.26"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7938.67 1878.29 16.16 123.35s-31.76-32.19-36.69-57.56c-4.92-25.38 20.53-65.79 20.53-65.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7938.89 1877.75 16.89 123.25s22.13-39.7 20.2-65.49-37.09-57.76-37.09-57.76"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7913.12 2039.19 124.25-6.28s-37.38-25.46-63.22-25.74c-25.85-.29-61.03 32.02-61.03 32.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7912.62 2039.5 124.28-5.54s-35.07 28.91-60.78 31.64c-25.72 2.74-63.5-26.1-63.5-26.1"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8085.54 2111.52 102.16-108.65s-5.74 53.91-25.54 77.75c-19.8 23.83-76.62 30.9-76.62 30.9"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8084.87 2111.74 101.51-109.26s-53.63 9.61-76.09 30.98c-22.45 21.38-25.42 78.28-25.42 78.28"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8038.69 2001.86 120.64-30.73s-28.21 35.39-52.83 43.3c-24.63 7.91-67.81-12.57-67.81-12.57"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8038.13 2001.71 120.45-31.44s-42.08-17.27-67.47-12.28-52.98 43.72-52.98 43.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7981.98 1905.42 83.55-123.54s2.91 54.14-12.83 80.82c-15.75 26.68-70.72 42.72-70.72 42.72"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7981.36 1905.74 82.8-124.04s-51.42 18.04-70.18 42.72-12.62 81.32-12.62 81.32"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9861.36 1341.7 82.18 89.94s-4.07-44.1-19.96-63.8-62.22-26.14-62.22-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9860.82 1341.52 81.64 90.43s-43.7-8.48-61.79-26.2-19.85-64.23-19.85-64.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9751.5 1194.34 46.83-115.26s-38.88 23.12-50.06 46.42 3.23 68.84 3.23 68.84"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9751.57 1194.92 47.51-114.97s11.37 44 2.98 68.46c-8.39 24.47-50.49 46.51-50.49 46.51"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9694.82 1212.19 42.8 120.93s14.15-44.44 6.82-70.06c-7.34-25.62-49.62-50.87-49.62-50.87"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9694.37 1211.79 42.07 121.18s-38.89-26.14-49.17-50.75c-10.27-24.61 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9945.74 1232.07 45.75-141.95s-44.42 31.08-55.72 59.93 9.97 82.02 9.97 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9945.87 1232.76 46.6-141.67s17.53 51.6 9.63 81.59c-7.85 29.98-56.23 60.08-56.23 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9724.83 2265.28 141.54-98.16s-62.56-2.63-93.16 15.91c-30.6 18.55-48.38 82.25-48.38 82.25"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9724.47 2266.01 142.12-97.32s-20.13 59.62-48.38 81.63c-28.24 22-93.74 15.69-93.74 15.69"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10230.1 946.749 132.5-68.528s-53.4-9.228-81.8 3.292c-28.3 12.519-50.7 65.236-50.7 65.236"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10229.8 947.335 132.8-67.732s-23.9 48.952-50.6 64.7-82.2 3.032-82.2 3.032"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9534.75 1195.13 82.18 89.94s-4.06-44.1-19.96-63.8c-15.89-19.7-62.22-26.14-62.22-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9534.21 1194.95 81.64 90.42s-43.7-8.47-61.79-26.2c-18.09-17.72-19.85-64.22-19.85-64.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10569.5 870.357 54.3-111.912s-40.3 20.496-53 43.007c-12.7 22.512-1.3 68.905-1.3 68.905"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10569.5 870.94 55-111.581s8.4 44.66-1.5 68.513c-10 23.853-53.5 43.068-53.5 43.068"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9884.99 1091.82 42.8 120.94s14.15-44.44 6.82-70.06-49.62-50.88-49.62-50.88"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9884.54 1091.43 42.07 121.18s-38.89-26.15-49.17-50.75c-10.27-24.61 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9475.82 1336.88 45.75-141.95s-44.43 31.09-55.72 59.94c-11.3 28.85 9.97 82.01 9.97 82.01"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9475.95 1337.57 46.6-141.67s17.5 51.6 9.64 81.59-56.24 60.08-56.24 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10343.1 996.144 55.6 163.026s19.6-59.45 10.2-93.96c-9.5-34.51-65.8-69.066-65.8-69.066"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10342.5 995.605 54.6 163.345s-51.8-35.7-65.3-68.89c-13.4-33.2 10.7-94.455 10.7-94.455"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10510.5 1027.21 39.1 143.93s20.3-50.29 14-80.63-53.1-63.3-53.1-63.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10510 1026.71 38.2 144.16s-42.8-33.7-52.6-63.12c-9.7-29.42 14.4-81.04 14.4-81.04"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9556.8 2131.75 108.99 54.44s-19.63-39.71-41.53-52.39c-21.91-12.67-67.46-2.05-67.46-2.05"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9556.23 2131.77 108.66 55.09s-43.82 7.77-67.07-2.27-41.59-52.82-41.59-52.82"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10232.6 947.786-33.3-119.871s-16.7 42.043-11.3 67.323c5.3 25.28 44.6 52.548 44.6 52.548"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10233 948.201-32.6-120.065s35.9 27.907 44.2 52.402c8.2 24.496-11.6 67.663-11.6 67.663"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8992.68 1819.58 42.8 120.93s14.15-44.43 6.82-70.05c-7.33-25.63-49.62-50.88-49.62-50.88"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8992.23 1819.18 42.07 121.19s-38.89-26.15-49.16-50.76c-10.28-24.6 7.09-70.43 7.09-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9630.22 1207.63 45.75-141.96s-44.42 31.09-55.72 59.94 9.97 82.02 9.97 82.02"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9630.35 1208.31 46.6-141.67s17.5 51.6 9.64 81.59-56.24 60.08-56.24 60.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10476.9 1015.98 140.7-99.347s-62.6-2.107-93 16.698c-30.5 18.805-47.7 82.649-47.7 82.649"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10476.5 1016.71 141.3-98.506s-19.6 59.786-47.7 82.026c-28 22.24-93.6 16.48-93.6 16.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9551.23 2216.37 120.14 123.44s-7.71-62.14-31.04-89.27c-23.34-27.13-89.1-34.17-89.1-34.17"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9550.46 2216.14 119.39 124.15s-62.12-10.04-88.48-34.28c-26.35-24.23-30.91-89.87-30.91-89.87"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9375.54 2216.91-28.22 169.92s45.48-43.04 53.5-77.91-25.28-92.01-25.28-92.01"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9375.27 2216.14-29.24 169.74s-28.73-55.98-24.83-91.57 54.07-78.17 54.07-78.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9527.4 1207.27 69.9-131.76s-49.18 22.83-65.35 49.26c-16.18 26.43-4.55 82.5-4.55 82.5"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9527.42 1207.96 70.68-131.32s8.19 53.86-4.8 82.01-65.88 49.31-65.88 49.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10195.2 569.524 111.6 131.255s-3.5-62.521-25-91.16c-21.4-28.638-86.6-40.095-86.6-40.095"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10194.5 569.24 110.7 131.916s-61.3-14.202-86-40.159c-24.6-25.957-24.7-91.757-24.7-91.757"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9194.44 2245.61 78.85-126.6s-50.65 19.37-68.61 44.61c-17.96 25.25-10.24 81.99-10.24 81.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9194.41 2246.31 79.6-126.13s4.45 54.31-10.46 81.49c-14.91 27.19-69.14 44.64-69.14 44.64"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9837.55 2235.37 108.78 60.35s-18.27-41.37-40.05-55.27c-21.79-13.91-68.73-5.08-68.73-5.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9836.96 2235.37 108.43 61s-45.06 5.99-68.33-5.28-40.1-55.72-40.1-55.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9156.17 2303.87 158.04 68.51s-30.75-54.55-62.64-70.77c-31.9-16.22-95.4 2.26-95.4 2.26"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9155.37 2303.95 157.62 69.46s-61.28 14.32-94.87 1.92-62.75-71.38-62.75-71.38"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10603.7 1044.65 64.5 134.5s10.8-53.12-.8-81.83c-11.7-28.72-63.7-52.67-63.7-52.67"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10603.2 1044.24 63.6 134.88s-48.2-25.41-63.1-52.58c-15-27.18-.5-82.3-.5-82.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m10512.6 750.606 59 120.3s9.3-47.812-1.4-73.51c-10.7-25.697-57.6-46.79-57.6-46.79"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10512.1 750.252 58.2 120.647s-43.5-22.432-57.1-46.721-1.1-73.926-1.1-73.926"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9196.48 2242.06-26.65-121.52s-18.96 41.06-14.98 66.6c3.97 25.53 41.63 54.92 41.63 54.92"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9196.87 2242.5-25.92-121.68s34.28 29.84 41.21 54.75c6.93 24.92-15.29 66.93-15.29 66.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9692.39 2150.35 42.8 120.93s14.15-44.44 6.82-70.06-49.62-50.87-49.62-50.87"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9691.94 2149.95 42.07 121.18s-38.89-26.15-49.17-50.75c-10.27-24.61 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9737.37 1948.26 42.8 120.93s14.15-44.43 6.82-70.05c-7.33-25.63-49.62-50.88-49.62-50.88"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9736.92 1947.86 42.07 121.19s-38.89-26.15-49.17-50.76c-10.27-24.6 7.1-70.43 7.1-70.43"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10602.3 1046.37 159.9-64.013s-60.4-16.562-94.4-5.33-65.5 69.343-65.5 69.343"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10601.7 1047 160.3-63.056s-32.9 53.606-65.4 68.736c-32.4 15.12-94.9-5.68-94.9-5.68"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9772.02 1281.31c-25.86 1.94-45.53 20.81-43.93 42.15 1.61 21.33 23.87 37.05 49.74 35.1 25.86-1.94 45.53-20.81 43.92-42.14-1.6-21.34-23.87-37.06-49.73-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9739.12 1337.75s-8.79-21.77.88-30.73c12.56-11.63 29.2-2.14 29.2-2.14-8.35 1.38-17.86 1.64-22.69 7.26-5.28 6.15-5.56 17.92-7.39 25.61"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9770.02 1332.59s9.81 3.26 10.47 4.29c4.25 6.76 5.92 8.23 5.92 8.23s-9.7 3.33-14.26 2.73c-4.57-.6-9.49-3.83-9.49-3.83s.17 5.32-1.08 7.15c-1.5 2.18-7.89 5.93-7.89 5.93s-5.71-4.29-6.83-7.14c-1.16-2.93 5.01-9.06 5.01-9.06s-5.65.76-8.98-1.01c-3.46-1.84-8.14-7.53-8.14-7.53s4.6-3.71 7.97-4.14c3.21-.4 12.68 1.56 12.68 1.56s-6.36-4.65-8.48-8.08c-2.19-3.58 4.42-9.51 4.42-9.51s7.16 4.08 10.5 7.32c2.55 2.48.42 8.3.42 8.3s2.75-6.01 5.82-8.1c3.07-2.1 11.11-1.57 11.11-1.57s2.52 7.3.74 10.2c-1.69 2.74-9.91 4.26-9.91 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9761.29 1343.6c1.39-.11 3.8.29 4.74-.39.97-.68 2.11-2.85 2.4-4.1.76-3.31.7-5.7-2.53-7.95-1.18-.8-3.39-.04-4.61.05-.66.05-1.48 0-2.12.16-2.5.6-4.4 2.38-5.96 4.03-.64.67-1.22 2.17-.62 3.03.54.77 1.44 1.48 1.93 2.32.65 1.1 1.75 3.35 3.34 3.85 1.06.34 1.45-.43 2.17-.69.77-.27.32-.05 1.26-.31"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M9861.15 1193.67c-22.14 1.66-38.97 17.82-37.6 36.08 1.37 18.25 20.43 31.71 42.56 30.04 22.14-1.66 38.97-17.81 37.6-36.07s-20.43-31.71-42.56-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9832.98 1241.98s-7.51-18.64.76-26.3c10.75-9.96 24.99-1.84 24.99-1.84-7.15 1.18-15.28 1.41-19.42 6.21-4.52 5.27-4.76 15.35-6.33 21.93"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9859.43 1237.56s8.4 2.79 8.96 3.68c3.64 5.78 5.07 7.04 5.07 7.04s-8.3 2.85-12.2 2.33c-3.91-.51-8.13-3.28-8.13-3.28s.15 4.56-.92 6.13c-1.28 1.86-6.75 5.07-6.75 5.07s-4.89-3.67-5.85-6.11c-.99-2.51 4.29-7.75 4.29-7.75s-4.83.65-7.69-.87c-2.96-1.57-6.96-6.44-6.96-6.44s3.93-3.18 6.82-3.54c2.75-.35 10.85 1.33 10.85 1.33s-5.44-3.98-7.25-6.92c-1.88-3.06 3.78-8.13 3.78-8.13s6.12 3.49 8.98 6.26c2.19 2.12.37 7.1.37 7.1s2.35-5.14 4.98-6.93c2.62-1.79 9.5-1.34 9.5-1.34s2.16 6.25.64 8.72c-1.45 2.35-8.49 3.65-8.49 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M9851.97 1246.98c1.18-.09 3.24.25 4.05-.33.83-.59 1.81-2.44 2.05-3.51.66-2.83.61-4.88-2.16-6.8-1.01-.69-2.9-.04-3.94.04-.58.05-1.27 0-1.82.14-2.14.51-3.77 2.03-5.1 3.44-.55.58-1.04 1.86-.53 2.6.46.66 1.23 1.26 1.65 1.98.56.95 1.5 2.87 2.86 3.3.9.29 1.24-.37 1.85-.59.66-.23.28-.04 1.09-.27"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M9168.57 1808.68c-22.14 1.67-38.97 17.82-37.6 36.08s20.43 31.71 42.57 30.05c22.13-1.67 38.97-17.82 37.59-36.08-1.37-18.26-20.43-31.71-42.56-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9140.41 1856.99s-7.52-18.64.76-26.3c10.74-9.96 24.98-1.83 24.98-1.83-7.14 1.18-15.28 1.4-19.42 6.21-4.52 5.26-4.76 15.34-6.32 21.92"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9166.86 1852.58s8.39 2.78 8.95 3.67c3.64 5.79 5.08 7.04 5.08 7.04s-8.3 2.85-12.21 2.34c-3.91-.52-8.13-3.28-8.13-3.28s.15 4.55-.92 6.12c-1.28 1.87-6.75 5.08-6.75 5.08s-4.89-3.68-5.85-6.11c-.99-2.51 4.29-7.76 4.29-7.76s-4.83.65-7.69-.86c-2.96-1.58-6.96-6.44-6.96-6.44s3.93-3.18 6.82-3.55c2.75-.35 10.85 1.33 10.85 1.33s-5.44-3.98-7.25-6.91c-1.88-3.06 3.78-8.14 3.78-8.14s6.13 3.49 8.98 6.27c2.19 2.12.37 7.1.37 7.1s2.35-5.15 4.98-6.94 9.5-1.34 9.5-1.34 2.16 6.25.64 8.73c-1.45 2.35-8.48 3.65-8.48 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M9159.39 1861.99c1.18-.09 3.24.26 4.05-.32.83-.59 1.81-2.45 2.05-3.52.66-2.83.61-4.88-2.16-6.8-1.01-.69-2.9-.03-3.94.05-.57.04-1.27 0-1.82.13-2.14.51-3.76 2.03-5.1 3.45-.55.57-1.04 1.85-.53 2.59.46.66 1.23 1.27 1.65 1.99.56.94 1.5 2.86 2.86 3.29.9.29 1.24-.37 1.85-.58.66-.24.28-.05 1.09-.28"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9304.58 1822.41c-25.86 1.95-45.53 20.82-43.93 42.15 1.61 21.34 23.87 37.06 49.74 35.11 25.86-1.94 45.53-20.81 43.93-42.15-1.61-21.33-23.87-37.05-49.74-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9271.68 1878.86s-8.79-21.78.89-30.73c12.55-11.64 29.19-2.15 29.19-2.15-8.35 1.38-17.86 1.64-22.69 7.26-5.28 6.15-5.56 17.93-7.39 25.62"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9302.58 1873.7s9.81 3.26 10.47 4.29c4.25 6.76 5.93 8.23 5.93 8.23s-9.7 3.33-14.27 2.73c-4.56-.6-9.49-3.83-9.49-3.83s.17 5.32-1.08 7.15c-1.5 2.18-7.89 5.93-7.89 5.93s-5.71-4.29-6.83-7.14c-1.16-2.93 5.01-9.06 5.01-9.06s-5.65.76-8.98-1.01c-3.46-1.84-8.14-7.53-8.14-7.53s4.6-3.71 7.97-4.14c3.21-.41 12.68 1.56 12.68 1.56s-6.36-4.65-8.47-8.08c-2.2-3.58 4.41-9.51 4.41-9.51s7.16 4.08 10.5 7.32c2.55 2.48.43 8.3.43 8.3s2.74-6.01 5.81-8.1c3.08-2.1 11.11-1.57 11.11-1.57s2.52 7.3.74 10.2c-1.69 2.74-9.91 4.26-9.91 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9293.86 1884.7c1.38-.1 3.79.3 4.73-.38.97-.69 2.11-2.86 2.4-4.11.76-3.31.71-5.7-2.53-7.95-1.18-.8-3.39-.03-4.61.06-.66.05-1.48 0-2.12.16-2.5.59-4.4 2.37-5.96 4.02-.64.67-1.21 2.17-.61 3.03.53.77 1.43 1.48 1.92 2.32.66 1.11 1.75 3.35 3.34 3.85 1.06.34 1.45-.43 2.17-.68.77-.27.32-.05 1.27-.32"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9890.52 1355.67c24.34-2.7 42.25-21.16 40.02-41.23s-23.76-34.15-48.09-31.45c-24.33 2.71-42.25 21.17-40.02 41.24s23.76 34.15 48.09 31.44"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9889.67 1306.12s-9.36-2.74-10.01-3.69c-4.24-6.24-5.87-7.57-5.87-7.57s9.03-3.46 13.36-3.05c4.33.42 9.08 3.3 9.08 3.3s-.34-5.02.78-6.79c1.34-2.11 7.24-5.86 7.24-5.86s5.54 3.86 6.69 6.51c1.19 2.72-4.43 8.71-4.43 8.71s5.3-.9 8.51.65c3.33 1.63 7.93 6.83 7.93 6.83s-4.21 3.66-7.38 4.17c-3.02.5-12.01-1.04-12.01-1.04s6.16 4.17 8.26 7.34c2.19 3.3-3.84 9.11-3.84 9.11s-6.89-3.6-10.15-6.55c-2.49-2.25-.68-7.81-.68-7.81s-2.39 5.76-5.22 7.84c-2.82 2.08-10.42 1.85-10.42 1.85s-2.62-6.8-1.04-9.59c1.5-2.65 9.2-4.36 9.2-4.36"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9879.43 1345.48s-22.12 1.52-27.32-9.78c-6.77-14.67 6.61-26.83 6.61-26.83-1.2 7.9-3.75 16.51-.12 22.49 3.97 6.54 14.46 10.23 20.83 14.12"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9898.55 1296.56c-1.31.14-3.59-.15-4.46.52-.89.68-1.89 2.76-2.12 3.95-.61 3.15-.48 5.4 2.65 7.41 1.14.72 3.2-.08 4.34-.2.63-.07 1.4-.05 2-.22 2.34-.65 4.07-2.39 5.49-4 .58-.65 1.07-2.09.48-2.88-.54-.71-1.41-1.35-1.9-2.12-.65-1.02-1.76-3.1-3.28-3.52-1.01-.29-1.35.45-2.02.72-.72.28-.3.06-1.18.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9695.61 1201.3c24.34-2.71 42.25-21.17 40.02-41.24s-23.76-34.15-48.09-31.44c-24.33 2.7-42.25 21.16-40.02 41.23s23.76 34.15 48.09 31.45"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9694.76 1151.75s-9.36-2.74-10.01-3.7c-4.24-6.23-5.87-7.56-5.87-7.56s9.03-3.47 13.36-3.06c4.33.42 9.08 3.3 9.08 3.3s-.34-5.01.78-6.78c1.34-2.11 7.24-5.87 7.24-5.87s5.54 3.86 6.69 6.51c1.19 2.73-4.43 8.72-4.43 8.72s5.3-.91 8.51.65c3.32 1.62 7.93 6.82 7.93 6.82s-4.21 3.66-7.38 4.18c-3.02.49-12.01-1.04-12.01-1.04s6.16 4.17 8.26 7.34c2.19 3.29-3.84 9.11-3.84 9.11s-6.89-3.61-10.15-6.55c-2.49-2.26-.68-7.82-.68-7.82s-2.39 5.77-5.22 7.84c-2.82 2.08-10.42 1.85-10.42 1.85s-2.62-6.8-1.04-9.59c1.5-2.64 9.2-4.35 9.2-4.35"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9684.52 1191.11s-22.12 1.51-27.32-9.79c-6.77-14.67 6.61-26.82 6.61-26.82-1.2 7.89-3.75 16.5-.12 22.48 3.97 6.54 14.46 10.23 20.83 14.13"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9703.64 1142.18c-1.31.15-3.59-.15-4.46.52-.89.68-1.89 2.77-2.12 3.96-.61 3.14-.48 5.4 2.65 7.41 1.14.72 3.2-.08 4.34-.21.63-.07 1.4-.05 2-.22 2.34-.64 4.07-2.38 5.49-4 .58-.65 1.07-2.08.48-2.88-.54-.7-1.41-1.34-1.9-2.12-.65-1.02-1.76-3.1-3.28-3.52-1.01-.28-1.35.46-2.02.72-.72.28-.3.06-1.18.34"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9449.62 1651.93c24.33-2.71 42.24-21.17 40.01-41.24s-23.76-34.14-48.09-31.44-42.25 21.16-40.02 41.23 23.77 34.15 48.1 31.45"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9448.76 1602.38s-9.36-2.74-10.01-3.69c-4.24-6.24-5.87-7.57-5.87-7.57s9.04-3.47 13.36-3.05c4.33.41 9.09 3.3 9.09 3.3s-.35-5.02.77-6.79c1.34-2.11 7.24-5.86 7.24-5.86s5.54 3.86 6.69 6.51c1.19 2.72-4.43 8.71-4.43 8.71s5.31-.91 8.51.65c3.33 1.62 7.93 6.83 7.93 6.83s-4.21 3.66-7.38 4.17c-3.02.5-12.01-1.04-12.01-1.04s6.16 4.17 8.27 7.34c2.19 3.3-3.85 9.11-3.85 9.11s-6.89-3.6-10.15-6.55c-2.49-2.25-.68-7.81-.68-7.81s-2.39 5.76-5.22 7.84c-2.82 2.08-10.42 1.85-10.42 1.85s-2.62-6.81-1.04-9.59c1.5-2.65 9.2-4.36 9.2-4.36"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9438.52 1641.74s-22.11 1.51-27.32-9.79c-6.77-14.67 6.62-26.82 6.62-26.82-1.21 7.89-3.76 16.5-.13 22.48 3.98 6.54 14.46 10.23 20.83 14.13"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9457.64 1592.82c-1.31.14-3.59-.16-4.46.52-.89.68-1.89 2.76-2.12 3.95-.61 3.15-.47 5.4 2.65 7.41 1.14.72 3.2-.08 4.34-.2.63-.07 1.4-.05 2-.23 2.34-.64 4.07-2.38 5.49-3.99.58-.66 1.07-2.09.48-2.88-.54-.71-1.41-1.35-1.9-2.12-.65-1.03-1.76-3.1-3.28-3.53-1.01-.28-1.35.46-2.02.72-.72.28-.3.06-1.18.35"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9472.83 1710.11c24.48 0 44.32-16.37 44.32-36.57 0-20.19-19.84-36.56-44.32-36.56-24.49 0-44.33 16.37-44.33 36.56 0 20.2 19.84 36.57 44.33 36.57"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9477.45 1660.77s-9-3.76-9.54-4.78c-3.53-6.67-5-8.17-5-8.17s9.36-2.45 13.61-1.56c4.26.89 8.67 4.28 8.67 4.28s.21-5.02 1.52-6.65c1.56-1.95 7.84-5.03 7.84-5.03s5.08 4.45 5.93 7.2c.88 2.85-5.36 8.18-5.36 8.18s5.37-.32 8.39 1.58c3.12 1.98 7.12 7.67 7.12 7.67s-4.59 3.17-7.79 3.33c-3.06.16-11.83-2.36-11.83-2.36s5.66 4.82 7.41 8.2c1.81 3.52-4.83 8.64-4.83 8.64s-6.45-4.35-9.36-7.63c-2.23-2.52.18-7.84.18-7.84s-3.01 5.46-6.05 7.21-10.56.69-10.56.69-1.86-7.05.02-9.65c1.78-2.46 9.63-3.31 9.63-3.31"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9462.92 1698.76s-22.14-.94-26.07-12.74c-5.11-15.33 9.54-25.93 9.54-25.93-2.07 7.71-5.55 15.99-2.61 22.33 3.23 6.94 13.24 11.77 19.14 16.34"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9487.33 1652.24c-1.31 0-3.55-.54-4.49.03-.95.58-2.19 2.54-2.54 3.7-.96 3.05-1.07 5.31 1.81 7.65 1.05.84 3.19.28 4.34.28.63 0 1.4.1 2.01 0 2.4-.38 4.31-1.92 5.9-3.37.65-.58 1.29-1.95.79-2.81-.45-.76-1.25-1.49-1.65-2.31-.54-1.09-1.41-3.28-2.87-3.87-.97-.39-1.39.31-2.09.49-.74.21-.31.03-1.21.21"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M9751.28 1265.28c21.44-2.38 37.24-18.45 35.31-35.89-1.94-17.44-20.89-29.65-42.32-27.27-21.44 2.38-37.24 18.45-35.31 35.89 1.94 17.44 20.89 29.65 42.32 27.27"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M9750.6 1222.22s-8.24-2.37-8.82-3.2c-3.72-5.42-5.16-6.57-5.16-6.57s7.97-3.02 11.78-2.67c3.81.36 8 2.85 8 2.85s-.3-4.35.69-5.89c1.18-1.84 6.38-5.11 6.38-5.11s4.87 3.35 5.88 5.65c1.05 2.37-3.91 7.58-3.91 7.58s4.68-.8 7.5.55c2.92 1.41 6.97 5.93 6.97 5.93s-3.71 3.18-6.5 3.63c-2.66.44-10.58-.88-10.58-.88s5.42 3.61 7.27 6.36c1.92 2.86-3.4 7.93-3.4 7.93s-6.06-3.13-8.93-5.68c-2.19-1.96-.59-6.79-.59-6.79s-2.11 5.01-4.6 6.82c-2.5 1.81-9.19 1.62-9.19 1.62s-2.3-5.91-.9-8.34c1.32-2.3 8.11-3.79 8.11-3.79"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9741.52 1256.44s-19.48 1.34-24.05-8.47c-5.94-12.74 5.87-23.32 5.87-23.32-1.08 6.86-3.33 14.35-.14 19.54 3.49 5.68 12.72 8.87 18.32 12.25"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M9758.43 1213.89c-1.15.13-3.16-.12-3.93.46-.78.59-1.67 2.4-1.87 3.44-.54 2.74-.42 4.7 2.32 6.44 1.01.62 2.83-.07 3.83-.19.56-.06 1.23-.04 1.76-.19 2.06-.56 3.59-2.08 4.84-3.48.51-.57.95-1.82.43-2.51-.47-.61-1.24-1.17-1.67-1.84-.58-.88-1.55-2.69-2.88-3.05-.89-.25-1.2.39-1.79.62-.63.25-.26.06-1.04.3"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10078.5 895.853 123.2-120.416s-62.1 7.851-89.2 31.248-34 89.168-34 89.168"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10078.3 896.63 123.9-119.673s-9.9 62.144-34.1 88.554-89.8 31.119-89.8 31.119"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9062.24 1814.23 4.77-149.07s-34.11 42.15-37 72.99c-2.89 30.85 32.23 76.08 32.23 76.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9062.56 1814.85 5.67-149.03s31.06 44.76 31.79 75.76c.72 30.99-37.46 73.27-37.46 73.27"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9844.73 1912.85-57.12 162.5s52.23-34.55 66.14-67.51c13.92-32.97-9.02-94.99-9.02-94.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9844.6 1912.05-58.1 162.15s-18.64-60.11-8.65-94.49c9.98-34.39 66.75-67.66 66.75-67.66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9582.77 1962.36-24.81 170.45s44.61-43.94 51.93-78.96c7.32-35.03-27.12-91.49-27.12-91.49"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9582.49 1961.6-25.83 170.3s-29.85-55.4-26.66-91.06c3.18-35.66 52.49-79.24 52.49-79.24"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m9427.85 2034.27-22.2 152.53s39.92-39.33 46.47-70.67-24.27-81.86-24.27-81.86"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m9427.59 2033.59-23.1 152.39s-26.72-49.57-23.87-81.48c2.85-31.92 46.97-70.91 46.97-70.91"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10079.1 739.801-.9 149.141s33-43.017 35.1-73.931-34.2-75.21-34.2-75.21"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10078.8 739.184-1.8 149.129s-32.2-43.938-33.7-74.903c-1.6-30.964 35.5-74.226 35.5-74.226"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9982.05 971.086 122.75-20.057s-39.9-21.146-65.7-18.553c-25.7 2.592-57.05 38.61-57.05 38.61"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9981.59 971.448 122.91-19.321s-31.7 32.625-56.9 38.202c-25.3 5.577-66.01-18.881-66.01-18.881"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10056.8 1099.94 56.9-162.571s-52.2 34.611-66.1 67.591c-13.8 32.99 9.2 94.98 9.2 94.98"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10056.9 1100.74 57.9-162.226s18.7 60.078 8.8 94.476c-9.9 34.4-66.7 67.75-66.7 67.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10295.8 569.859 75.4-128.655s-50.1 20.714-67.4 46.428c-17.2 25.715-8 82.227-8 82.227"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m10295.8 570.558 76.2-128.198s5.9 54.167-8.3 81.738-67.9 46.46-67.9 46.46"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10395.4 1003.11 82.2 89.94s-4.1-44.11-20-63.8c-15.8-19.7-62.2-26.14-62.2-26.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10394.9 1002.93 81.6 90.42s-43.7-8.48-61.8-26.2-19.8-64.22-19.8-64.22"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m10446.3 814.615-20.2 122.747s32.8-31.118 38.6-56.311c5.7-25.194-18.4-66.436-18.4-66.436"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m10446.1 814.061-20.9 122.621s-20.8-40.415-18-66.124c2.7-25.71 38.9-56.497 38.9-56.497"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10255 448.293 42.8 120.933s14.2-44.437 6.8-70.059c-7.3-25.621-49.6-50.874-49.6-50.874"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10254.6 447.895 42 121.184s-38.8-26.148-49.1-50.755c-10.3-24.606 7.1-70.429 7.1-70.429"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10424.7 521.217 164 52.863s-35.9-51.31-69.3-64.363c-33.3-13.052-94.7 11.5-94.7 11.5"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10423.9 521.367 163.6 53.842s-59.6 20.202-94.2 11.118-69.4-64.96-69.4-64.96"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10647.5 345.608-126 117.419s62.3-6.354 89.9-29.093c27.7-22.739 36.1-88.326 36.1-88.326"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10647.8 344.839-126.7 116.659s11.4-61.888 36.2-87.709 90.5-28.95 90.5-28.95"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9154.34 570.27 81.96 151.499s9.51-61.892-5.55-94.351-76.41-57.148-76.41-57.148"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9153.66 569.832 81.05 151.982s-57.04-26.582-75.79-57.082c-18.76-30.499-5.26-94.9-5.26-94.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9145.58 763.519-75.42-128.671s-6.4 53.841 7.6 81.483 67.82 47.188 67.82 47.188"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9146.18 763.879-74.64-129.116s50.14 21.312 67.28 47.149c17.13 25.837 7.36 81.967 7.36 81.967"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9081.51 444.014-114.62-48.367s22.6 39.18 45.75 50.672 68.87-2.305 68.87-2.305"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9082.1 443.948-114.33-49.05s44.15-10.78 68.5-2.062 45.83 51.112 45.83 51.112"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9236 700.708 159.86-64.132s-60.4-16.516-94.36-5.258c-33.97 11.258-65.5 69.39-65.5 69.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9235.49 701.332 160.24-63.171s-32.92 53.629-65.36 68.78-94.88-5.609-94.88-5.609"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9097.48 1048.99 141.66-46.63s-51.28-17.589-81.25-9.727c-29.97 7.857-60.41 56.357-60.41 56.357"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9097 1049.51 141.94-45.78s-31.39 44.53-60.26 55.84c-28.86 11.31-81.68-10.06-81.68-10.06"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9164.48 765.87-117.95 39.567s42.87 14.431 67.83 7.732c24.96-6.7 50.12-47.299 50.12-47.299"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9164.88 765.442-118.18 38.859s25.97-37.296 50-46.866c24.02-9.57 68.18 8.007 68.18 8.007"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9238.45 1002.36-157.05-70.74s29.97 54.979 61.64 71.65c31.66 16.67 95.41-.91 95.41-.91"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9239.26 1002.29-156.62-71.68s61.47-13.458 94.88-.585 61.74 72.265 61.74 72.265"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9269.12 1047.33 92.63-116.89s-52.5 13.532-73.2 36.588c-20.7 23.055-19.43 80.302-19.43 80.302"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9269.01 1048.02 93.32-116.326s-1.71 54.46-19.59 79.786c-17.88 25.33-73.73 36.54-73.73 36.54"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m8967.23 518.055 117.02-65.265s-48.24-6.782-73.33 5.258c-25.1 12.04-43.69 60.007-43.69 60.007"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8966.9 518.591 117.4-64.562s-20.1 44.631-43.64 59.524c-23.53 14.894-73.76 5.038-73.76 5.038"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.505}
      d="M9292.71 569.761 9239.87 455.6s-9.75 44.681-.25 69.026c9.5 24.346 53.09 45.135 53.09 45.135"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9293.19 570.107-52.16-114.472s40.36 21.973 52.65 45.059c12.28 23.085-.49 69.413-.49 69.413"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m8809.47 824.568 102.64-33.942s-37.2-12.7-58.91-6.972c-21.72 5.729-43.73 40.914-43.73 40.914"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="m8809.12 824.939 102.84-33.327s-22.71 32.312-43.62 40.538c-20.91 8.227-59.22-7.211-59.22-7.211"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9029.44 971.878-26.5-121.553s-19.01 41.04-15.07 66.582c3.95 25.542 41.57 54.971 41.57 54.971"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9029.83 972.313-25.78-121.705s34.25 29.878 41.15 54.801-15.37 66.904-15.37 66.904"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9044.24 700.117-32.61 169.132s46.58-41.847 55.5-76.501-22.89-92.631-22.89-92.631"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9043.99 699.345-33.62 168.928s-27.28-56.709-22.46-92.187c4.82-35.479 56.08-76.741 56.08-76.741"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9609.31 358.571-116.18-93.515s13.13 52.605 36.03 73.478 80.15 20.037 80.15 20.037"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m9610 358.693-115.62-94.206s54.45 2.122 79.64 20.192c25.19 18.071 35.98 74.014 35.98 74.014"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9224.4 929.889 85.48-86.809s-43.82 6.385-62.66 23.294c-18.83 16.91-22.82 63.515-22.82 63.515"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m9224.25 930.438 86-86.293s-6.17 44.079-22.91 63.081c-16.74 19.001-63.09 23.212-63.09 23.212"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8987.9 562.82 123.65 13.761s-32.81-31.134-58.27-35.565-65.38 21.804-65.38 21.804"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8987.36 563.048 123.56 14.5s-39.26 22.895-65.08 21.463-58.48-35.963-58.48-35.963"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9493.51 398.1 118.51-49.114s-45.12-11.788-70.32-3.116-48.19 52.23-48.19 52.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m9493.14 398.567 118.79-48.402s-24.06 40.217-48.09 51.775-70.7-3.373-70.7-3.373"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8349.95 386.252 109.32-61.116s-45.1-6.292-68.54 4.986c-23.45 11.278-40.78 56.13-40.78 56.13"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8349.64 386.755 109.67-60.459s-18.75 41.735-40.73 55.679c-21.99 13.943-68.94 4.78-68.94 4.78"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8534.88 464.942 120.77-16.046s-38.51-21.866-63.76-20.08-57.01 36.126-57.01 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8534.42 465.285 120.86-15.323s-31.92 31.011-56.8 35.732c-24.89 4.722-64.06-20.409-64.06-20.409"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8219.38 729.54 120.77-16.047s-38.52-21.866-63.77-20.079c-25.24 1.786-57 36.126-57 36.126"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8218.92 729.882 120.86-15.323s-31.93 31.012-56.81 35.733-64.05-20.41-64.05-20.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8497.44 812.863-139.71-52.202s29.02 45.8 57.32 58.406 82.39-6.204 82.39-6.204"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8498.13 812.761-139.39-53.035s52.34-15.12 81.94-5.894 57.45 58.929 57.45 58.929"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8464.91 536.119 28.12 121.188s18.46-41.288 14.18-66.776c-4.29-25.487-42.3-54.412-42.3-54.412"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8464.52 535.689 27.39 121.351s-34.64-29.42-41.87-54.248c-7.23-24.829 14.48-67.103 14.48-67.103"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8460 539.692 144.66 36.279s-33.95-42.273-63.48-51.642c-29.54-9.368-81.18 15.363-81.18 15.363"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8459.32 539.875 144.44 37.144s-50.33 20.868-80.77 15.005c-30.45-5.864-63.67-52.149-63.67-52.149"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8339.45 719.391-120.42-87.995s15.58 51.935 39.42 71.717c23.85 19.783 81 16.278 81 16.278"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8340.15 719.479-119.89-88.712s54.49-.419 80.49 16.457c26.01 16.876 39.4 72.255 39.4 72.255"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8529.06 471.725-45.58-142.008s-17.97 51.155-10.33 81.182 55.91 60.826 55.91 60.826"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8529.57 472.207-44.73-142.274s44.3 31.723 55.39 60.671c11.1 28.949-10.66 81.603-10.66 81.603"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8340.21 487.524-116.19-93.515s13.14 52.605 36.03 73.478c22.9 20.873 80.16 20.037 80.16 20.037"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8340.9 487.648-115.62-94.206s54.44 2.122 79.63 20.192c25.19 18.071 35.99 74.014 35.99 74.014"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8224.44 527.049 118.5-49.114s-45.12-11.788-70.32-3.116-48.18 52.23-48.18 52.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8224.06 527.518 118.8-48.402s-24.06 40.217-48.09 51.775-70.71-3.373-70.71-3.373"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9111.31 540.024 97.13-142.253s-59.38 19.895-81.33 48.152-15.8 94.101-15.8 94.101"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m9111.24 540.823 97.97-141.665s2.5 62.877-16.02 93.52-81.95 48.145-81.95 48.145"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m9076.65 385.969 33.89-127.816s-37.88 29.595-46.54 55.665 12.65 72.151 12.65 72.151"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m9076.8 386.57 34.65-127.606s17.9 44.869 12.34 71.787-46.99 55.819-46.99 55.819"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8035.72 886.883 81.96 151.497s9.51-61.89-5.55-94.349-76.41-57.148-76.41-57.148"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8035.04 886.447 81.05 151.983s-57.04-26.58-75.79-57.083c-18.76-30.499-5.26-94.9-5.26-94.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7925 886.026-75.42-128.67s-6.39 53.841 7.6 81.483c14 27.642 67.82 47.187 67.82 47.187"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7925.6 886.383-74.64-129.116s50.15 21.312 67.28 47.149c17.14 25.837 7.36 81.967 7.36 81.967"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8170.6 1007.16 159.86-64.129s-60.4-16.516-94.37-5.258c-33.96 11.258-65.49 69.387-65.49 69.387"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8170.09 1007.79 160.24-63.172s-32.92 53.629-65.36 68.782c-32.44 15.15-94.88-5.61-94.88-5.61"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7981.81 776.065-57.47 110.339s40.88-19.354 54.2-41.5c13.32-22.145 3.27-68.839 3.27-68.839"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7981.79 775.476-58.12 109.99s-7.18-44.88 3.48-68.443c10.65-23.562 54.64-41.547 54.64-41.547"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7934.38 640.794 123.64 13.762s-32.8-31.134-58.27-35.565c-25.46-4.431-65.37 21.803-65.37 21.803"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7933.84 641.018 123.55 14.501s-39.26 22.895-65.08 21.463-58.47-35.964-58.47-35.964"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8115.45 667.926 97.12-142.252s-59.37 19.894-81.33 48.151c-21.95 28.257-15.79 94.101-15.79 94.101"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8115.37 668.727 97.97-141.664s2.5 62.877-16.02 93.519-81.95 48.145-81.95 48.145"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.502}
      d="m8120.9 668.305-40.66-125.826s-15.84 45.386-9.02 71.995c6.83 26.608 49.68 53.831 49.68 53.831"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.487}
      d="m8121.35 668.732-39.9-126.063s39.33 28.048 49.22 53.695-9.32 72.368-9.32 72.368"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8285.92 1358.84 151.66-81.66s-61.88-9.64-94.37 5.36c-32.48 15-57.29 76.3-57.29 76.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8285.48 1359.52 152.14-80.75s-26.69 56.98-57.23 75.68c-30.53 18.69-94.91 5.07-94.91 5.07"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M8309.64 1378.83 8180.82 1454s53.83 6.5 81.5-7.44 47.32-67.73 47.32-67.73"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8309.99 1378.23-129.25 74.4s21.4-50.11 47.27-67.19c25.87-17.09 81.98-7.21 81.98-7.21"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7932.47 1562.68-99.18 75.1s45.22.02 66.75-14.29c21.52-14.3 32.43-60.81 32.43-60.81"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7932.71 1562.15-99.63 74.5s12.73-43.63 32.45-60.36c19.72-16.72 67.18-14.14 67.18-14.14"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8289.02 1363.92-63.82-159.99s-16.64 60.37-5.44 94.36c11.19 33.98 69.26 65.63 69.26 65.63"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8289.65 1364.43-62.87-160.36s53.57 33.02 68.66 65.49-5.79 94.87-5.79 94.87"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m7804.25 1367.38-129.03 102.24s59.84-1.3 87.9-20.85c28.06-19.56 41.13-81.39 41.13-81.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="m7804.55 1366.67-129.64 101.46s15.58-58.09 41.18-80.8c25.6-22.7 88.46-20.66 88.46-20.66"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8291.24 1375.79 39.34 118.02s14.52-42.83 7.87-67.81c-6.66-24.97-47.21-50.21-47.21-50.21"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8290.81 1375.39 38.63 118.26s-37.24-26.05-46.76-50.09c-9.53-24.04 8.13-68.17 8.13-68.17"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7984.51 1339.42-80.44 152.31s56.75-26.47 75.37-57.02c18.62-30.56 5.07-95.29 5.07-95.29"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7984.49 1338.62-81.34 151.82s-9.59-62.19 5.36-94.73c14.94-32.54 75.98-57.09 75.98-57.09"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7813.41 1375-71.19-131.06s-8.14 53.61 4.95 81.69 66.24 49.37 66.24 49.37"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7814 1375.37-70.4-131.47s49.42 22.93 65.71 49.31c16.28 26.38 4.69 82.16 4.69 82.16"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m7999.71 1679.17-65.04-117.15s-6.87 48.23 5.12 73.35 59.92 43.8 59.92 43.8"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8000.25 1679.5-64.34-117.53s44.59 20.2 59.44 43.76 4.9 73.77 4.9 73.77"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7804.18 1370.57-23.21 170.67s44.2-44.36 51.19-79.45-27.98-91.22-27.98-91.22"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7803.88 1369.81-24.22 170.53s-30.37-55.11-27.52-90.8 51.74-79.73 51.74-79.73"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8525.68 1419.82-116.89 126.51s61.65-10.99 87.5-35.74c25.85-24.74 29.39-90.77 29.39-90.77"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8525.87 1419.03-117.64 125.81s6.73-62.56 29.53-90.17c22.8-27.6 88.11-35.64 88.11-35.64"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8533.02 1575.69-6.68-149s-30.78 44.64-31.29 75.62c-.52 30.98 37.97 73.38 37.97 73.38"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8533.39 1576.28-5.79-149.02s34.41 42.24 37.51 73.09c3.11 30.85-31.72 75.93-31.72 75.93"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8572.81 1336.54-121.6 26.26s41 19.09 66.55 15.2c25.55-3.9 55.05-41.46 55.05-41.46"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8573.25 1336.15-121.75 25.54s29.94-34.19 54.88-41.04c24.93-6.85 66.87 15.5 66.87 15.5"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8495.04 1201.32-48.58 165.26s50.36-37.22 62.54-70.87c12.18-33.64-13.96-94.39-13.96-94.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8494.86 1200.53-49.56 164.96s-21.75-59.05-13.57-93.91 63.13-71.05 63.13-71.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7765.6 2089.95-72.39 130.4s49.6-21.89 66.28-48.01c16.67-26.11 6.11-82.39 6.11-82.39"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7765.6 2089.24-73.17 129.96s-7.17-54.01 6.36-81.91c13.52-27.9 66.81-48.05 66.81-48.05"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8080.44 1335.75 88.82-83.4s-44.05 4.66-63.53 20.82-25.29 62.58-25.29 62.58"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8080.26 1336.29 89.31-82.86s-7.88 43.8-25.35 62.13c-17.48 18.34-63.96 20.73-63.96 20.73"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8003.1 1523.75 14-123.62s-31.2 32.74-35.68 58.2c-4.48 25.45 21.68 65.42 21.68 65.42"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8003.32 1524.29 14.74-123.53s22.82 39.3 21.34 65.12-36.08 58.41-36.08 58.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7617.45 892.845 165.34-48.321s-58.52-22.298-93.42-14.388c-34.89 7.91-71.92 62.709-71.92 62.709"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7616.89 893.42 165.61-47.329s-37.97 50.183-71.73 62.116c-33.75 11.932-93.88-14.787-93.88-14.787"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8077.27 1487.33-4.78 149.06s34.11-42.14 37.01-72.99c2.89-30.85-32.23-76.07-32.23-76.07"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8076.95 1486.71-5.67 149.03s-31.07-44.76-31.79-75.76c-.73-30.99 37.46-73.27 37.46-73.27"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7927.87 911.868-71.35 101.912s43.05-13.864 59.14-34.085c16.1-20.221 12.21-67.827 12.21-67.827"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7927.93 911.283-71.96 101.477s-1.27-45.431 12.37-67.404 59.59-34.073 59.59-34.073"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8093.91 1335.75-29.13-169.76s-28.83 55.59-24.96 91.16c3.88 35.57 54.09 78.6 54.09 78.6"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8094.42 1336.39-28.12-169.93s45.52 43.44 53.53 78.34c8 34.9-25.41 91.59-25.41 91.59"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7990.39 540.471 59.12-136.928s-47.19 26.696-61.2 54.334c-14 27.638 2.08 82.594 2.08 82.594"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7990.46 541.168 59.93-136.568s12.49 53.037 1.8 82.137c-10.7 29.099-61.73 54.431-61.73 54.431"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8187.55 1531.34 120.88 29.4s-28.57-35.06-53.26-42.7-67.62 13.3-67.62 13.3"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8186.98 1531.49 120.71 30.12s-41.86 17.71-67.29 13-53.42-43.12-53.42-43.12"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8004.97 560.046-171.96-9.989s47.63 40.648 83.16 44.914 88.8-34.925 88.8-34.925"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8005.7 559.694-171.89-11.018s52.61-34.524 88.41-34.431c35.81.093 83.48 45.449 83.48 45.449"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7928.82 479.369 33.42-145.352s-41.6 34.779-50.38 64.492c-8.78 29.712 16.96 80.86 16.96 80.86"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m7929.01 480.042 34.29-145.145s21.86 49.91 16.59 80.462c-5.26 30.552-50.88 64.683-50.88 64.683"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.506}
      d="m7971.84 1039.41-39.24-128.121s-16.76 45.737-10.26 72.803c6.5 27.068 49.5 55.318 49.5 55.318"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7972.29 1039.85-38.47-128.349s39.42 29.029 49.04 55.168-10.57 73.181-10.57 73.181"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7938.04 458.905-164.95-49.592s36.91 50.586 70.48 62.973 94.47-13.381 94.47-13.381"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7938.83 458.736-164.64-50.577s59.18-21.383 93.99-12.99c34.8 8.393 70.65 63.567 70.65 63.567"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8327.07 1562.61 45.06 166.25s23.44-58.06 16.22-93.11-61.28-73.14-61.28-73.14"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8326.51 1562.03 44.06 166.51s-49.43-38.94-60.7-72.93c-11.26-33.98 16.64-93.58 16.64-93.58"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8436.19 1657.63-114.07-96.08s54.14 2.79 79.02 21.26 35.05 74.82 35.05 74.82"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8436.43 1658.29-114.63-95.4s12.52 53.03 35.09 74.28c22.57 21.26 79.54 21.12 79.54 21.12"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8198.96 1642.19-124.41.39s36.14 27.2 61.94 28.7c25.8 1.51 62.47-29.09 62.47-29.09"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8199.47 1641.9-124.4-.36s36.4-27.21 62.22-28.72c25.81-1.51 62.18 29.08 62.18 29.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7874.27 1222.58 117.64 125.81s-6.46-62.28-29.25-89.87-88.39-35.94-88.39-35.94"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7873.5 1222.33 116.88 126.51s-61.91-11.28-87.77-36.03c-25.87-24.76-29.11-90.48-29.11-90.48"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7771.54 845.811-66.93-101.805s-2.96 44.192 9.62 66.155 57.31 35.65 57.31 35.65"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7772.05 846.073-66.32-102.2s41.81 15.282 56.87 35.641 9.45 66.559 9.45 66.559"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8172.06 1748.24 10.34-123.98s24.23 38.2 23.66 64.03c-.56 25.84-34 59.95-34 59.95"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8171.73 1748.73 9.61-124.04s-30.04 34.11-33.62 59.72c-3.57 25.62 24.01 64.32 24.01 64.32"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m7599.46 2168.01 90.74-90.69s-46.21 6.36-66.18 24c-19.97 17.65-24.56 66.69-24.56 66.69"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m7599.3 2168.59 91.27-90.14s-6.86 46.36-24.65 66.22c-17.78 19.87-66.62 23.92-66.62 23.92"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7838.34 2241.86-81.58-151.7s56.95 26.04 75.8 56.46 5.78 95.24 5.78 95.24"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7838.33 2242.67-82.48-151.21s-9.12 62.26 6.06 94.69c15.19 32.42 76.42 56.52 76.42 56.52"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7689.73 2083.75-153.51-78.12s27.33 56.34 58.16 74.49c30.84 18.16 95.35 3.63 95.35 3.63"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m7690.54 2083.72-153.04-79.04s62.04-10.52 94.8 3.93c32.76 14.44 58.24 75.11 58.24 75.11"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9398.43 1665.12c-25.86 1.94-45.53 20.81-43.93 42.15 1.61 21.33 23.87 37.05 49.74 35.11 25.86-1.95 45.53-20.82 43.92-42.15-1.6-21.34-23.87-37.06-49.73-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9365.53 1721.56s-8.79-21.78.88-30.73c12.56-11.64 29.2-2.14 29.2-2.14-8.35 1.38-17.86 1.64-22.69 7.25-5.28 6.15-5.56 17.93-7.39 25.62"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9396.43 1716.4s9.81 3.26 10.46 4.29c4.26 6.76 5.93 8.23 5.93 8.23s-9.7 3.33-14.26 2.73c-4.57-.6-9.49-3.83-9.49-3.83s.17 5.32-1.08 7.15c-1.5 2.18-7.89 5.94-7.89 5.94s-5.71-4.3-6.83-7.15c-1.16-2.93 5.01-9.06 5.01-9.06s-5.65.76-8.99-1.01c-3.45-1.84-8.13-7.53-8.13-7.53s4.59-3.71 7.97-4.14c3.21-.4 12.68 1.56 12.68 1.56s-6.36-4.65-8.48-8.08c-2.19-3.58 4.42-9.51 4.42-9.51s7.16 4.08 10.5 7.32c2.55 2.48.42 8.3.42 8.3s2.75-6.01 5.82-8.1c3.07-2.1 11.11-1.57 11.11-1.57s2.52 7.31.74 10.2c-1.69 2.74-9.91 4.26-9.91 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9387.7 1727.4c1.39-.1 3.8.3 4.74-.38.97-.69 2.11-2.85 2.4-4.11.76-3.3.7-5.7-2.53-7.94-1.18-.8-3.39-.04-4.61.05-.67.05-1.48 0-2.12.16-2.5.59-4.4 2.37-5.96 4.03-.64.67-1.22 2.17-.62 3.03.54.77 1.44 1.48 1.93 2.31.65 1.11 1.75 3.35 3.34 3.86 1.06.34 1.45-.43 2.17-.69.77-.27.32-.05 1.26-.32"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M8186.59 1601.13c-22.14 1.67-38.97 17.82-37.6 36.08s20.43 31.71 42.57 30.04c22.13-1.66 38.96-17.81 37.59-36.07s-20.43-31.71-42.56-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8158.43 1649.44s-7.52-18.63.76-26.3c10.74-9.96 24.98-1.83 24.98-1.83-7.14 1.18-15.28 1.4-19.42 6.21-4.52 5.26-4.75 15.34-6.32 21.92"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8184.88 1645.03s8.39 2.78 8.95 3.67c3.64 5.79 5.08 7.04 5.08 7.04s-8.3 2.85-12.21 2.34c-3.91-.52-8.13-3.28-8.13-3.28s.15 4.55-.92 6.12c-1.28 1.87-6.75 5.08-6.75 5.08s-4.89-3.68-5.85-6.11c-.99-2.51 4.3-7.76 4.3-7.76s-4.84.65-7.7-.86c-2.95-1.58-6.96-6.44-6.96-6.44s3.93-3.18 6.82-3.55c2.75-.35 10.85 1.33 10.85 1.33s-5.44-3.98-7.25-6.92c-1.88-3.05 3.78-8.13 3.78-8.13s6.13 3.49 8.99 6.27c2.18 2.12.36 7.1.36 7.1s2.35-5.15 4.98-6.94 9.5-1.34 9.5-1.34 2.16 6.25.64 8.73c-1.45 2.35-8.48 3.65-8.48 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M8177.41 1654.44c1.19-.09 3.24.26 4.06-.32.82-.59 1.8-2.45 2.04-3.52.66-2.83.61-4.88-2.16-6.8-1.01-.69-2.9-.03-3.94.05-.57.04-1.27 0-1.82.13-2.14.51-3.76 2.03-5.1 3.45-.55.57-1.04 1.85-.53 2.59.46.66 1.23 1.27 1.65 1.98.56.95 1.5 2.87 2.86 3.3.91.29 1.24-.37 1.86-.58.66-.24.27-.05 1.08-.28"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M8281.16 1589.97c-25.87 1.95-45.54 20.82-43.93 42.15 1.6 21.34 23.87 37.06 49.73 35.11 25.87-1.94 45.53-20.81 43.93-42.15-1.6-21.33-23.87-37.05-49.73-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8248.25 1646.42s-8.78-21.77.89-30.73c12.55-11.63 29.19-2.14 29.19-2.14-8.35 1.38-17.85 1.64-22.69 7.25-5.28 6.16-5.55 17.93-7.39 25.62"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M8279.16 1641.26s9.8 3.25 10.46 4.29c4.26 6.76 5.93 8.23 5.93 8.23s-9.7 3.33-14.26 2.73c-4.57-.61-9.5-3.84-9.5-3.84s.18 5.33-1.08 7.16c-1.49 2.18-7.88 5.93-7.88 5.93s-5.72-4.29-6.84-7.14c-1.15-2.93 5.02-9.06 5.02-9.06s-5.65.76-8.99-1.01c-3.46-1.84-8.14-7.53-8.14-7.53s4.6-3.71 7.97-4.14c3.22-.41 12.68 1.56 12.68 1.56s-6.36-4.65-8.47-8.09c-2.19-3.57 4.42-9.5 4.42-9.5s7.16 4.08 10.49 7.32c2.56 2.48.43 8.3.43 8.3s2.75-6.01 5.82-8.11c3.07-2.09 11.1-1.56 11.1-1.56s2.52 7.3.75 10.2c-1.69 2.74-9.91 4.26-9.91 4.26"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M8270.43 1652.26c1.39-.11 3.79.29 4.74-.39.96-.68 2.11-2.85 2.39-4.1.77-3.31.71-5.7-2.52-7.95-1.18-.8-3.4-.04-4.61.05-.67.06-1.48 0-2.12.16-2.51.6-4.4 2.38-5.96 4.03-.64.67-1.22 2.17-.62 3.03.54.77 1.44 1.48 1.93 2.32.65 1.1 1.75 3.35 3.34 3.85 1.05.34 1.44-.43 2.16-.69.78-.27.33-.05 1.27-.31"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.499}
      d="M8312.42 1465.54c-22.14 1.67-38.97 17.82-37.6 36.08s20.43 31.71 42.57 30.04c22.13-1.66 38.97-17.81 37.59-36.07-1.37-18.26-20.43-31.71-42.56-30.05"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8284.26 1513.85s-7.52-18.64.76-26.3c10.74-9.96 24.98-1.84 24.98-1.84-7.14 1.19-15.28 1.41-19.42 6.21-4.52 5.27-4.75 15.35-6.32 21.93"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8310.71 1509.44s8.39 2.78 8.95 3.67c3.64 5.79 5.08 7.04 5.08 7.04s-8.3 2.85-12.21 2.34c-3.91-.52-8.13-3.28-8.13-3.28s.15 4.55-.92 6.12c-1.28 1.87-6.75 5.08-6.75 5.08s-4.89-3.68-5.85-6.11c-.99-2.51 4.29-7.76 4.29-7.76s-4.83.65-7.69-.86c-2.96-1.58-6.96-6.44-6.96-6.44s3.93-3.18 6.82-3.55c2.75-.35 10.85 1.33 10.85 1.33s-5.44-3.98-7.25-6.92c-1.88-3.05 3.78-8.13 3.78-8.13s6.13 3.49 8.98 6.27c2.19 2.12.37 7.1.37 7.1s2.35-5.15 4.98-6.94 9.5-1.34 9.5-1.34 2.16 6.25.64 8.73c-1.45 2.35-8.48 3.65-8.48 3.65"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.47}
      d="M8303.24 1518.85c1.19-.09 3.24.26 4.05-.33.83-.58 1.81-2.44 2.05-3.51.66-2.83.61-4.88-2.16-6.8-1.01-.69-2.9-.03-3.94.04-.57.05-1.27 0-1.82.14-2.14.51-3.76 2.03-5.1 3.45-.55.57-1.04 1.85-.53 2.59.46.66 1.23 1.27 1.65 1.98.56.95 1.5 2.87 2.86 3.3.9.29 1.24-.37 1.85-.59.66-.23.28-.04 1.09-.27"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9408.56 2183.16-44.17-116.3s-12.74 43.39-5.06 68.07c7.67 24.68 49.23 48.23 49.23 48.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9409 2183.54-43.47-116.56s38.29 24.49 48.8 48.12c10.5 23.63-5.33 68.44-5.33 68.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7784.52 1966.88 36.46 116.25s14.96-41.69 8.88-66.26c-6.08-24.56-45.34-49.99-45.34-49.99"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m7784.1 1966.49 35.77 116.46s-36.01-26.15-44.92-49.86 9.15-66.6 9.15-66.6"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8334.69 2259.06-112.63 61.4s46.11 6.94 70.25-4.35c24.14-11.3 42.38-57.05 42.38-57.05"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8335.02 2258.56-113 60.72s19.66-42.54 42.33-56.58 70.67-4.14 70.67-4.14"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8016.27 2150.75-112.63 61.39s46.11 6.94 70.25-4.35 42.38-57.04 42.38-57.04"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8016.6 2150.24-113 60.72s19.66-42.54 42.33-56.58 70.67-4.14 70.67-4.14"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8380.51 2254.87 158.05-68.48s-60.83-14.86-94.48-2.67c-33.64 12.18-63.57 71.15-63.57 71.15"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8380.02 2255.51 158.45-67.53s-31.44 54.51-63.46 70.54c-32.01 16.03-94.99-3.01-94.99-3.01"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8358.16 2136.96 34.59 116.82s15.63-41.45 9.95-66.11-44.54-50.71-44.54-50.71"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8357.76 2136.56 33.88 117.02s-35.58-26.73-44.11-50.58c-8.52-23.85 10.23-66.44 10.23-66.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8309.55 2255.27 56.71 162.65s19.28-59.58 9.6-94.03c-9.69-34.45-66.31-68.62-66.31-68.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8308.95 2254.73 55.73 162.98s-52.06-35.35-65.7-68.46c-13.64-33.1 9.97-94.52 9.97-94.52"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8171.03 2182.94-97.4 142.06s59.41-19.78 81.42-47.99c22.01-28.22 15.98-94.07 15.98-94.07"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8171.11 2182.12-98.25 141.48s-2.37-62.88 16.21-93.49c18.57-30.61 82.04-47.99 82.04-47.99"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8211.54 2159.15 124.97-81.41s-54.08-3.85-81.04 11.44c-26.95 15.29-43.93 69.97-43.93 69.97"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8211.22 2159.77 125.44-80.66s-18.92 51.09-43.91 69.43c-25 18.34-81.53 11.23-81.53 11.23"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8465.5 2354.03 73.08 100.68s.93-45.21-12.94-67.02-60.14-33.66-60.14-33.66"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8464.96 2353.79 72.48 101.11s-43.36-13.61-59.69-33.66-12.79-67.45-12.79-67.45"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8009.57 2128.83 15.46 171.55s33.19-53.1 32.17-88.87c-1.01-35.77-47.63-82.68-47.63-82.68"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8009.12 2128.16 14.43 171.63s-41.9-46.94-47.08-82.37c-5.19-35.43 32.65-89.26 32.65-89.26"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m7998.11 2130.06 27.22-121.39s-34.54 29.2-41.73 54.02c-7.2 24.82 14.51 67.37 14.51 67.37"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m7998.28 2130.62 27.94-121.23s18.46 41.54 14.21 67.04c-4.25 25.51-42.15 54.19-42.15 54.19"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8465.58 2354.33-12.33 127.69s31.61-34.29 35.79-60.61c4.19-26.32-23.46-67.08-23.46-67.08"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8465.34 2353.78-13.09 127.6s-24.2-40.13-23.11-66.78c1.09-26.64 36.2-60.82 36.2-60.82"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8215.22 2166.29 9.13-124.07s-29.89 33.94-33.37 59.55c-3.47 25.61 24.24 64.52 24.24 64.52"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8215.46 2166.82 9.87-124.01s24.35 38.38 23.88 64.23c-.46 25.86-33.75 59.78-33.75 59.78"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m9552.51 2124.8-44.17-116.3s-12.74 43.39-5.06 68.07c7.67 24.68 49.23 48.23 49.23 48.23"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m9552.96 2125.18-43.47-116.56s38.28 24.49 48.79 48.12c10.5 23.63-5.32 68.44-5.32 68.44"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8879.55 433.964-79.64-92.199s43.32 9.23 61.01 27.331c17.69 18.102 18.63 64.868 18.63 64.868"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8879.67 434.525-80.19-91.718s3.27 44.388 18.74 64.441 61.45 27.277 61.45 27.277"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8727.03 704.194-111.5 63.442s18.38-42.863 40.69-57.44 70.81-6.002 70.81-6.002"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8727.63 704.184-111.11 64.106s46.52 5.677 70.39-6.206 40.72-57.9 40.72-57.9"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8553.6 966.637-111.5 63.443s18.38-42.863 40.69-57.44 70.81-6.003 70.81-6.003"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8554.21 966.633-111.12 64.107s46.52 5.68 70.4-6.21c23.87-11.88 40.72-57.897 40.72-57.897"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8698.68 530.843 114.15-128.997s-4.76 62.439-26.78 90.642c-22.02 28.204-87.37 38.355-87.37 38.355"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8697.92 531.116 113.37-129.675s-61.58 12.973-86.75 38.432c-25.18 25.459-26.62 91.243-26.62 91.243"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="M8811.53 713.435 8770.3 598.79s37.12 24.167 47.13 47.413-5.9 67.232-5.9 67.232"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8811.44 714-41.91-114.393s-12.88 42.605-5.65 66.874c7.24 24.269 47.56 47.519 47.56 47.519"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8601.41 341.187-57.27-107.527s40.2 18.58 53.45 40.146c13.25 21.565 3.82 67.381 3.82 67.381"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m8601.4 341.76-57.92-107.18s-6.62 44.013 4.03 66.99 53.89 40.19 53.89 40.19"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="M8726.84 709.005 8618.4 575.173s60.81 14.972 85 41.338c24.19 26.367 23.44 92.494 23.44 92.494"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8726.98 709.801-109.23-133.177s2.65 62.87 23.62 91.896c20.96 29.025 85.61 41.281 85.61 41.281"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8744.55 883.405-172.06 8.022s48.1-40.101 83.67-43.959c35.58-3.858 88.39 35.937 88.39 35.937"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8745.28 883.768-172 9.051s52.21 35.123 88.01 35.44c35.8.316 83.99-44.491 83.99-44.491"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8659.61 1110.23 135-63.39s-25.2 48.01-52.39 62.88c-27.18 14.86-82.61.51-82.61.51"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="m8658.91 1110.19 134.61-64.2s-53.4-10.81-82.15.79-52.46 63.41-52.46 63.41"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8713.37 386.212 45.4-115.828s12.28 43.53 4.34 68.126c-7.93 24.596-49.74 47.702-49.74 47.702"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8712.92 386.586 44.71-116.094s-38.55 24.083-49.3 47.6c-10.76 23.518 4.59 68.494 4.59 68.494"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8657.51 1093.25-49.43-165.006s50.55 36.958 62.91 70.54c12.35 33.586-13.48 94.466-13.48 94.466"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8657.34 1094.04-50.42-164.7s-21.44 59.161-13.08 93.98c8.36 34.81 63.5 70.72 63.5 70.72"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8659.29 1115.27 117.54 40.76s-43.01 14-67.9 7.04c-24.89-6.95-49.64-47.8-49.64-47.8"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8658.9 1114.83 117.78 40.07s-25.59-37.56-49.52-47.38c-23.92-9.81-68.26 7.31-68.26 7.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8809.03 576.622-115.05-56.738s45.79-8.82 70.37 1.477c24.58 10.296 44.68 55.261 44.68 55.261"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8809.37 577.114-115.38-56.046s21.38 41.701 44.61 54.801c23.22 13.101 70.77 1.245 70.77 1.245"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10121.9 472.44-125.96-24.119s41.76-20.674 68.26-17.28c26.4 3.394 57.7 41.399 57.7 41.399"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10122.4 472.827-126.13-23.364s31.73 34.517 57.53 40.973c25.9 6.457 68.6-17.609 68.6-17.609"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8462.91 860.253-12.01 171.827s-34.24-52.425-33.95-88.207c.3-35.782 45.96-83.62 45.96-83.62"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8463.35 859.57-10.98 171.89s40.95-47.779 45.42-83.303-34.44-88.587-34.44-88.587"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10149.1 684.262 43.1-113.968s12.5 42.477 5.1 66.658c-7.5 24.181-48.2 47.31-48.2 47.31"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10148.7 684.632 42.4-114.221s-37.5 24.048-47.7 47.206c-10.3 23.158 5.3 67.015 5.3 67.015"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10283.3 278.494 12.4-121.198s23.1 37.843 22 63.132c-1 25.289-34.4 58.066-34.4 58.066"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.493}
      d="m10283 278.962 11.7-121.267s-30 32.843-34 57.855 22.3 63.412 22.3 63.412"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10118.6 475.953 4.4-172.191s36.6 50.858 37.9 86.618c1.2 35.76-42.3 85.573-42.3 85.573"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10118.2 476.655 3.4-172.209s-38.8 49.546-41.7 85.233 38.3 86.976 38.3 86.976"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10021.9 605.163-136.06-105.589s62.61.716 92.18 20.874c29.58 20.158 43.88 84.715 43.88 84.715"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m10022.2 605.901-136.67-104.769s16.92 60.61 43.95 84.092 92.72 20.677 92.72 20.677"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10282.3 448.863-50.7-117.843s40.5 23.017 52.5 46.805c12 23.789-1.8 71.038-1.8 71.038"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m10282.2 449.463-51.4-117.534s-10.8 45.603-1.6 70.645c9.1 25.042 53 46.889 53 46.889"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8975.65 556.626-115.06-56.738s45.8-8.82 70.38 1.476c24.58 10.297 44.68 55.262 44.68 55.262"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.498}
      d="m8975.99 557.118-115.38-56.046s21.38 41.701 44.61 54.801c23.22 13.101 70.77 1.245 70.77 1.245"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8498.99 436.956-168.09 37.598s40.45-47.8 74.83-57.74c34.37-9.941 93.26 20.142 93.26 20.142"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8499.77 437.186-167.86 38.602s57.49 25.585 92.81 19.718 75.05-58.32 75.05-58.32"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8997.85 629.64-172.19 4.565s48.89-39.127 84.53-42.27c35.65-3.143 87.66 37.705 87.66 37.705"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.501}
      d="m8998.56 630.017-172.15 5.595s51.5 36.165 87.29 37.2 84.86-42.795 84.86-42.795"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8880.84 925.884-154.08 4.085s43.75-35.013 75.64-37.826c31.9-2.813 78.44 33.741 78.44 33.741"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.492}
      d="m8881.48 926.219-154.05 5.006s46.08 32.363 78.11 33.29 75.94-38.296 75.94-38.296"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8745.63 932.666 110.3 57.553s-44.6 7.54-68.2-2.987c-23.61-10.527-42.1-54.566-42.1-54.566"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8745.31 932.18 110.63 56.891s-19.81-40.904-42.04-54.119-68.59-2.772-68.59-2.772"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.504}
      d="m8817.89 718.506 110.3 57.553s-44.59 7.54-68.2-2.987c-23.6-10.527-42.1-54.566-42.1-54.566"
      clipRule="evenodd"
    />
    <path
      fill="#6F945C"
      fillRule="evenodd"
      stroke="#5F7C50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.491}
      d="m8817.57 718.018 110.64 56.891s-19.82-40.904-42.05-54.119c-22.22-13.216-68.59-2.772-68.59-2.772"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M9074 533.485c-25.87 1.944-45.54 20.815-43.93 42.15 1.6 21.334 23.87 37.054 49.73 35.11 25.87-1.944 45.53-20.815 43.93-42.15s-23.87-37.054-49.73-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9041.09 589.934s-8.78-21.777.89-30.73c12.55-11.637 29.19-2.143 29.19-2.143-8.34 1.379-17.85 1.638-22.69 7.255-5.28 6.151-5.55 17.928-7.39 25.618"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M9071.99 584.77s9.81 3.256 10.47 4.292c4.25 6.761 5.93 8.23 5.93 8.23s-9.7 3.33-14.26 2.727c-4.57-.602-9.5-3.833-9.5-3.833s.18 5.323-1.08 7.156c-1.49 2.181-7.88 5.932-7.88 5.932s-5.72-4.294-6.84-7.141c-1.15-2.931 5.02-9.06 5.02-9.06s-5.65.758-8.99-1.011c-3.46-1.843-8.14-7.528-8.14-7.528s4.6-3.714 7.97-4.14c3.22-.409 12.68 1.553 12.68 1.553s-6.36-4.648-8.47-8.081c-2.19-3.573 4.42-9.502 4.42-9.502s7.15 4.075 10.49 7.318c2.55 2.48.43 8.298.43 8.298s2.75-6.01 5.82-8.104 11.1-1.565 11.1-1.565 2.52 7.304.75 10.196c-1.69 2.744-9.92 4.263-9.92 4.263"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M9063.27 595.769c1.39-.104 3.79.296 4.74-.383.96-.687 2.11-2.853 2.39-4.109.77-3.306.71-5.698-2.52-7.944-1.18-.802-3.4-.038-4.61.054-.67.05-1.48 0-2.12.159-2.51.592-4.4 2.372-5.97 4.025-.63.67-1.21 2.17-.61 3.031.54.769 1.44 1.479 1.93 2.317.65 1.106 1.75 3.35 3.33 3.854 1.06.339 1.45-.432 2.17-.686.77-.271.33-.053 1.27-.318"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9127.86 464.999c24.33-2.704 42.25-21.165 40.02-41.235s-23.76-34.149-48.09-31.445-42.25 21.166-40.02 41.236 23.76 34.148 48.09 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9127.01 415.45s-9.36-2.741-10.01-3.696c-4.24-6.234-5.87-7.564-5.87-7.564s9.03-3.467 13.36-3.052 9.08 3.296 9.08 3.296-.34-5.015.78-6.786c1.34-2.108 7.24-5.861 7.24-5.861s5.53 3.858 6.69 6.506c1.19 2.726-4.43 8.715-4.43 8.715s5.3-.905 8.51.651c3.32 1.622 7.93 6.827 7.93 6.827s-4.21 3.658-7.38 4.174c-3.02.493-12.01-1.039-12.01-1.039s6.16 4.17 8.26 7.338c2.19 3.296-3.84 9.111-3.84 9.111s-6.89-3.603-10.15-6.55c-2.49-2.253-.68-7.812-.68-7.812s-2.39 5.761-5.22 7.839c-2.82 2.078-10.42 1.85-10.42 1.85s-2.62-6.804-1.04-9.592c1.5-2.646 9.2-4.355 9.2-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9116.77 454.811s-22.12 1.512-27.32-9.785c-6.77-14.669 6.61-26.825 6.61-26.825-1.2 7.896-3.75 16.504-.12 22.483 3.97 6.539 14.46 10.233 20.83 14.127"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9135.88 405.886c-1.3.145-3.58-.152-4.45.52-.89.681-1.9 2.763-2.12 3.957-.61 3.144-.48 5.399 2.65 7.409 1.14.716 3.2-.079 4.34-.206.63-.07 1.4-.05 2-.222 2.34-.642 4.07-2.385 5.49-3.997.58-.654 1.07-2.088.48-2.88-.54-.707-1.41-1.347-1.9-2.121-.65-1.021-1.77-3.1-3.28-3.522-1.01-.285-1.35.455-2.02.72-.72.281-.3.06-1.19.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M9078.25 886.212c24.33-2.704 42.24-21.166 40.01-41.236s-23.76-34.148-48.09-31.444-42.25 21.166-40.02 41.236 23.77 34.148 48.1 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M9077.4 836.663s-9.36-2.741-10.02-3.696c-4.24-6.234-5.87-7.564-5.87-7.564s9.04-3.467 13.36-3.052c4.33.415 9.09 3.296 9.09 3.296s-.35-5.015.77-6.786c1.34-2.108 7.24-5.861 7.24-5.861s5.54 3.858 6.69 6.506c1.19 2.726-4.43 8.715-4.43 8.715s5.31-.905 8.51.651c3.33 1.622 7.93 6.827 7.93 6.827s-4.21 3.658-7.38 4.174c-3.01.493-12.01-1.039-12.01-1.039s6.16 4.17 8.27 7.338c2.19 3.296-3.85 9.111-3.85 9.111s-6.89-3.603-10.15-6.55c-2.49-2.253-.68-7.812-.68-7.812s-2.39 5.761-5.21 7.839c-2.83 2.078-10.43 1.85-10.43 1.85s-2.62-6.804-1.04-9.592c1.5-2.646 9.21-4.355 9.21-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9067.15 876.024s-22.11 1.512-27.32-9.785c-6.77-14.669 6.62-26.825 6.62-26.825-1.21 7.896-3.76 16.504-.13 22.483 3.98 6.539 14.46 10.233 20.83 14.127"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M9086.27 827.097c-1.3.145-3.59-.152-4.46.52-.88.681-1.89 2.763-2.11 3.957-.62 3.144-.48 5.399 2.64 7.409 1.14.716 3.21-.079 4.35-.206.63-.07 1.39-.05 2-.222 2.34-.642 4.07-2.385 5.48-3.998.58-.653 1.08-2.087.48-2.879-.53-.707-1.4-1.347-1.9-2.121-.65-1.021-1.76-3.1-3.27-3.522-1.01-.285-1.35.455-2.02.72-.72.281-.31.06-1.19.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.494}
      d="M8306.39 581.337c-25.86 1.944-45.53 20.815-43.92 42.149 1.6 21.335 23.87 37.054 49.73 35.11s45.53-20.815 43.93-42.149c-1.61-21.335-23.87-37.054-49.74-35.11"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8273.49 637.789s-8.78-21.777.89-30.729c12.55-11.638 29.19-2.144 29.19-2.144-8.35 1.379-17.86 1.639-22.69 7.255-5.28 6.151-5.56 17.928-7.39 25.618"
      clipRule="evenodd"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.27}
      d="M8304.39 632.624s9.81 3.255 10.47 4.292c4.25 6.761 5.93 8.229 5.93 8.229s-9.7 3.33-14.27 2.728c-4.56-.603-9.49-3.833-9.49-3.833s.17 5.323-1.08 7.155c-1.49 2.182-7.88 5.933-7.88 5.933s-5.72-4.294-6.84-7.142c-1.16-2.931 5.02-9.06 5.02-9.06s-5.65.759-8.99-1.01c-3.46-1.843-8.14-7.528-8.14-7.528s4.6-3.715 7.97-4.141c3.22-.408 12.68 1.554 12.68 1.554s-6.36-4.648-8.47-8.082c-2.2-3.572 4.41-9.502 4.41-9.502s7.16 4.076 10.5 7.318c2.55 2.481.43 8.298.43 8.298s2.74-6.009 5.82-8.103c3.07-2.094 11.1-1.566 11.1-1.566s2.52 7.304.74 10.196c-1.68 2.745-9.91 4.264-9.91 4.264"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.469}
      d="M8295.67 643.624c1.39-.104 3.79.297 4.74-.382.96-.688 2.11-2.854 2.39-4.109.77-3.306.71-5.699-2.52-7.945-1.18-.802-3.4-.037-4.61.054-.67.05-1.48 0-2.12.16-2.51.591-4.4 2.371-5.97 4.025-.63.67-1.21 2.169-.61 3.03.54.769 1.44 1.48 1.93 2.318.65 1.105 1.75 3.349 3.33 3.853 1.06.339 1.45-.431 2.17-.686.77-.271.33-.052 1.27-.318"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M8538 535.995c24.33-2.704 42.25-21.165 40.02-41.235s-23.76-34.148-48.09-31.445-42.25 21.166-40.02 41.236 23.76 34.148 48.09 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8537.15 486.448s-9.36-2.741-10.01-3.696c-4.24-6.234-5.87-7.564-5.87-7.564s9.03-3.467 13.36-3.052 9.08 3.296 9.08 3.296-.34-5.015.78-6.786c1.34-2.107 7.24-5.861 7.24-5.861s5.53 3.858 6.69 6.507c1.19 2.725-4.43 8.714-4.43 8.714s5.3-.905 8.51.651c3.32 1.622 7.93 6.827 7.93 6.827s-4.21 3.658-7.38 4.174c-3.02.493-12.01-1.039-12.01-1.039s6.16 4.17 8.26 7.338c2.19 3.296-3.84 9.111-3.84 9.111s-6.89-3.603-10.15-6.549c-2.49-2.254-.68-7.813-.68-7.813s-2.39 5.761-5.22 7.839c-2.82 2.079-10.42 1.85-10.42 1.85s-2.62-6.804-1.04-9.592c1.5-2.646 9.2-4.355 9.2-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8526.91 525.805s-22.12 1.513-27.32-9.785c-6.77-14.669 6.61-26.825 6.61-26.825-1.2 7.896-3.75 16.504-.12 22.483 3.97 6.539 14.46 10.233 20.83 14.127"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M8546.03 476.882c-1.31.145-3.59-.152-4.46.521-.88.68-1.89 2.762-2.12 3.956-.61 3.144-.47 5.399 2.65 7.409 1.14.716 3.2-.079 4.35-.206.62-.07 1.39-.05 1.99-.222 2.34-.642 4.07-2.385 5.49-3.997.58-.654 1.07-2.088.48-2.88-.54-.707-1.4-1.347-1.9-2.121-.65-1.021-1.76-3.1-3.27-3.522-1.01-.285-1.36.456-2.03.72-.72.281-.3.06-1.18.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.5}
      d="M8392.69 884.249c24.33-2.704 42.25-21.165 40.02-41.235s-23.77-34.149-48.1-31.445-42.25 21.166-40.02 41.236 23.77 34.148 48.1 31.444"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.266}
      d="M8391.84 834.7s-9.36-2.741-10.02-3.696c-4.24-6.234-5.87-7.564-5.87-7.564s9.04-3.467 13.36-3.052c4.33.415 9.09 3.296 9.09 3.296s-.35-5.015.77-6.786c1.34-2.108 7.24-5.861 7.24-5.861s5.54 3.858 6.69 6.506c1.19 2.726-4.43 8.715-4.43 8.715s5.31-.905 8.52.651c3.32 1.622 7.93 6.827 7.93 6.827s-4.22 3.658-7.38 4.174c-3.02.493-12.02-1.039-12.02-1.039s6.16 4.17 8.27 7.338c2.19 3.296-3.85 9.111-3.85 9.111s-6.89-3.603-10.15-6.55c-2.49-2.253-.68-7.812-.68-7.812s-2.39 5.761-5.21 7.839c-2.83 2.078-10.43 1.85-10.43 1.85s-2.62-6.804-1.04-9.592c1.5-2.646 9.21-4.355 9.21-4.355"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8381.59 874.057s-22.11 1.512-27.32-9.785c-6.77-14.669 6.62-26.825 6.62-26.825-1.21 7.896-3.75 16.504-.13 22.483 3.98 6.539 14.47 10.233 20.83 14.127"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.476}
      d="M8400.71 825.134c-1.3.145-3.59-.152-4.46.521-.88.68-1.89 2.762-2.12 3.956-.61 3.144-.47 5.399 2.65 7.409 1.14.716 3.2-.079 4.35-.206.63-.07 1.39-.05 1.99-.222 2.34-.642 4.07-2.385 5.49-3.997.58-.654 1.07-2.088.48-2.88-.53-.707-1.4-1.347-1.9-2.121-.65-1.021-1.76-3.1-3.27-3.522-1.01-.285-1.35.455-2.03.72-.71.281-.3.06-1.18.342"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M8320.77 526.438c21.44-2.382 37.24-18.451 35.31-35.892-1.94-17.44-20.89-29.647-42.32-27.265-21.44 2.382-37.24 18.451-35.31 35.891 1.94 17.44 20.89 29.647 42.32 27.266"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M8320.09 483.371s-8.24-2.37-8.82-3.199c-3.72-5.413-5.16-6.566-5.16-6.566s7.97-3.025 11.78-2.67 7.99 2.853 7.99 2.853-.29-4.359.7-5.899c1.18-1.834 6.38-5.104 6.38-5.104s4.87 3.346 5.88 5.646c1.05 2.368-3.91 7.58-3.91 7.58s4.67-.794 7.5.555c2.92 1.405 6.97 5.923 6.97 5.923s-3.71 3.185-6.5 3.637c-2.66.433-10.58-.887-10.58-.887s5.42 3.616 7.27 6.366c1.92 2.862-3.4 7.924-3.4 7.924s-6.06-3.123-8.93-5.679c-2.19-1.955-.59-6.789-.59-6.789s-2.11 5.01-4.61 6.82c-2.49 1.81-9.18 1.622-9.18 1.622s-2.3-5.911-.9-8.336c1.32-2.301 8.11-3.797 8.11-3.797"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M8311.01 517.596s-19.48 1.344-24.05-8.469c-5.94-12.739 5.86-23.322 5.86-23.322-1.07 6.864-3.32 14.349-.14 19.541 3.5 5.678 12.73 8.874 18.33 12.25"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M8327.92 475.05c-1.15.127-3.16-.128-3.93.458-.78.593-1.67 2.403-1.87 3.441-.54 2.734-.43 4.693 2.32 6.436 1.01.621 2.82-.073 3.83-.185.55-.062 1.23-.045 1.76-.196 2.06-.561 3.59-2.078 4.84-3.481.51-.568.95-1.815.42-2.503-.47-.614-1.23-1.169-1.67-1.841-.57-.886-1.54-2.692-2.88-3.057-.89-.246-1.19.398-1.78.629-.63.245-.27.052-1.04.299"
      clipRule="evenodd"
    />
    <path
      fill="#55627E"
      stroke="#464D62"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.497}
      d="M9200.05 746.088c15.34-15.154 17.79-37.56 5.46-50.045-12.33-12.486-34.77-10.322-50.11 4.832-15.35 15.154-17.79 37.561-5.46 50.046s34.76 10.322 50.11-4.833"
    />
    <path
      fill="#4A4D6E"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.251}
      d="M9172.82 712.714s-7.93 3.248-8.9 2.954c-6.28-1.937-8.12-1.954-8.12-1.954s4.38-7.31 7.58-9.393c3.21-2.083 8.05-2.718 8.05-2.718s-2.94-3.236-3.11-5.059c-.21-2.17 1.84-7.96 1.84-7.96s5.9-.394 8.12.784c2.29 1.211 1.63 8.372 1.63 8.372s3.17-3.519 6.22-4.21c3.17-.71 9.15.324 9.15.324s-.94 4.802-2.85 6.887c-1.82 1.988-8.85 5.861-8.85 5.861s6.49-.52 9.65.49c3.28 1.053 2.24 8.325 2.24 8.325s-6.69 1.307-10.53 1.078c-2.93-.177-4.67-4.963-4.67-4.963s1.45 5.241.62 8.207c-.84 2.965-6.21 6.964-6.21 6.964s-5.46-3.212-5.87-5.98c-.39-2.627 4.01-8.009 4.01-8.009"
      clipRule="evenodd"
    />
    <path
      fill="#757F96"
      fillRule="evenodd"
      d="M9186.91 745.201s-14.45 13.127-24.12 8.259c-12.56-6.313-9.86-21.936-9.86-21.936 3.42 6.051 6.29 13.323 12.01 15.422 6.26 2.291 15.48-.923 21.97-1.745"
      clipRule="evenodd"
    />
    <path
      fill="#3B3D5A"
      fillRule="evenodd"
      stroke="#383A4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.472}
      d="M9173.81 701.333c-.83.812-2.56 1.858-2.8 2.793-.25.949.18 2.922.66 3.86 1.27 2.482 2.58 3.948 5.81 3.611 1.18-.133 2.17-1.805 2.89-2.517.4-.391.94-.798 1.26-1.243 1.27-1.719 1.53-3.855 1.64-5.732.05-.763-.38-2.012-1.22-2.228-.75-.19-1.69-.151-2.45-.41-.99-.341-2.88-1.153-4.15-.614-.85.358-.69 1.051-1.01 1.598-.35.586-.18.207-.63.882"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M8583 3037.57s-259.79 359.51-425.12 505.53c-168.72 149-633.24 138.35-633.24 138.35s488.47 19.51 657.19-114.41c155.59-123.5 403.04-439.01 403.04-439.01s-124.54 420.66-232.55 609.3c-108.42 189.36-854.29 513.51-854.29 513.51s765.87-291.35 879.39-478.92c113.52-187.58 238.1-633.24 238.1-633.24s-101.16 495.87-146.05 715.82c-41.05 201.28-352 792.78-352 792.78s385.42-680.39 428.12-870.04c49.76-220.84 99.19-643.89 99.19-643.89s62.08 560.08 71.84 790.22c8.33 196.76-5.32 332.59-5.32 332.59s40.74-145.81 37.25-348.55c-3.99-231.93-69.18-784.9-69.18-784.9s116.19 548.98 156.98 779.58c35.44 200.32 484.25 752.97 484.25 752.97s-406.13-560.55-436.35-763.61c-35.05-235.47-170.29-798.21-170.29-798.21s324.58 441.68 394.21 662.51c62.07 196.94 513.08 454.98 513.08 454.98s-432.86-284-489.56-478.92c-66.97-230.15-398.69-694.44-398.69-694.44z"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M8216.08 3512.18c-68.67-20.59-50.17-50.82-120.07-62.47-52.53-8.76-166.02-17.14-216.17-17.14-30.92 0-138.01-12.34-152.54-16.49-10.94-3.14-270.82 61.99-263.09 54.27 29.96-29.95 244.43-84.98 285.13-83.14 78.12 3.56 158.56 6.62 234.17 23.44 48.33 10.72 101.94 1.04 149.87 11.71 21.22 4.71 73.96 23.6 88.99 38.63 1.66 1.65 16.05 17.56 17.56 17.56M8182.56 3907.08c-26.67-5.32-51.05-17.75-77.28-24.59-33.06-8.62-68.18-7.1-100.69-15.22-55.3-13.83-108.2-17.56-166.26-17.56-41.07 0-81.96 5.86-121.77 5.86-12.69 0-30.47 4.68-42.15 9.36-5.44 2.18-17.56 0-17.56 0s4.68-1.57 7.02-2.34c9.84-3.27 21.36-12.96 30.44-15.22 31.24-7.82 59.13-16.47 93.67-21.07 55.39-7.4 213.09-9.26 270.47 3.51 30.39 6.76 156.52 33.21 165.09 50.34 8.3 16.6-19.24 17.56-33.96 17.56-2.3 0-7.02 11.63-7.02 9.37M8944.17 3375.18c76.54 0 149.79 17.54 225.03 23.79 107.82 8.99 216.69 7.32 325.64 7.32 62.98 0 129.29.5 192.1-5.48 20.49-1.95 41.75-1.39 62.19-3.65 5.88-.66 10.5-1.84 16.46-1.84h10.99c-47.89 0-91.42 19.11-137.21 29.27-89.29 19.85-245.37 22.3-334.13 6.15-60.66-11.02-136.97 6.7-197.07-8.3-22.16-5.56-138.33 5.21-141.55 1.99-8.17-8.17-9.44-49.25-22.45-49.25M9141.75 3779.5c79.6 0 196.3 32.03 281.73 42.09 103.32 12.16 183.22-31.1 272.59-31.1 12.16 0 65.43-7.75 113.43-14.64 43.52-6.25-122.1 46.88-152.99 55.72-105.47 30.12-225.6 19.29-335.46 19.29-31.64 0-151.85 7.63-151.85-23.79M8911.25 3988.07c84.72 36.29 156.5 90.41 241.48 124.39 24.3 9.71 52.45 10.37 76.84 20.14 30.87 12.34 73.97 15.03 102.44 29.27 9.45 4.71 25.25 14.63 36.61 14.63 4.63 0 142.48 48.05 137.85 48.05-12.37 0-259.55-43.02-291.53-59.04-49.19-24.58-110.66-36.8-168.31-51.22-25.84-6.44-108.9-54.89-118.91-54.89M8483.15 3931.34c12.8 57.58 43.21 115.37 54.89 173.8 11.63 58.11.53 148.12 23.44 201.57 53.8 125.51 69.87 106.11 69.87 252.15 0 44.52 58.53 176.83 58.53 221.37v45.71c0 7.96-60.26-153.55-71.36-164.64-6.51-6.52-14.23-79.1-18.27-93.31-10.89-38.05-3.14-102.6-14.32-130.56-15.48-38.69-51.7-103.29-60.69-143.84-18.7-84.15-27.88-166.77-43.93-246.99-2.18-10.93-10.83-69.52-20.11-69.52"
      clipRule="evenodd"
    />
    <path
      fill="#4E4A47"
      fillRule="evenodd"
      d="M7711.39 3389.58c-14.3-14.29-32.56-22.03-51.9-30.31-18.12-7.77-37.22-16.09-54.36-32.03-16.2-15.09-31.21-46.03-48.87-68.35-13.08-16.5-27.74-28.26-44.55-28.26-3.05 0-5.54 2.47-5.54 5.53s2.49 5.54 5.54 5.54c13.76 0 25.16 10.56 35.86 24.08 18.01 22.75 33.49 54.19 50.01 69.57 18.17 16.9 38.33 25.86 57.54 34.11 17.99 7.69 35.13 14.66 48.43 27.94a5.517 5.517 0 0 0 7.84 0c2.16-2.16 2.16-5.67 0-7.82M7872.17 3404.45c-10.27-41.11-29.15-61.38-51.79-80.17-14.42-11.97-30.44-23.31-46.63-39.48-6.55-6.57-8.52-19-10.37-31.8-2.13-14.76-3.77-30.06-8.71-39.96-3.02-6.01-8.14-12.88-12.52-19.96-3.71-5.96-7.02-12-7.02-17.8 0-3.06-2.49-5.53-5.54-5.53-3.06 0-5.55 2.47-5.55 5.53 0 6.23 2.48 12.8 6.09 19.27 4.62 8.3 11.12 16.44 14.62 23.46 5.49 10.97 6.18 29.25 9.02 45.1 2.18 12.22 5.69 23.07 12.14 29.51 16.47 16.47 32.73 28.02 47.39 40.18 21 17.42 38.58 36.21 48.12 74.34a5.54 5.54 0 0 0 6.72 4.04 5.55 5.55 0 0 0 4.03-6.73M7805.61 3414.13c-45.25 22.64-92.33 67.69-138.7 100.15-29.72 20.81-59.05 36.48-87.51 36.48-3.06 0-5.54 2.5-5.54 5.56s2.48 5.53 5.54 5.53c30.45 0 62.07-16.23 93.87-38.5 45.93-32.14 92.48-76.89 137.29-99.29 2.74-1.36 3.85-4.71 2.48-7.43-1.37-2.74-4.7-3.86-7.43-2.5M8007.8 3432.06c-35.37 10.12-61.94 29.01-88.53 49.25-25.71 19.61-51.46 40.5-85.93 55.27-15.74 6.75-63.4 30.11-126.48 37.01-3.04.32-5.24 3.06-4.9 6.12.33 3.03 3.07 5.24 6.11 4.89 64.64-7.05 113.51-30.92 129.64-37.83 35.39-15.17 61.88-36.51 88.28-56.62 25.51-19.45 50.92-37.73 84.86-47.42a5.55 5.55 0 0 0 3.8-6.86c-.83-2.93-3.91-4.66-6.85-3.81M8075.69 3434.96c-10.12-35.44-27.64-63.43-42.68-92.38-14.49-27.85-26.62-56.64-26.62-94.53 0-9.95-2.09-28.87-8.36-42.41-4.96-10.7-12.61-18.02-22.8-18.02a5.54 5.54 0 0 0-5.54 5.54c0 3.06 2.48 5.56 5.54 5.56 6.04 0 9.8 5.24 12.74 11.57 5.57 12.06 7.33 28.9 7.33 37.76 0 39.91 12.61 70.29 27.87 99.64 14.72 28.31 31.96 55.64 41.87 90.33.84 2.93 3.91 4.63 6.85 3.81 2.94-.86 4.65-3.92 3.8-6.87"
      clipRule="evenodd"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M7581.2 3302.57c0-11.28-3.93-32.43.96-42.2 3.82-7.63 9.59-16.25 9.59-25.43 0-3.49-3.43-23.02-5.75-23.02M7619.09 3345.25c-21.21 0-43.74-5.69-65.23-2.39-6.08.93-12.5 2.39-18.7 2.39-7.32 0-15.47 4.07-22.06 6.71-1.16.48-15.45 1.35-16.79 0M7649.78 3360.07c6.1-24.42 12.3-38.29 26.37-59.41 10.75-16.13 34.16-25.68 23.98-46.03M7750.49 3213.84c2.67-14.66 7.7-33.1 17.26-45.07 10.01-12.51 20.91-24.96 25.42-40.76 2.01-7.03-5.57-16.05-8.15-22.06-.79-1.84-1.46-7.18-3.36-7.18M7771.59 3295.39c-13.25 4.42-24.02 21.95-35.01 30.2-2.61 1.97-4.86 6.76-7.67 8.17M7830.58 3339.51c-2.18-14.21-7.22-27.04-9.59-41.24-2.06-12.38 2.49-25.86 4.79-37.41 2.63-13.12 16.13-22.96 20.63-36.45 1.52-4.55 2.2-15.2-2.88-17.75M8014.74 3311.19c4.67-10.88 6.23-27.51 14.87-35.94 10.62-10.4 28.22-17.14 34.53-31.66 3.77-8.7 7.17-29.8 4.31-39.81-1.66-5.8-3.84-12.48-3.84-18.7M7995.08 3234.94c-27.01 0-59.51 13.7-83.93-.96-15.36-9.2-19.98-31.45-31.65-44.59-2.64-2.98-6.73-14.39-11.51-14.39M7554.34 3450.29c-8.81 8.81-14.65 16.58-21.1 27.33-5.21 8.7-7.8 19.21-13.91 27.32-12.6 16.82-28.97 31.35-47.47 41.27-13.9 7.42-29.49 16.71-45.09 19.18M7506.39 3455.08c-7.34-7.34-12.4-17.11-20.15-23.97-17.76-15.8-38.01-26.07-59.95-34.06-7.91-2.87-15.32-8.62-22.54-12.95-1.38-.83-5.75-3.6-5.75-5.27M7632.03 3548.13c-1.39 6.94-5.68 11.89-8.15 18.7-1.96 5.38-2.35 11.92-6.71 16.31-4.96 4.95-11.56 10.67-15.83 16.29-8.14 10.72-14.4 19.55-24.94 27.83-8.78 6.89-21.71 13.46-31.65 18.7M7677.59 3514.55c-7.49-5.13-17.47-15.24-26.37-18.22-17.73-5.91-37-5.54-55.15-10.09-4.03-.98-24.46-8.59-24.46-11.97M7887.65 3511.68c-4.41-3.81-10.7-10.22-16.31-13.44-16.54-9.44-39.86-8.96-57.55-14.87-9.9-3.3-13.47-9.15-20.62-16.31-1.81-1.78-9.38-7.18-8.15-7.18M7833.16 3541.95c-9.16 12.82-14.47 27.64-26.38 36.93-9.1 7.1-23.15 8.25-33.09 15.35-8.34 5.96-19.49 9.45-28.77 13.41"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.095}
      d="M9324.51 3415.83c-.8-1.57.26-3.67 2.23-2.68M9213.34 3424.48c-44.06 0-41.48 92.01-16.57 115.34 12.72 11.9 30.17 16.82 41.05 30.89 9.24 11.98 15.17 26.8 21.18 40.58 9.55 21.95 11.68 44.89 7.45 68.35-.58 3.33-11.36 35.44-6.25 37.15M9541.59 3425.98c-.72-.72 5.4-6.9 5.51-7 10.99-12.03 19.85-22.25 21.04-39.09 1.87-25.97-4.23-52.6 8.36-77 12.45-24.16 36.74-36.16 57.28-52.52 28.55-22.72 48.29-68.56 56.86-102.81M9716.16 3403.89c0-1.03-.35-1.09.45-1.49 19.24-9.6 41.51-9.73 57.87-26.1 13.81-13.81 13.49-38.23 23.73-54.46 16.82-26.63 44.33-45.31 62.08-71.92M9620.06 3423.74c-5.35 1.36 16.04 19.05 15.37 30.44-1.25 21.21-22.51 44.35-19.23 64.76 3.03 19.1 41.85 37.12 26.39 60.29M9397.01 3832.13c6.2-6.2 17.11-8.3 22.83-16.87 17.35-26.02-9.52-59.09 9.39-88.63 10.51-16.36 50.45-36.85 50.45-57.15M9607.52 3832.71c-.34-.34-.58-.61-.87 0-10.83 21.63-13.52 43.98-16.42 67.9-6.04 49.52 62.79 78.28 24.02 138.6M9674.81 3810.92c60.64-22.99 18.89-49.83 38.05-88.17 14.26-28.52 46.88-46.67 64.6-73.25M9334.35 3847.93c-13.65 10.22 4.63 38.74 11.63 47.44 29.93 37.28 81.02 48.64 81.02 104.3M9438.65 4088.14c0-7.91 27.94-40.13 34.91-42.81 14.21-5.51 29.48-1.95 43.1-10.75 17-10.97 10.35-47.55 23.12-52.66M9004.16 3524.31c-6.09 12.21-6.04 30.87-16.55 43.72-13.81 16.87-38.55 21.84-47.46 42.81-15.78 37.17-7.03 84.85-30.73 118.03M9105.16 3734.53c-52.6 26.32-47.6 80.86-71.3 125.19-12.7 23.76-36.11 29.48-53.11 48.18M9085.63 4097.4c6.49 0 16.63-10.62 21.47-14.32 39.52-30.33 18.84-58.58 25.52-99.66 2.1-12.96 10.14-23.79 15.96-35.23 2.27-4.39 12.96-40.87 16.42-40.87M9254.98 4147.52c2.16-19.47-11.54-36.39-7.61-56.08.11-.64 45.87-66.6 53.4-77.88M9181.26 4146.94c-8.81-8.81-17.43 52.57-17.75 56.83-4.34 57.87 62.68 99.56 30.73 155.49M9399.41 4203.34c1.06-3.27 14.76 34.59 15.96 44.91 3.99 34.7-4.92 77.56-36.27 98.47M8959.25 4146.19c-7.93-23.78-52.68 25.28-56.25 30.44-22.16 32.04 5.11 56.59-8.48 86.53-12.38 27.22-52.53 41.02-73.28 61.78M8749.93 4040.11c-8.08-6.07 31.37-9.84 32.36-9.55 21.79 6.54 33.58 36.45 53.13 47.89M8718.3 3681.42c-13.04-19.55-62.61 35.42-67 41.48-20.8 28.63-.42 70.33-28.78 106.67-11.02 14.1-46.51 28.87-49.71 46.4M8551.64 4266.3c57.25-28.63 79.26 39 114.59 68.32 26.02 21.63 63.54 31.82 96.82 33.29M8396.92 4103.68c-10.67-5.35-33.1 27.62-45.51 31.18-83.75 23.92-117.48 24.8-189.78 80.41M8004.37 4034.29c-14.79 14.79-14.88 59.75-24.92 79.82-15.7 31.39-41.12 57.55-58.48 88.17-21.74 38.37-31.95 87.14-44.02 129.36M7795.49 4125.31c-6.36-25.47-45.14-39.43-66.69-41.64-63.91-6.52-116.24 18.22-178.59-10.88M7904.86 3846.44c-7.02 2.34-45.57 45.63-72.07 58.19-58.94 27.91-129.63 33.58-185.15 67.74M8020.48 3841.23c-11.9-23.81-8.19-51.03-31.48-70.72-19.14-16.21-108.17-38.47-108.17-63.43M8170.58 3863.6c-4.79-5.99-1.77-76.79-8.05-94.61-10.45-29.59-55.2-65.96-50.58-98.31M8391.25 3692.18c0-35.28-38.96-54.79-55.95-80.28-18.65-27.99-14.92-59.44-14.92-91.02M8336.49 3805.25c-16.64 24.96-33.75 116.14-32.82 145.94 1 32.01 11.75 61.86 4.18 94.43-7.9 33.95-33.18 33.68-48.49 57.74M9096.06 4356.57c-7.26-3.64-41.8 54.28-46.08 63.11-20.2 41.38-9.85 88.1-28.2 130.11-16.23 37.06-56.33 57.12-73.12 93.26M9196.02 4481.3c36.64-36.61 78.15 24.88 115.8 33.58 38.95 8.97 68.56-13.97 103.26-26.13M8320.98 4283.91c-18.58 9.29 27.85 94.19 30.43 103.39 14.47 51.65-6.76 109.3.9 162.94M8507.04 4150.66c-52.19 16.07-47.39 105.13-65.51 143.84-9.74 20.81-33.95 35.01-41.03 56.25M8611.31 4521.88c-18.46-10.57-42.54 19.55-51.61 32.38-20.86 29.45-23.58 68.14-45.95 96.39-22.09 27.83-62.01 31.56-81.92 64.74"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8647.74 4656.32c3.94-15.85 39.24-20.83 50.42-17.77 34.43 9.47 43.26 50.07 86.98 53.43 31.21 2.39 58.96-22.38 90.11-22.38M9241.92 3567.66c19.69-19.69 48.85-11.18 76.58-24.83 14.66-7.21 31.98-29.37 42.78-32.99M9185.12 3521.02c2.84-2.85-8.44 4.01-9.4 4.84-6.01 5.11-12.05 10.27-16.6 16.79-12.34 17.74-7.85 41.48-21.55 58.11-4.15 5.02-9.23 8.86-14.13 13.14-.9.77-8.14 7.4-6.7 7.1M9271.37 3673.58c-3.45-2.32 15.94-6.52 17.49-6.44 11.97.77 21.87 9.9 33.39 12.48 32.06 7.1 55.6-19.48 84.1-26.58M9618.01 3518.14c1.73-.85-16.5-1.06-18.5-.87-11.6 1.01-23.99 7.84-33.17 14.6-12.83 9.42-19.88 29.27-34.19 35.68-18.42 8.22-38.88 5.3-57.71 14.72M9638.76 3553.9c22.96-34.43 74.15-11.54 103.55-35.06M9809.09 3309.15c-1.33 2.68.75-5.99.51-9-.48-6.36-2.23-12.71-4.55-18.67-10.48-26.77-14.29-27.22-5.24-54.34M9786.19 3365.69c-.61-1.23 8.41-.27 9.39 0 6.55 1.62 9.93 6.09 12.53 12.05 10.01 22.85 25.15 18.36 46.75 17.77M9732.34 3706.38c-5.08-2.02-2.05-20.91-5.14-29.45-4.04-11.09-14.76-18.01-19.66-28.55-7.9-17-4.12-43.29 1.68-60.66M9714.14 3764.57c6.78-6.75 19.07-6.46 28.17-10.45 23.07-10.17 57.79-28.07 83.2-28.07M9603.29 3937.01c-1.81-.58.08-2.85.88-3.94 5.69-7.85 17.64-17.45 27.78-17.69 8.22-.21 15.4 4.52 23.89 4.26 15.62-.54 36.03-13.68 48.64-23.15M9622.34 3996.1c3.09-6.14-30.89 9.58-35.07 13.25-10.82 9.48-16.84 22.7-27.27 32.52-8.99 8.46-21.79 13.35-28.76 23.81M9392.41 3937.3c14.26-7.13 17.05-25.99 30.44-33.2 14.23-7.66 41.24-1.6 63.72-12.83M9421.67 3765.37c-1.49-.59 2.19-3.78 2.85-4.34 8.94-7.55 19.72-12.58 31.93-10.37 13.68 2.47 23.36 15.67 37.14 17.37 14.1 1.76 25.41-7.93 38.85-10.16M9469.59 3692.55c-2.84 5.69-21.55-14.93-23.12-17.4-7.9-12.27.19-24.88-2.98-36.45-2.05-7.5-11.41-15.41-16.39-20.94-2.28-2.56-10.64-13.65-14.52-13.65M9023.64 3871.69c0 .03-5.75-7.13-7.1-8.48-3.84-3.84-12.4-6.1-17.59-6.74-7.29-.87-13.89 4.05-21.15 3.57-9.42-.64-45.21-14.95-49.81-24.11M9053.38 3820.31c23.47 0 19.08 39.33 33.02 53.46 2.58 2.63 20.44 18.01 24.22 10.48M8933.15 3671.98c0 4.69 10.16-4.36 13.92-1.57 24.16 17.96 19.79 65.27 68.08 45.95M8953.4 3595.04c0-11.07-26.5-7.93-33.29-10.19-18.78-6.26-34.64-49.55-25.11-66.2M9132.94 4041.55c0-20.25 37.01-17.99 45.34-20.25 17.88-4.84 36.08-18.39 52.68-26.69M9135.2 3979.02c-.05.03-3.75-2.34-6.41-3.86-5.53-3.16-11.76-4.81-17.59-7.31-13.89-5.96-23.33 3.64-33.02-13.84-.9-1.68-5.16-8.86-2.95-11.07M9273.45 4060.33c-6.12-3.06 11.87-3.38 12.56-3.16 3.64 1.19 8.65 11.28 10.45 14.42 14.03 24.55 36.61 7.69 56.33 8.99M9184.21 4265.98c0-11.17 26.69-12.45 31.13-12.26 21.21.9 65.8-1.65 77.77-25.6M9204.88 4325.04c-14.39-7.18-35.54 6.07-50.79 6.84-8.17.4-29.8-16.65-35.57-22.43M9418.51 4285.53c19.72-23.68 59.84-8.09 84.29-17.69 4.58-1.78 8.46-4.13 12.53-6.81 1.07-.69 18.71-15.17 15.43-16.79M9393.6 4330.28c-21.47-21.44-49.19 5.75-72.52 12.67-7.85 2.31-20.6-1.12-26.88 2.84M9668.21 3212.06c-1.94-3.91 10.75-6.49 13.79-6.68 10.37-.64 19.63 4.1 30.04-.16 16.68-6.78 26.87-39.59 45.41-39.59M9638.65 3243.29c-1.86-5.58-10.05-6.33-14.63-8.19-6.94-2.85-13.28-9.15-17.61-15.09-15.01-20.56-10.43-38.92-12.93-61.56M9257.41 3717.69c-12.24 6.12-12.35 19.26-22.51 26.66-8.68 6.28-25.89 2.45-29.96 15.46M9640.94 3580.75c3.46 0-5.51 4.15-7.95 6.6-5.86 5.83-11.92 11.44-17.78 17.29-9.2 9.21-6.68 20.86-14.47 28.66-8.38 8.35-22 6.38-31.08 14.55M9481.73 3673.5c-3.04-1.01-1.12-9.47-.08-11.57 5.32-10.62 17.72-11.5 25.57-18.92 3.88-3.64 5.27-24.77 8.27-25.28M9779.35 3653.52c3.32-6.66 7-9.66 7.34-18.02.27-5.98-2.61-13.51-.53-19.29 2.45-6.83 11.92-9.5 15.25-16.31 2.2-4.57.34-13.27 4.44-16.47M9861.81 3248.67c-.48 2.76.82-14.18-1.84-20.76-4.98-12.26-20.04-16.73-23.68-30.38-4.9-18.17 22.16-59.23 10.83-70.56M9861.19 3252.53c8.12-14.24 28.07-29.75 31.69-38.79 8.2-20.52-3.75-37.04 11.55-55.37"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9780.07 3654.24c0-15.06-17.24-26.35-14.37-43.56 1.3-7.88 19.02-41.27 8.81-46.38M9707.27 3406.66c-1.2-1.2 10.22-.45 11.44-.1 6.07 1.73 8.46 10.32 9.02 15.69 2.48 23.47-7.55 33.48 19.53 38.77 5.93 1.17 14-1.01 18.23 4.26M9618.88 4039.63c-17.29 17.3 2.34 37.44 5.25 57.93 1.96 13.78-5.35 25.41-5.35 38.28"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9618.35 4037.82c.03.06-14.23 10.89-18.22 14.88-8.62 8.64-7.42 21.58-14.77 29.98-8.09 9.24-22.8 11.9-31.61 22.49M9427.9 4003.4c-5.27 21.04 22.32-3.2 30.97-9.85 4.66-3.56 23.82 2.05 23.82-3.94M9424.26 4003.47c-5.27 10.54-10.97 34.27-6.9 46.48M9539.49 3988.61c8.57-17.17-5.03-64.87 16.1-73.33"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9537.97 3989.61c-1.65 3.28 14.48-10.61 17.72-11.65 18.04-5.77 19.64-.21 35.13-12.13M9262.75 3718.62c0-1.35 12 6.47 17.41 14.9 12.29 19.19 11.22 31.13 37.06 27.35M8910.56 3729.66c-5.08 2.56 13.3 35.34 13.97 43.24.64 7.56-1.94 14.55-4.66 21.47-1.41 3.59-6.46 13.68-3.75 10.94M8906.52 3731.39c-1.36-1.33-9.77 10.33-10.94 11.45-14.87 13.99-15.54 29.77-18.33 49.32M8983.35 3907.29c-3.96 0 16.16 37.17 13.79 48.69-.54 2.66-3.75 16.42-7.8 16.42M8980.83 3904.95c-13.15 0-31.93 36.08-33.82 45.58M9162.79 3915.28c6.31-18.89-37.43-33.02-16.71-53.78M9166.14 3909.02c-2.26 2.24 6.02 2.37 9.21 2.61 9.44.74 16.39-5.06 24.82-5.06M9414.94 4489.15c0-8.88 10.41-16.15 13.07-25.09 2.21-7.29-1.2-15-.43-22.43 1.89-17.82 20.97-27.32 34.78-34.77M9417.9 4485.22c-.91-.45 11.47 2.47 13.57 3.09 8.25 2.39 15.83 6.49 23.01 11.09 26.26 16.9 43.88 4.5 71.95 2.02M9361.17 4508.15c-5.19 3.73-2.02 15.17-1.09 19.93 3.33 16.92 12.72 30.94 19.48 46.48 2.37 5.46 2.07 14.21-2.77 18.26M9305.56 4510.44c-.63 1.09 1.28-6.97 1.41-8.7.54-5.88-.85-11.71.7-17.56 4.39-16.66 21.92-29.21 23.25-46.24M9379.88 4345c-6.36 2.13-10.75 23.39-10.57 29.11.32 8.96 8.39 14.13 11.47 22.08 4.21 10.72.16 21.79-4.36 31.64-1.44 3.08-3.43 10.11-6.55 11.84M9374.56 4348.33c-12.46 0-30.84 15.62-38.29 24.56-2.77 3.32-2.96 8.22-6.15 11.22-4.04 3.76-11.31 4.93-16.1 7.69M9196.56 4356.6c-1.87.27 5.72 4.1 5.85 4.21 5.43 3.51 7.69 8.19 10.61 13.72 5.41 10.27 10.2 35.23 22.33 40.1M9193.47 4362.32c-8.22 1.65-7.79 10.22-6.52 17.16 2.82 15.59 14.21 27.03 18.23 41.8.93 3.35.02 20.97-7.32 17.83M8947.09 4635.92c-7.74 7.71 10.48 31.79 12.83 40.87 3.48 13.51-8.07 27.51-9.93 41.08M8944.19 4638.5c-23.41 10.93-28.39 48.82-56.59 52.36M8969.23 4608.73c-.93 2.82.08-6.01-.61-8.89-1.33-5.48-6.15-8.56-10.81-11.23-11.09-6.33-37.96-7.68-36.5-23.91M9005.97 4571.29c-3.59 0 7.13 1.46 10.3 3.14 7.26 3.88 14.08 9.2 19.66 15.3 19.82 21.52 35.74 37.43 65.8 44.27M9032.79 4502.91c.24 3.73-.72-5.56-2.63-8.09-3.81-4.92-10.75-7.05-16.79-6.94-9.42.13-17.77 6.73-27.25 6.46-18.38-.5-35.97-24.34-44.75-38.66M9050.3 4422.08c-.27.08-6.39-15.04-9.61-16.85-6.43-3.61-14.26-4.33-20.4-8.56-13.44-9.24-18.33-27.14-21.53-42.09-1.04-4.93-4.33-13.07-2.9-18.15M9042.61 4456.37c0 .46 13.41-1.73 14.9-1.62 6.73.53 12.27 5.85 16.71 10.3 14.42 14.42 16.02 38.31 33.79 50.58 8.19 5.61 18.54 4.47 27.19 8.8M9283.19 4505.81c-5.43-1.81-6.73 24.35-5.86 28.31 2.56 11.52 15.3 16.92 21.88 25.57 9.1 11.97 14.68 29.56 16.65 44.41M8883.02 4285.83c-.18-.43 6.41 5.8 7.72 8.3 3.78 7.31 6.68 15.93 7.1 24.18.72 14.24.99 25.73 8.76 38.29 7.02 11.39 18.7 19.5 23.78 32.19M8894.2 4215.21c-2.98 1.49-7.59-1.67-10.99-1.3-6.6.74-13.54 3.88-20.22 1.73-22.09-7.11-40.68-39.27-42.23-60.85M8918.17 4170.64c-8.62 5.17.4 25.63 4.02 31.19 7.93 12.29 22.45 18.6 32.06 29.42 13.52 15.22 13.54 30.82 16.02 49.71M8819.96 4327.25c-10.35 13.81 3.81 34.81 10.11 46.62 7.03 13.12 6.1 25.12-2.47 37.49-2.61 3.78-6.39 8.38-10.16 11.04M8815.95 4329.09c-9.88 0-26.4.45-33.48-7.4-6.99-7.71-6.59-24.4-6.59-34.27M8762.26 4370.59c-3.57 0-8.12 11.31-9.64 13.68-3.83 6.04-11.04 14.82-10.35 22.4 1.15 12.61 8.09 19.74 4.5 33.66-.75 2.87-1.62 7.88-4.82 9.07M8768.05 4371.63c-4.47-.42 5.22-7.61 9.18-6.94 4.87.8 7.88 6.33 13.2 5.4 6.6-1.14 8.17-9.82 13.25-11.52M8713.22 4648.93c0-7.29-3.65-17.72.64-24.24 7.45-11.39 25.41-11.63 33.34-23.87 7.34-11.28 2.26-28.49 11.54-38.76M8794.05 4691.47c1.49-.98 1.68-6.78 1.81-8.4.66-9.4-3.57-17.78-.88-27.43 3.73-13.36 18.95-17.67 25.54-28.93 6.34-10.83 3.86-25.43 6.04-37.41M8755.76 4681.1c-2.36-2.37-6.36 4.76-7.26 6.06-4.71 6.76-8.57 16.13-7.48 24.53 2.13 16.02 22.51 23.9 23.31 42.23.35 7.53-3.94 15.54-7.69 21.76-.45.75-5.19 8.62-6.12 6.49M8879.7 4668.59c0-12.29-5.19-29.8-4-42.67 1.02-11.1 10.22-18.2 10.22-30.63M8658.65 4332.07c-7.16-1.81-12.83 20.46-12.83 24.9 0 7.13 5.72 13.57 8.52 19.79 6.94 15.36 10.14 44.38-6.65 55.13M8618.84 4282.31c0-4.79 2.11-8.83 1.04-13.84-1.57-7.34-8.35-17.08-5.19-24.66 4.74-11.28 18.28-14.58 22.03-26.82 3.6-11.79-.63-24.66 2.82-36.61M8471.84 4683.81c-5.14 3.08 11.79 25.25 13.01 31.21 3.83 18.73-6.81 38.05-.18 56.3M8515.61 4646.59c0-22.94-29.03-21.71-43.26-28.31-10.47-4.84-13.86-21.47-15.31-31.58M8551.37 4562.54c0-18.68-20.44-26.79-32.67-37.3-15.97-13.73-19.99-37.92-11.15-57.34M8542.94 4597.44c-.88.37-2.98 1.09-2.53 2.34 1.28 3.54 6.89 5.8 9.5 8.52 5.56 5.77 9.81 13.14 12.58 20.7 7.74 21.31-.56 44.54 5.11 65.74M8402.91 4355.19c-.77-1.17 4.74 18.78 6.6 22.56 7.22 14.69 19.48 23.1 19.73 41 .07 4.95-.28 14.34-6.35 15.78M8397.3 4353.94c-14.34 14.34-8.56 35.89-4.63 53.1.97 4.23 4.73 19.67-1.11 22.01M8427.51 4312.64c-4.72-9.47-7.44-17.64-19.48-20.67-7.17-1.78-14.39.85-20.97-3.62-9.93-6.76-11.29-22.69-10.72-33.55M8459.2 4231.07c-7.34-9.79-25.78-18.44-28.24-29.91-1.67-7.79 1.81-16.39 2.84-24.05 1.68-12.48.73-25.44-4.87-36.61M8451.13 4272.55c0 2.5 5.07 3.8 6.53 4.44 5.19 2.34 9.43 6.09 12.77 10.67 7.43 10.19 9.29 40.68 22.86 44.96 4.87 1.52 9.47-1.62 14.31-.87M8353.83 4554.34c0 2.29 8.9 8.46 10.48 9.93 10.24 9.5 27.76 16.6 34.1 29.29 1.15 2.29 6.02 19.82 1.11 20.52M8351.24 4550.09c-8.66 12.98-9.94 38.26-4.38 52.15 2.98 7.44 10.17 14.44 10.67 22.74.93 15.62-12.12 26.42-16.71 40.23M8352.41 4474.6c-.51.26-6.17-3.65-7.4-3.89-5.68-1.09-11.83-.82-17.02 1.92-11.38 6.04-18.79 17.21-29.1 24.61-12.11 8.7-25.75 12.03-39.46 17.21M8348.71 4387.54c-3.38-6.76.38-26.5 4.5-32.43 4.62-6.63 12.18-8.14 15.48-16.44 3.36-8.49.95-21.16 6.04-28.82M8363.26 4442.99c-.77 0 1.91-.18 2.72 0 2.85.61 5.74 1.12 8.38 2.45 6.13 3.11 9.61 8.12 12.27 14.26 4.36 10.03 8.5 27.49 18.13 33.77 14.3 9.36 33.68-1.07 42.36 14.12M8779.58 4024.47c0-16.26-10.17-27.86-11.23-43.9-1.07-16.02 9.07-26.82 11.84-41.67 2.55-13.65-2.64-31.87 1.59-44.59M8811.58 4057.89c-8.11.48-13.14 14.26-14.5 20.72-2.71 12.91 3.73 26.74-.24 39.09-6.3 19.58-24.66 33.39-26.02 55.18M8838.96 4081.33c0-5.22 8.3-4.13 11.02-2.48 11.73 7.08 36.87 31.11 49.14 9.63"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8842.29 4080.58c-5.22 1.94-3.22 15.91-3.09 19.85.19 6.2-.21 13.86 2.96 19.42 6.2 10.94 23.68 20.57 15.96 36.03M8574.12 3880.87c3.64 0 12.93 9.63 15.54 12.21 11.94 11.76 16.92 33.68 14.55 50.13-1.57 11.09-5.29 22.61-2.53 33.84 3.57 14.47 14.48 26.08 17.78 40.95M8570 3882.79c-12 5.4-9.77 31.21-9.93 41.43-.29 18.99 8.41 33.36 12.88 51.05 3.64 14.37-2.66 37.31-11.57 48.77M8626.72 3829.89c0 2.98 6.68 6.84 8.65 8.76 3.91 3.83 6.25 9.79 7.5 15.03 3.91 16.15.98 33.15 3.78 49.46 2.84 16.71 11.49 31.69 14.28 48.53M8637.84 3758.9c-3.4-8.46-10.72-1.35-16.28 2.53-10.59 7.4-24.69 20.62-32.68 31.03M8160.41 4218.64c-2.58 0-1.29 10.43-1.29 11.76 0 14.19 11.58 21.48 13.56 34.54 3 19.77-19.85 41.13-23.74 60.56M8155.05 4221.28c-27.22 10.91-33.53 41.67-49.82 63.4-6.72 8.97-19.48 10.97-25.28 19.67M8248.83 4171.6c-9.79 2.8-11.25 22.24-9.62 30.2 2.13 10.4 9.25 19.1 12.39 29.16 3.48 11.12 2.43 23.18.62 34.54-.91 5.72-1.88 16.01-7.28 19.61M8206.11 4185.71c-2.17-1.44-.75-10.86-1.48-13.31-2.11-7.16-9.2-12.93-15.66-16.04-18.01-8.7-60.39-5.4-63.07-31.37M8318.56 4146.94c-1.86-2.8-2.37-6.63-3.51-9.74-10.12-27.67 14.98-31.05 27.13-51.99 8.09-13.94 7.39-32.54 9.25-48.03M8258.75 4101.86c-5.53 1.39-9.13 9.29-15.66 8.3-23.4-3.48-36.09-36.29-61.04-34.5M8258.69 4110.25c-11.28 4.09 1.33 28.94 7.46 31.68M8309.38 4018.74c-5.48-7.05-5.76-21.23-15.48-24.61-7.05-2.44-15.81 4.5-22.2 6.18-12.4 3.24-26.99-3.94-37.42-9.93-3.59-2.07-9.06-4.23-10.48-8.51M8302.65 3950.42c3.19-6.36 17.43-7.58 22.88-5.24 15.75 6.81 21.23 29.11 39.21 34.64 9.71 3.01 23.71-2.42 33.79-3.75M7975.1 4123.66c-.38-.08 7.97-2.13 9.19-2.29 7.46-1.03 14.05-1.35 19.79 4.39 4.74 4.74 7.26 12.67 13.44 15.89 4.28 2.26 8.71-.53 12.52-2.45 9.54-4.84 16.99-10.32 28.11-11.23M7915.42 4208.88c-5.41 1.78-10.97 1.09-16.28 3.51-13.61 6.15-29.6 20.33-40.45 30.57-7.65 7.24-13.36 18.12-21.7 24.24-7.2 5.27-19.19-3.3-28.24 3.38M7879.22 4325.71c-3.74 20.57 18.88 23.55 27.32 37.62 16.17 26.96 15.76 60.85 29.22 89.27M7873.92 4338.11c-2.59-7.77-21.63 17.45-24.29 19.98-15.33 14.42-36.55 32.38-57.77 36.61M7892.23 4268.3c-2.87-4.32 11.51-2.29 12.15-2.16 9.05 2.02 16.98 7.13 22.63 14.45 10.27 13.27 14.25 26.52 30.15 34.69 10.32 5.32 22.18 4.9 32.31 10.43M7933.01 4188.13c-3.15-3.16 3-1.19 6.6-1.78 7.58-1.28 16.09-1.12 21.52 5.11 5.44 6.25 5.91 15.27 10.6 22.08 9.07 13.12 27.59 23.79 42.55 28.79M7961.66 4145.53c-4.93-8.19-25.93.74-31.45 2.55-26.23 8.6-50.28 19.43-77.25 6.52M7552.81 4070.07c2.4 1.2-4.46-10.21-4.68-10.53-4.75-6.76-10.68-13.97-12.27-22.27-3.36-17.46 13.34-35.23-1.73-50.98-3.43-3.59-6.62-6.47-10.85-9.08M7554.78 4072.12c-15.09 2.5-43.05-1.06-52.16 12.27-7.14 10.43-8.01 24.61-11.28 36.55-.77 2.83-2.17 11.61-6.29 11.61"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.554}
      d="M7612.69 4086.24c-3.77 0-7.48 23.44-8.15 26.34-4.44 19.19-11.49 63.86-40.94 61.7"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M7629.39 4090c0-13.22 10.22-22.22 2.71-36.88-8.09-15.83-44.71-29.58-32.74-52.78M7719.23 4080.42c-.59.11.37-6.12.3-7.02-.3-4.45-1.9-8.94-3.94-12.88-12.23-23.55-25.65-40.79-6.6-66.41M7704.96 4081.01c-4.6-.94-3.79 5.8-4.38 9.17-1.86 10.7-4.36 21.32-9.06 31.16-8.49 17.77-29.78 24.61-39.34 42.09M7648.75 3973.65c0-17.4-22.34-20.86-33.54-30.36-12.27-10.37-18.73-27.8-22.51-42.89M7647.39 3975.3c2.07-1.04-2.94 3.62-4 5.67-2.4 4.63-3.92 9.84-4.63 14.98-1.71 12.48 6.31 26.39 14.49 35.23M7705.6 3943.24c-.27 1.88-.29-3.6-.37-4.26-.35-3.03-1.01-6.01-2.28-8.81-3.84-8.49-7.73-21.76-14.37-28.18-8.39-8.11-27.8-3.99-38.66-6.17-1.97-.4-10.6-.69-10.6-3.88M7772.68 3924.38c-11.79 7.37-5.79 30.62-1.54 40.81 4.67 11.23 15.51 16.82 22.26 26.39 9.09 12.91 6.3 36.45-1.98 49.33M7825.52 3902.05c-.37.45-1.58 2.71-2.09 2.71-.21 0-1.39-4.01-1.48-4.17-1.23-2.21-3.37-3.97-5.31-5.51-8.07-6.33-16.33-9.37-26.32-11.89-20.43-5.19-35.92 10.98-53.95 15.85M7984.97 3766.78c-3.05 1.31.3-19.07 2.9-22.13 4.92-5.8 16.81-3.89 23.36-8.14 17.62-11.47 11.04-38.85 29.97-48.03M8008.4 3787.85c0 .93 9-1.06 9.8-1.17 5.23-.58 10.76-.77 15.97.08 11.23 1.81 21.56 10.91 32.99 10.91 12.2 0 25.17-11.76 34.34-18.57M7906.54 3737.06c-2.02 0-4.54 6.33-5.92 8.06-5.75 7.27-11.63 15.6-18.93 21.34-11.7 9.24-36.21 9.05-50.37 12.96M7878.05 3709.68c-3.54 0-7.31-3.08-10.91-3.64-8.24-1.28-18.91.77-26.57 3.59-14.46 5.27-25.86 18.46-40.14 22.85M7892.3 3727c-2.33 0 1.7-4.68 1.97-4.92 4.63-4.36 10.75-7.29 16.15-10.48 14.57-8.65 32.07-13.7 44.27-25.92M8145.95 3734.96c7.33 5.48 27.6 6.09 35.27 1.12 8-5.22 13.39-14.61 19.98-21.34 13.44-13.73 32.16-24.43 51.42-26.9M8172.53 3809.38c9.84-4.92 23.34 6.38 32.61 7.9 12.36 2 36.25-9.9 47.66-14.98M8125.33 3713.06c3.04 6.07-7.01 14.72-10.79 17.32-11.72 8.12-40.56 21.45-54.99 16.05M8330.37 3597.51c4.92-12.26 28.85-10.75 37.12-20.94 9.5-11.73 7.49-29.51 13.25-43.05 6.76-15.88 20.67-26.58 30.95-39.96M8321 3548.87c-12.82 0-24.41 8.54-37.12 10.3-12.54 1.73-24.38-3.01-36.75-2.77-6.42.13-14.88 2.61-18.74 8.06M8350.41 3631.25c-7.76 5.83-6.97 19.93-12.52 27.7-13.13 18.38-39.8 20.09-41.06 46.53M8373.71 3651.36c5.22-10.46 2.57-22.88 9.07-32.94 6.45-9.98 20.02-14.74 24.17-26.13M8319.39 3523.91c5.61-11.23 12.49-21.92 21.64-30.52 6.25-5.88 14.02-8.59 19-16.04 6.37-9.55 7.43-21.58 10.6-32.38M8318.35 3522.05c0-21.52-5.2-37.3 9.68-56.4M8112.47 3670.84c-1.8 0 .21-5.11.5-5.75 2.13-4.79 6.73-10.03 11.22-12.56 6.08-3.46 12.14-2.07 18.62-3.4 9.4-1.92 29.56-14.53 31.38-25.47M8107.42 3673.42c0-16.2-13.91-30.94 1.54-43.82M8161.71 3282.27c-1.72 1.71.98 5.14-.19 7.27-4.52 8.25-12.66 17.05-12.45 26.95.57 27.7 15.72 42.22 2.71 70.11M7576.95 3559.59c-16.6 0-33.89 26.16-37.92 40.58-2.65 9.47-2.01 18.84-9.19 26.53-3.5 3.75-9.57 4.09-14.24 5.16M7577.88 3557.92c-25.64 0-29.12-15.62-40.26-35.58M7708.77 3581.55c-6.79-2.72-10.9 7.23-13.81 11.84-4.19 6.68-7.98 13.73-7.77 21.84.24 8.89 6.41 24.64-2.95 30.89M7701.62 3582c-2.53 2.53-7.78-1.41-10.85-1.73-13.02-1.36-23.53-2.93-31.94-14.13M7524.54 3237.09c-28.47 0-22.03-25.84-28.73-45.93"
    />
    <path
      stroke="#4E4A47"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M7521.52 3241.93c0-8.06-8.16-4.12-13.07-1.91-12.26 5.53-26.71 8.51-38.35 14.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      stroke="#2F291E"
      strokeLinejoin="round"
      strokeWidth={2.55}
      d="M8926.5 3036.94s-353.61 359.19-491.51 569.38c-137.92 210.19-516.18 468.28-516.18 468.28s439.46-243 577.37-436.35c128.48-180.13 436.35-500.21 436.35-500.21s-165.84 435.74-248.77 653.62c-105.31 276.71-513.51 854.98-513.51 854.98s527.48-595.99 639.89-872.7c82.43-202.87 164.96-635.9 164.96-635.9s34.59 508.83 34.59 763.62c0 262.95-7.98 1000.25-7.98 1000.25s57.66-750.15 74.5-1000.25c15.38-228.32-53.71-747.16-53.71-747.16s114.54 375.06 175.5 559.5c69.18 209.32 258.68 698.51 258.68 698.51S9311.2 3885.69 9250 3675.5c-57.31-196.86-196.5-549.5-196.5-549.5s502.51 382.75 632 549.5c104.17 134.12 364.5 545.44 364.5 545.44s-171.28-437.79-274.04-574.71C9645.14 3471.96 9053.5 3089 9053.5 3089s367.24 186.39 517.11 255.11c139.74 64.1 410.23 174.41 410.23 174.41l-426.3-245.39-506.04-236.19z"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8635.89 4048.71c43.4 37.22 93.63 118.05 100.98 175.15 9.79 75.86 24.05 67.61 35.33 146.53 6.81 47.68 30.7 99.56 30.7 148.81 0 68.06 27.62 140.67 27.62 209.98 0 9.02 27.78 347.51-6.25 153.81-9.58-54.44-32.83-248.93-52.31-307.31-27.96-83.91-22.03-201.17-61.06-279.23-8.62-17.25-40.84-116.06-56.04-146.45-11.65-23.33-32.94-39.3-49.06-55.39"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M8635.89 4048.71c43.4 37.22 93.63 118.05 100.98 175.15 9.79 75.86 24.05 67.61 35.33 146.53 6.81 47.68 30.7 99.56 30.7 148.81 0 68.06 27.62 140.67 27.62 209.98 0 9.02 27.78 347.51-6.25 153.81-9.58-54.44-32.83-248.93-52.31-307.31-27.96-83.91-22.03-201.17-61.06-279.23-8.62-17.25-40.84-116.06-56.04-146.45-11.65-23.33-32.94-39.3-49.06-55.39"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9308.62 3856.24c-1.25-1.26 70.9 8.06 87.85 13.96 9.74 3.41 19.29 7.51 27.78 13.47 55 38.71 102.46 89.9 163.74 118.98 37.59 17.85 77.5 27.99 118.64 27.46 16.07-.21 32.62-3.17 48.07-3.17 2.11 0 80.09-16.01 76.69-12.47-29.19 30.35-125.51 54.33-155.39 55.58-90.73 3.78-194.68-43.51-261.25-102.68-2.23-1.97-4.23-4.2-6.46-6.14-1.73-1.49-3.41-2.8-5.17-4.18-1.73-1.33-3.4-2.72-5.16-3.99-32.22-23.18-82.67-47.95-81.71-48.93"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M9308.62 3856.24c-1.25-1.26 70.9 8.06 87.85 13.96 9.74 3.41 19.29 7.51 27.78 13.47 55 38.71 102.46 89.9 163.74 118.98 37.59 17.85 77.5 27.99 118.64 27.46 16.07-.21 32.62-3.17 48.07-3.17 2.11 0 80.09-16.01 76.69-12.47-29.19 30.35-125.51 54.33-155.39 55.58-90.73 3.78-194.68-43.51-261.25-102.68-2.23-1.97-4.23-4.2-6.46-6.14-1.73-1.49-3.41-2.8-5.17-4.18-1.73-1.33-3.4-2.72-5.16-3.99-32.22-23.18-82.67-47.95-81.71-48.93"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8345.34 3729.93c-9.7-6.46-14.38-18.59-24.63-24.47-56.89-32.52-125.84-35.26-186.19-60.4-49.87-20.78-98.13-53.35-143.94-81.52-39.72-24.45-80.16-52.9-114.14-84.88-27.24-25.62-124.16-99.59-118.27-92.64 27.48 32.38 150.2 152.69 167 168.2 86.23 79.59 164.93 107.36 267.42 152.91 34.6 15.38 69.35 63.83 95.65 75.54 26.7 11.87 34.5-34.16 49.28-51.4 2.05-2.4 9.15-1.84 8.15-4.85"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M8345.34 3729.93c-9.7-6.46-14.38-18.59-24.63-24.47-56.89-32.52-125.84-35.26-186.19-60.4-49.87-20.78-98.13-53.35-143.94-81.52-39.72-24.45-80.16-52.9-114.14-84.88-27.24-25.62-124.16-99.59-118.27-92.64 27.48 32.38 150.2 152.69 167 168.2 86.23 79.59 164.93 107.36 267.42 152.91 34.6 15.38 69.35 63.83 95.65 75.54 26.7 11.87 34.5-34.16 49.28-51.4 2.05-2.4 9.15-1.84 8.15-4.85"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9780.67 3669.54c20.76 0 60.05 11.25 82.86 13.81 61.8 6.86 129.89-7.66 187.67-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.32 89.21-43.74 7.29-72.37 13.2-110.98-9.34-20.33-11.87-5.82-37.28-17.13-51.4-2.88-3.6-6.95.53-4.5 2.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M9780.67 3669.54c20.76 0 60.05 11.25 82.86 13.81 61.8 6.86 129.89-7.66 187.67-30.31 34.5-13.46 68.1-28.36 100.7-45.92 13.7-7.37 26.1-17.08 39.6-24.8 2.5-1.43 7.6-4.31 7.6-4.31s-4.3 5-6.1 7.82c-15.6 25.04-37.8 49.39-62.1 66.55-58.5 41.48-130.9 77.29-202.32 89.21-43.74 7.29-72.37 13.2-110.98-9.34-20.33-11.87-5.82-37.28-17.13-51.4-2.88-3.6-6.95.53-4.5 2.98"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M9064 3991.85c-6.68-6.67 25.78 52.74 29.45 61.89 14.05 35.12 35.2 71.01 52.1 105.34 34.48 70.03 78.33 138.65 124.78 201.49 18.79 25.44 44.67 44.65 62.74 70.72 21.47 31.05 45.44 59.36 69.87 87.88 8.51 9.9 20.41 26.08 24.48 38.26.88 2.64 64.01 127.56 64.01 127.56s-93.76-141.71-105.28-150.84c-37.41-29.69-79.42-87.75-103.98-116.46-83.17-97.19-90.01-135.93-168.58-236.32-24.16-30.86-49.75-68.19-49.75-108.15 0-13.81-17.03-41.06-16.63-38.64"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M9064 3991.85c-6.68-6.67 25.78 52.74 29.45 61.89 14.05 35.12 35.2 71.01 52.1 105.34 34.48 70.03 78.33 138.65 124.78 201.49 18.79 25.44 44.67 44.65 62.74 70.72 21.47 31.05 45.44 59.36 69.87 87.88 8.51 9.9 20.41 26.08 24.48 38.26.88 2.64 64.01 127.56 64.01 127.56s-93.76-141.71-105.28-150.84c-37.41-29.69-79.42-87.75-103.98-116.46-83.17-97.19-90.01-135.93-168.58-236.32-24.16-30.86-49.75-68.19-49.75-108.15 0-13.81-17.03-41.06-16.63-38.64"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.534}
      d="M8565.65 4045.76c4.84-4.85-12.59 5.48-18.65 8.64-11.58 6.07-24.77 7.99-36.77 13.31-36.71 16.33-77.09 30.41-116.31 39.11-54.02 12-110.31 14.82-164.89 23.63-45.48 7.34-90 20.3-135.45 27.61-16.64 2.69-141.98 39.62-149.72 41.43-137.08 32.41 157.22-15.83 172.18-18.78 52.28-10.33 107.86-30.79 160.74-34.62 71.83-5.19 153.96 10.24 223.97-9.31 37.23-10.41 52.29-55.21 66.07-86.21.53-1.22 3.46-7.82 4.66-7.82"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M8565.65 4045.76c4.84-4.85-12.59 5.48-18.65 8.64-11.58 6.07-24.77 7.99-36.77 13.31-36.71 16.33-77.09 30.41-116.31 39.11-54.02 12-110.31 14.82-164.89 23.63-45.48 7.34-90 20.3-135.45 27.61-16.64 2.69-141.98 39.62-149.72 41.43-137.08 32.41 157.22-15.83 172.18-18.78 52.28-10.33 107.86-30.79 160.74-34.62 71.83-5.19 153.96 10.24 223.97-9.31 37.23-10.41 52.29-55.21 66.07-86.21.53-1.22 3.46-7.82 4.66-7.82"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.909}
      d="M9665.55 3353.53c3.3-13.22 29.37-13.59 37.94-12.77 37.22 3.57 65.58 34.7 117.55 31.56 70.48-4.29 75.29-41.91 126.19-60.85 41.64-15.49 85.37-3.49 127.57 1.86M9973.97 3691.91c-5.19-7.77 8.09-26.87 11.58-33.42 22.05-41.18 74.25-36.93 96.75-71.99 40.1-62.34 1.2-160.28 77.5-202.48M10121.5 3667.17c95.8 22.29 69.6 61.03 128.7 100.62 39.5 26.5 81.7 20.04 125.9 26.37M9986.9 4059.46c-9.26-16.95 53 18.39 66.7 34.62 51.4 60.71 48.5 72.93 129.6 78.41 13.9.93 51 7.85 57.9-9.05M9785.49 3817.98c-54.41 9.61-91.74 52.76-140.56 68.3-26.8 8.51-84.67-6.33-110.5-13.97M9589.53 4054.93c-23.2 5.8-26.5 50.66-18.23 67.24 15.2 30.41 52.55 44.38 69.34 74.66 23.02 41.5 8.76 88.78 11.74 133.54 1.35 20.54 7.45 39.96 7.45 60.82M9404.91 3873.37c17.13-11.44 1.73-91.76 11.3-120.87 17.43-53.06 69.63-81.1 112.36-113.16M9342.59 4113.5c-38.68 0-65.23 48.82-59.75 83.86 2.82 18.01 15.85 31.74 16.36 50.87.45 16.63-11.92 54.2-34.46 51.38M9396.53 4529.36c-8.84-23.94 43.95-38.04 57.36-33.12 18.54 6.78 28.44 24.93 44.59 35.38 55 35.71 107.73 44.92 164.67 4.4M9235.98 3602.6c-7.37-12.88 39.75-33.34 47.52-35.41 26.02-6.9 48.5 12.95 74.68 10.8 33.1-2.77 55.4-30.97 85.07-42.2M9023.93 4321.43c-12.56-3.11-21.85 2.82-32.23 9.21-51.21 31.53-26.04 74.07-57.49 107.41-19.98 21.2-53.72 5.51-72.43 33.55M9018.74 4567.57c-1.17-.45-.35-.45.26-.53 9.4-1.04 19.61 2.04 28.77 4.12 21.95 5 49.54 11.68 64.14 30.36 48.37 61.94 11.82 125.48 120.08 143.65 15.01 2.5 28.89 1.57 43.66-1.73M9023.26 4051.08c-13.97-14-45.07 17.05-56.43 25.83-16.77 12.94-32.78 29.59-54.6 33-44.57 6.97-75.14-27.97-89.85 35.81M9006.95 4771.99c.43-.45-19.93 11.79-24.77 17.69-13.01 15.91-14.42 34.99-16.89 54.71-2.77 22.16 2.71 42.97-6.52 64.17-28.18 64.63-53.14 54.6-59.1 124.87M8813.12 4787.95c-62.23-31.13-75.67 125.83-97.17 152.03-24.5 29.86-66.43 51.3-85.19 84.67M8780.39 4621.95c-42.99-48.37-112.86-39.27-156.82 5.86-21.2 21.76-25.3 59.41-51.11 77.08-19.85 13.59-81.39 4.52-108.09 9.84M8759.48 4388.08c12.43-43.47 60.11-21.58 84.26-30.09 23.18-8.17 39.97-39.78 58.33-54.86 15.43-12.67 38.79-21.58 49.51-38.98M8683.46 4207.68c-11.7-8.78-36.39 14.9-42.46 21.85-29.72 33.98-33.95 82.05-56.17 120.31-32.14 55.48-115.26 60.16-162.79 98.53M8808.33 4666.55c-1.65-1.68-.61-2.19 1.22-3.46 11.15-7.83 33.72-13.68 45.5-5.19 48.16 34.59 54.81 36.85 104.91 4.79M8240.87 4561.39c-9 2.98-18.54 46.3-16.51 57.9 2.84 16.23 13.04 32.41 18.64 47.79 16.35 44.99 13.77 92.53-7.86 135.77M8269.48 4497.09c-18.55-18.55-62.42 2.85-77.34 14.23-26.59 20.36-46.07 48.16-72.28 68.7-29.49 23.1-109.76 34.83-144.56 37.15M8381.17 4364.11c-20.64 3.86-18.48 53.48-15.84 67.34 4.13 21.69 22.64 41.05 31.82 61.12 18.49 40.41 24.5 88.76 17.7 132.44M8397.28 4296.88c-21-3.49-78.38 41.61-106.23 48.05-34.11 7.93-74.22 14.15-109.15 10.8-16.32-1.57-36.73-14.74-52.19-12.53M7985.15 4198.24c-9.2 0-30.89 57.07-31.68 65.61-5.16 55.53 28.21 149.06-37.01 180.13M8042.52 4175.87c0 7.95-1.61-5.88-2.39-7.85-4.04-10.09-14.22-21.58-23.17-27.54-8-5.35-19.19-4.66-26.62-10.54-16.92-13.35-3.11-59.44-.93-79.07M8264.69 4134.73c0-59.41-44.03-30.09-69.88-74.39-17.11-29.35 2.91-63.64-5.99-94.8M8428.83 4110.92c-6.58-8.78-2.06-40.84-7.19-53.64-8.93-22.35-32.5-33.15-42.47-54.47-18.85-40.28 8.03-70.16 21.3-105.54M8339.77 4126.48c-22.15 3.51-68.48 60.82-75.07 83.33-4.35 14.88-.91 36.45-9.85 49.12-15.79 22.35-63.86 40.57-85.86 55.26M8022.69 4005.61c-13.43-1.22-21.75-25.22-36.34-30.07-40.84-13.62-105.9 28.69-97.31-53M8117.87 3940c-2.28 13.78-11.6 68.43-12.65 82-1.46 19 11.13 36.5 14.64 55.23 2.87 15.28-19.15 45.26-27.02 57.5M8200.27 3878.48c-2.73 5.46-2.92-11.89-5.46-17.43-6.3-13.7-14.62-22.98-29.15-27.96-55.74-19.05-84.97 14.98-121.27-57.63M8237.27 3698.92c-21.64-11.47-19.14-60-13.97-79.35 8.24-30.91 40.57-52.81 56.97-79.2 17.45-28.07 16.55-75.35 9.85-106.64M8044.25 3603.61c-7.61-6.12 4.53-23.42 8.39-28.5 17.58-23.17 47.26-34.48 63.76-58.85 26.78-39.49 9.6-107.89-1.33-151.61M7903.68 3513.33c1.99 6.97-20.23 33.82-24.09 39.01-36.33 48.98-102.74 46.75-160.54 50.6M8098.7 3660.7c-19.35 3.62-33.72 52.29-46.73 66.44-29.65 32.22-72.43 44.94-111.28 59.89M7856.03 3481.67c-3.04-1.01 8-17.24 9.32-19.05 14.8-20.17 39.35-29.16 53.78-49.25 24.32-33.87-13.16-79.44 25.42-108.23"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M7804.18 3197.51c-13.94 0-60.86 68.99-77.61 84.26M8134.31 3451.63c-.35 1.41 17.06-31.26 33.54-32.73 57.06-5.1 74.63 3.94 105.83-58.45M8110.88 3513.55c-1.2 2.39-16.93-19.75-25.69-21.85-12.31-2.93-41.31 10.91-49.39.8M7929.58 3335.44c0-10.04 3.16-26.35-3.2-35.02-9.42-12.85-47.43-22.72-35.28-44.59M7943.02 3312.4c-1.02-5.09 23.98-11.84 29.29-18.76 10.71-14.02 2.53-36.93 21.43-43.4"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M7949.94 3305.88c-12.38-15.49 3.5-44.54-7.45-61.78M8294.57 3433.72c-26.88-26.87 60.83-38.66 65.77-60.87"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8294.57 3441.25c-11.64-23.28-11.13-72.34 8.93-88.38M8277.94 3551.88c34.94-34.93 49.32 54.33 111.42 50.32M8225.1 3607.12c-31.15-41.53-55.77-29.08-38.74-80.14M8116.2 3370.18c-2.71 0-.87-20.3 2.27-22.37 9.18-6.12 27.84-1.39 39.53-8.38M7944.88 3787.04c-1.72-1.73-3.24 6.62-3.19 6.86 1.86 9.29 5.77 24.19 2.26 33.42-7.68 20.14-46.19 33.9-46.19 55.23M7940.69 3786.79c-29.09-29.08-84.97 29.49-120.41 26.27M8047.78 3780.17c-4.47-4.47 18.37-20.7 20.77-22.48 15.47-11.49 29.2-28.42 24.62-48.98M8088.52 3824.1c-26.57-5.29-56.24 24.64-62.17 49.01-1.82 7.5 2.47 17.64.13 24.08-1.35 3.72-8.84 21.6-12.24 19.55M8150.95 3829.45c-6 3.99-3.45-14.03-5.6-20.92-5.37-17.27-9.04-33.95 5.06-48.05M8195.67 3972.8c4.91-24.53 27.55-19.93 38.74-30.62 17.65-16.85 19.88-42.52 37.14-59.76M8400.75 3897.26c-10.13-30.41-25.76-58.69 6.31-81.15M8399.87 3903.97c9.8-6.52 23.5-2.26 32.08-11.31 33.89-35.68 15.79-68.38 76.68-87.32M8411.46 4040.17c-4.21-8.4 15.59-27.14 21.16-29.69 15.85-7.26 38.4-.32 55.78-6.25 24.73-8.46 37.58-35.02 54.05-53M8372.68 3984.9c-38.68-38.66-66.63 14.27-110.45 14.27M8235.47 4085.16c0-35.49 72.26-16.25 76.15-16.79 10.13-1.35 18.57-8.94 25.69-15.69M8111.95 4045.23c-5.38-21.53 28.04-52.53 42.33-62.05M7983.35 4125.1c-17.47-26.21-49.88 12.53-68.15 10.24M8025.15 4141.46c-.8 0-.98-.99-1.06-1.86-2.22-24.43 16.05-46.35 31.15-62.69M7959.79 4302.14c-1.72-1.73 1.82 2.26 2.4 2.79 7.31 6.57 18.23 9.26 27.55 11.31 25.42 5.61 52.05 10.27 77.88 13.46M7949.28 4387.07c-11.51-11.5-82.97 10.72-108.5-27.57M7917.73 4444.04c4.86 1.62 8.02 45.33 7.58 50.34M7916.8 4438.45c-33.41 12.95-68.9 22.45-94.78 48.31M8131.91 4344.74c-7.83-31.34-57.62-23.2-34.34-76.42M8123.52 4342.48c-29.57 5.16-54.1 39.64-66.29 64.01M8174.11 4309.32c-16.44 16.45-35.36-55.5-48.19-58.69M8264.36 4235.7c-.75-.24 12.38-9.92 13.05-10.37 7.53-4.98 19.45-12 28.75-11.71 12.81.4 12.63 16.92 21.17 23.55 13.2 10.27 32.96-1.44 44.72-8.39M8259.44 4354.71c-5.04-10.77-16.54 15.04-19.04 18.66-10.88 15.77-23.74 74.55-36.74 77.34M8299.77 4342.88c-17.48-34.97-23.14-41.27-4.26-71.5M8244.4 4802.58c-22.21 0-66.47 86.26-87.46 100.26"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8239.6 4801.39c8.91 8.91 4.29 41.99 7.72 54.6 3.14 11.49 14.16 18.38 20.37 28.07 13.58 21.23 19.3 45.79 19.3 70.56M8253.71 4722.74c-.63 1.89 1.97-8.57 4.13-11.73 5.13-7.48 13.91-15.19 22.36-18.36 25.15-9.45 48.42 12.27 68.43-15.46M8234.94 4656.97c-12.33 6.17-21.83 18.54-34.21 25.41-21.71 12.08-46.51 20.64-67.09 34.35M7976.57 4619.03c0-27.65-85.05-31.93-105.57-50.85"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M7979.89 4618.63c-42.61-2.85-65.93 118.45-79.34 126.59M8069.08 4602.8c-2.16-53.3-105.93-60.72-55.64-131.12M8164.26 4542.48c-56.58 42.44-8.55 110.34-24.23 158.95M8417.56 4552.45c-3.67-7.34 24.44-16.84 25.71-17.16 17.01-4.25 30.79 7.67 43.13 17.43 37.4 29.64 70.02 12.37 110.49-4.12M8417.31 4625.55c-12.16 0-14.23 23.78-14.5 31.69-1.43 41.29 16.11 54.03-15.85 89.98"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8417.31 4625.55c-3.1 0 6.23 4.33 9.32 4.52 5.99.37 13.37 1.84 19.3 3.06 23.23 4.84 36.36 18.6 61.64 16.79M8467.23 4717.13c3.94-7.85-26.58 25.33-31.01 33.82-16.71 31.95 0 55.21-34.08 80M8464.03 4715.29c-12.77-1.97-33.77-9.15-28.21-23.04M8550.17 4715c-3.6-13.33-34.17 29.48-36.88 35.01-20.69 42.33 4.92 91.21-26.62 130.85M8654.65 4603.33c-14.66 2.45-19.13-24.72-18.62-34.48 1.62-31.61 40.7-50.4 27.96-85.46M8582.79 4353.6c-10.33-7.37-15.25 39.72-15.2 41.13 1.33 29.16 18.18 54.79 14.13 85.2M8620.19 4278.91c-18.97-18.97-70.88 6.84-60.98-39.4M8424.24 4447.71c-5.99 0 4.34 17.24 5.85 20.75 5.98 13.97 5.38 24.05-5.06 34.48M8878.31 4675.73c12.37 6.19 29.21-13.36 30.33-24.75 4.55-45.5-27.7-59.12 22.77-95.17M8731.86 4899.38c-29.82 19.87 16.29 60.74 23.05 76.41 10.29 23.95 2.36 50.88-1.87 74.93M8673.97 4977.93c-.56 1.65-25.63-5.72-38.88-.94-35.06 12.62-61.51 48.72-101.02 48.72M8756.9 4819.8c-5.69-3.8-2.02-5.24-9.6-8.27-44.49-17.8-65.64 42.14-104.22-15.73M8934.47 4950.1c-3.88 0 6.81-3.78 10.38-5.32 9.34-4.02 15.43-2.05 22.11 5.32 22.83 25.25 43.61 43.58 80.27 40.6M8899.67 5033.42c-7.74-1.65-6.7-7.71-16.57-5.85-27.99 5.24-39.33 52.18-79.88 56.43M8967.36 4824.7c-21.15-21.16-57.82-26.4-76.41-49.65M9111.91 4602.26c-1.91-1.91-.08-10.93-1.19-14.12-17.22-48.75 20.27-102.2 58.56-132.85M9160.63 4705.15c-13.04 7.82 45.1 16.55 63.11 8.12 36.74-17.19 44.78-51.89 72.8-76.82M9221.45 4746.58c5.4-23.97-47.44 42.2-49.91 56.97-6.49 39.03 41.27 56.96 8.14 94.64M9266.5 4746.58c-16.36-20.43 91.92-71.41 104.86-79.5M9267.14 4746.58c-6.04 12.08 32.88 15.57 40.6 21.82 20.86 16.89 38.47 55.53 68.27 32.33M8828.76 4151.39c0-7.35-7.42 13.01-4.52 23.41 5.69 20.49 16.76 38.02 13.73 60.45-.88 6.49-9.58 30.52-20.25 23.42M8826.5 4147.93c-35.04 5.53-53.48 16.12-82.93 40.47M8893.47 4111.98c-6.25 0-14.79-9.39-19.16-13.06-56.88-47.39-28.62-65.75-58.05-115.4M8964.3 4262.39c-8.81 8.81-20.19-9.42-21.58-15.43-4.79-20.75-12.34-54.28 6.65-69.9"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M8956.03 4262.53c10.88 12.69 37.32.82 50.6-1.33M8874.85 4332.31c-10.17-15.24-17.51-40.81-11.6-58.59 5.42-16.28 27.08-36.74 17.98-54.97M8877.91 4456.75c-3.09 3.09 1.62 27.17 1.33 31.96-1.41 21.82-13.54 40.25-21.45 60.02M9284.03 4192.66c-10.3-10.33-6.07-27.27-21.42-38.21-18.73-13.33-58.56-14.95-70.16-36.21M9292.68 4268.14c49.65 33.07 24.21 50.53 28.76 99.03M9503.01 4536.89c11.22 19.67 35.33-18.28 37.01-29.42 2.76-18.52-16.31-58.41-5.86-72M9609.38 4560.34c-7.72 13.62 15.8 41.56 16.63 57.49 1.44 27.97-17.83 51.46-24.88 77.35M9666.34 4537.82c8.41-30.54 42.79-47.49 71.63-52.57M9669.14 4537.03c35.76 15.75 71.09 66.33 115.55 45.79M9664.88 4393c-35.95 15.38-36 61.07-37.67 94.51"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M9662.89 4395.8c27.27 12.32 51.67 36.79 56.83 67.74M9656.1 4245.76c.61-11.12 22.78.53 33.07 4.79 31.13 12.88 46.09 48.88 76.47 31.96M9620.42 4180.12c-11.94-19.9-73.59 30.28-100.23 25.57M9419.41 3798.08c3.14-6.28 14.23-14.1 19.45-18.23 42.73-33.84 51.88 56.41 101.42 16.76M9464.53 3691.73c-14.29-39.33-88.15-42.26-58.03-99.73M9535.36 3878.62c0-19.56-44.91 6.25-55.77-7.19M9651.31 3877.02c-5.61-47.63-36.69-93.1-26.1-142.03M9613.9 3891.12c-17.37 5.81-9.02 64.82-6.78 78.81M9718.65 3844.8c54.87 38.21 46.75 54.17 43.53 112.09M10035.8 4081.36c64.3-42.86 17.6-77.99 70.9-120.61M10113.7 4163.09c32.4-50.31 32.6-132.15 98.2-147.48M10183.6 4174.93c-9.9 4.28-3.8 29.8-3.8 37.94 0 34.62 3.7 65.27-23.2 92.14M10243.3 4166.55c28.2-42.78 7.8-65.08 67.2-81.07"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10241.8 4164.02s10.6.96 12.4 1.2c9.3 1.33 19 4.87 26.2 11.04 16.6 14.18 21.6 39.41 41.1 50.21M9307.47 3570.99c-4.36 1.09 7.4-5.3 10.25-8.78 6.33-7.85 8.86-15.81 7.71-25.84-2.95-25.78-19.18-68.75-.93-91.31M9412.23 3558.75c-1.26 2.52 5.56 1.19 8.38 1.46 10.53.9 22.93.96 32.88 4.79 18.49 7.08 19.27 30.14 31.96 43.26M10381 3788.23c-7.1 0 13-22.51 14.6-23.41 2.7-1.47 4.2-1.92 7.9-2.16 36.9-2.23 46.9-23.04 75.9-41.66M10379.4 3792.89c12.3 12.34 87 48.58 113 48.58M10264.6 3778.79c-2.8-11.28-20.6 26.44-22.3 31.02-13.2 35.76 12 75.88-23.6 103.82M10313.4 3786.1c-4.4-56.51 1.3-58.75 48.6-91.45M10203.7 3706.23c8.4-37.11 38.1-44.78 66.7-64.97M10113.7 3466.48c-2.8-5.48 9.3 8.03 14 12 7.1 6.04 13.7 12.32 20.3 18.89 20.8 20.46 46.4 16.68 73.4 14.9M10091 3571.12c-58.9-9.81-51.5-27.06-50-86.79M10166.8 3381.81c14.1-42.38 4.2-50.28 42.9-73.46M10164.8 3387c-4.5-4.52 12.7 2.13 18.8 4.02 9.9 3 19.3 7.37 29.2 10.51 31.7 10 57.1-9.08 83.8-23.05M10087.7 3317.53c-1.1-2.76-7.4-4.01-7.7-5.05-6.3-25.36 57.1-52.58 74.7-56.59"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={5.348}
      d="M10082.7 3313.27c-5.9 26.61 42.5 16.23 69.9 7.19M9931.45 3322.98c-3.4-17.02 30.49-97.56 14.37-113.69M9863.29 3358.8c-27.99 35.97 57.36 52.55 36.61 101.82M9650.43 4268.14c-1.83 2.42-19.58-5.06-23.44-5.19-14.36-.56-30.27 7.58-43.26 12.9-21.02 8.6-39.51 47.2-62.55 35.68"
    />
    <path fill="#3F4142" d="M12877 3178h-40v60h40z" />
    <path
      fill="#257676"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12920 3347h-126v659h126z"
    />
    <path
      fill="#A7C7C6"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 3464.39h-125.1v541.13h125.1z"
    />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.405}
      d="M12919.5 3502.72h-125.1v471.31h125.1z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12940.9 3248.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91z"
      clipRule="evenodd"
    />
    <path
      fill="#D9D9D9"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.157}
      d="M12843.7 3538.6c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 3579.33c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12843.7 3620.06c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 3660.79c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12843.7 3701.52c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12843.7 3742.24c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M12843.7 3782.97c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 3823.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12843.7 3945.88c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M12843.7 3864.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12843.7 3905.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12871.1 3959.97c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M12872.3 3554.64c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12872.3 3595.37c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12872.3 3636.1c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 3676.83c5.6 0 10-4.7 10-10.5s-4.4-10.49-10-10.49c-5.5 0-9.9 4.69-9.9 10.49s4.4 10.5 9.9 10.5M12872.3 3717.56c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 3758.29c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 3799.01c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12872.3 3921.2c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M12872.3 3839.74c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12872.3 3880.47c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M12899.7 3946.28c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M12900 3539.62c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 3579.23c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12900 3619.96c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 3660.69c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 3701.42c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 3742.15c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12900 3782.87c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12899.7 3905.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M12899.7 3823.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M12899.7 3864.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M12816.4 3961.97c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M12816.4 3555.19c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12816.4 3595.92c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12816.4 3636.65c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12816.4 3677.38c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12816.4 3718.11c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12816.4 3758.83c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M12816.4 3799.56c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12816.4 3921.75c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M12816.4 3840.29c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M12816.4 3881.02c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m12794.4 4004.94 125.1.82s-41 25.24-62 25.24-63.1-26.06-63.1-26.06"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M12908.5 3237.55v109.1h-6.7l-7.1 658.29-31.7 24.56 56.5-24.56v-658.29s15.7 3.64 20.5-5.15 0-101.5 0-101.5z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 3346.64h-125.1v658.88h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 3464.39h-125.1v541.13h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12919.5 3502.72h-125.1v471.31h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12940.9 3248.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91zM12794.4 4005.76h125.1s-36.5 25.06-61.5 25.06-63.6-25.06-63.6-25.06"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M13136 3725h-40v60h40z" />
    <path
      fill="#257676"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13179 3894h-126v659h126z"
    />
    <path
      fill="#A7C7C6"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 4011.39h-125.1v541.13h125.1z"
    />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.405}
      d="M13178.5 4049.72h-125.1v471.31h125.1z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13199.9 3795.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91z"
      clipRule="evenodd"
    />
    <path
      fill="#D9D9D9"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.157}
      d="M13102.7 4085.6c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 4126.33c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13102.7 4167.06c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 4207.79c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13102.7 4248.52c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13102.7 4289.24c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13102.7 4329.97c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 4370.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13102.7 4492.88c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13102.7 4411.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13102.7 4452.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13130.1 4506.97c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13131.3 4101.64c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13131.3 4142.37c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13131.3 4183.1c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 4223.83c5.6 0 10-4.7 10-10.5s-4.4-10.49-10-10.49c-5.5 0-9.9 4.69-9.9 10.49s4.4 10.5 9.9 10.5M13131.3 4264.56c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 4305.29c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 4346.01c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13131.3 4468.2c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13131.3 4386.74c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13131.3 4427.47c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13158.7 4493.28c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13159 4086.62c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4126.23c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13159 4166.96c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4207.69c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4248.42c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4289.15c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13159 4329.87c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13158.7 4452.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M13158.7 4370.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13158.7 4411.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M13075.4 4508.97c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13075.4 4102.19c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13075.4 4142.92c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 4183.65c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13075.4 4224.38c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 4265.11c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 4305.83c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13075.4 4346.56c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13075.4 4468.75c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13075.4 4387.29c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13075.4 4428.02c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13053.4 4551.94 125.1.82s-41 25.24-62 25.24-63.1-26.06-63.1-26.06"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13167.5 3784.55v109.1h-6.7l-7.1 658.29-31.7 24.56 56.5-24.56v-658.29s15.7 3.64 20.5-5.15 0-101.5 0-101.5z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 3893.64h-125.1v658.88h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 4011.39h-125.1v541.13h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13178.5 4049.72h-125.1v471.31h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13199.9 3795.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91zM13053.4 4552.76h125.1s-36.5 25.06-61.5 25.06-63.6-25.06-63.6-25.06"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M13395 4295h-40v60h40z" />
    <path
      fill="#257676"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13438 4464h-126v659h126z"
    />
    <path
      fill="#A7C7C6"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 4581.39h-125.1v541.13h125.1z"
    />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.405}
      d="M13437.5 4619.72h-125.1v471.31h125.1z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13458.9 4365.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91z"
      clipRule="evenodd"
    />
    <path
      fill="#D9D9D9"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.157}
      d="M13361.7 4655.6c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13361.7 4696.33c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 4737.06c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13361.7 4777.79c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 4818.52c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 4859.24c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13361.7 4899.97c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13361.7 4940.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13361.7 5062.88c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13361.7 4981.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13361.7 5022.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13389.1 5076.97c5.6 0 10-4.69 10-10.49s-4.4-10.5-10-10.5c-5.5 0-9.9 4.7-9.9 10.5s4.4 10.49 9.9 10.49M13390.3 4671.64c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 4712.37c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 4753.1c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13390.3 4793.83c5.6 0 10-4.7 10-10.5s-4.4-10.49-10-10.49c-5.5 0-9.9 4.69-9.9 10.49s4.4 10.5 9.9 10.5M13390.3 4834.56c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13390.3 4875.29c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13390.3 4916.01c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 5038.2c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-9.9 4.7-9.9 10.49 0 5.8 4.4 10.5 9.9 10.5M13390.3 4956.74c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13390.3 4997.47c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-9.9 4.7-9.9 10.5 0 5.79 4.4 10.49 9.9 10.49M13417.7 5063.28c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13418 4656.62c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13418 4696.23c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13418 4736.96c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13418 4777.69c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13418 4818.42c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13418 4859.15c5.5 0 10-4.7 10-10.5 0-5.79-4.5-10.49-10-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13418 4899.87c5.5 0 10-4.7 10-10.49 0-5.8-4.5-10.5-10-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13417.7 5022.16c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M13417.7 4940.7c5.6 0 10-4.7 10-10.49 0-5.8-4.4-10.5-10-10.5-5.5 0-10 4.7-10 10.5 0 5.79 4.5 10.49 10 10.49M13417.7 4981.43c5.6 0 10-4.7 10-10.5 0-5.79-4.4-10.49-10-10.49-5.5 0-10 4.7-10 10.49 0 5.8 4.5 10.5 10 10.5M13334.4 5078.97c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13334.4 4672.19c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13334.4 4712.92c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 4753.65c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13334.4 4794.38c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 4835.11c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 4875.83c5.5 0 9.9-4.69 9.9-10.49s-4.4-10.5-9.9-10.5c-5.6 0-10 4.7-10 10.5s4.4 10.49 10 10.49M13334.4 4916.56c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13334.4 5038.75c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5M13334.4 4957.29c5.5 0 9.9-4.7 9.9-10.49 0-5.8-4.4-10.5-9.9-10.5-5.6 0-10 4.7-10 10.5 0 5.79 4.4 10.49 10 10.49M13334.4 4998.02c5.5 0 9.9-4.7 9.9-10.5 0-5.79-4.4-10.49-9.9-10.49-5.6 0-10 4.7-10 10.49 0 5.8 4.4 10.5 10 10.5"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13312.4 5121.94 125.1.82s-41 25.24-62 25.24-63.1-26.06-63.1-26.06"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13426.5 4354.55v109.1h-6.7l-7.1 658.29-31.7 24.56 56.5-24.56v-658.29s15.7 3.64 20.5-5.15 0-101.5 0-101.5z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 4463.64h-125.1v658.88h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 4581.39h-125.1v541.13h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13437.5 4619.72h-125.1v471.31h125.1z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13458.9 4365.46c0-6.02-4.9-10.91-10.9-10.91h-146.1c-6 0-10.9 4.89-10.9 10.91v87.28c0 6.02 4.9 10.91 10.9 10.91h146.1c6 0 10.9-4.89 10.9-10.91zM13312.4 5122.76h125.1s-36.5 25.06-61.5 25.06-63.6-25.06-63.6-25.06"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.5}
      d="M12994.2 1461.66h-40.2v231.89h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.609}
      d="M12994.2 1507.02h-40.2v132.63h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.5}
      d="M12994.2 1974.22h-40.2v231.89h40.2zM13749.1 1974.22h-40.2v231.89h40.2zM13749.1 1453.96h-40.2v231.89h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.609}
      d="M12994.2 2019.57h-40.2v132.63h40.2z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.499}
      d="M13708.9 1381.22c0-39.31-31.9-71.22-71.2-71.22H13068c-39.3 0-71.2 31.91-71.2 71.22v896.51c0 39.31 31.9 71.22 71.2 71.22h569.7c39.3 0 71.2-31.91 71.2-71.22z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.501}
      d="M13666.3 1416.99c0-34.6-28.1-62.69-62.7-62.69H13102c-34.6 0-62.6 28.09-62.6 62.69v824.98c0 34.6 28 62.69 62.6 62.69h501.6c34.6 0 62.7-28.09 62.7-62.69z"
      clipRule="evenodd"
    />
    <circle cx={13351.9} cy={1896.05} r={55} fill="#257676" />
    <circle cx={13247.4} cy={1898.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle cx={13401.9} cy={1804.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle cx={13406.4} cy={1985.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle
      cx={13209.4}
      cy={1829.05}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle
      cx={13364.9}
      cy={2053.05}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle
      cx={13481.4}
      cy={1806.55}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle cx={13238.4} cy={1760.55} r={13} fill="#257676" fillOpacity={0.4} />
    <circle cx={13526.4} cy={1865.55} r={13} fill="#257676" fillOpacity={0.4} />
    <circle cx={13291.4} cy={2062.55} r={13} fill="#257676" fillOpacity={0.4} />
    <path
      fill="#257676"
      d="M13110.6 1559.55v-72.38h53.7v11.37h-41v18.82h36.3v11.48h-36.3v19.34h41.5v11.37zm67.7 0v-54.6h12.7v8.38c3.6-5.07 8.4-9.51 17-9.51 12.4 0 19.5 8.17 19.5 20.89v34.84h-12.6v-31.02c0-8.58-4.2-13.34-11.6-13.34s-12.3 4.97-12.3 13.55v30.81zm83 1.04c-7.9 0-16.2-2.69-23.2-8.17l5.6-8.48c6.1 4.45 12.2 6.72 17.9 6.72 5.4 0 8.5-2.27 8.5-5.89v-.21c0-4.14-5.8-5.69-12.2-7.65-8-2.17-17.1-5.59-17.1-15.93v-.2c0-10.45 8.6-16.76 19.5-16.76 6.9 0 14.2 2.38 20 6.21l-4.9 8.89c-5.3-3.2-10.9-5.17-15.5-5.17-4.8 0-7.6 2.38-7.6 5.38v.21c0 3.92 5.9 5.79 12.3 7.75 7.9 2.48 17 6.1 17 15.93v.2c0 11.48-8.9 17.17-20.3 17.17m58.1.21c-15.7 0-28-11.48-28-28.34v-.21c0-15.71 11-28.43 26.7-28.43 17.3 0 26.1 13.65 26.1 29.37 0 1.13-.1 2.27-.2 3.51h-40.1c1.3 9 7.5 13.86 15.7 13.86 6.2 0 10.4-2.28 14.8-6.52l7.3 6.52c-5.2 6.2-12.3 10.24-22.3 10.24m-15.6-32.37h28c-.8-7.96-5.6-14.38-13.8-14.38-7.8 0-13.1 5.8-14.2 14.38m52.9 31.12v-54.6h12.6v8.28c3.5-4.86 8.3-9.41 16.6-9.41 7.9 0 13.5 3.82 16.4 9.61 4.4-5.79 10.1-9.61 18.4-9.61 12 0 19.1 7.55 19.1 20.89v34.84h-12.5v-31.02c0-8.68-4-13.34-11.1-13.34-6.9 0-11.6 4.76-11.6 13.55v30.81h-12.6v-31.12c0-8.58-4-13.24-11-13.24s-11.7 5.17-11.7 13.55v30.81zm129.4 1.14c-9.1 0-14.8-4.55-18.6-9.61v8.47h-12.7v-75.48h12.7v29.98c4-5.68 9.6-10.23 18.6-10.23 12.8 0 25.3 10.13 25.3 28.33v.21c0 18.2-12.4 28.33-25.3 28.33m-3-10.86c8.6 0 15.6-6.72 15.6-17.47v-.21c0-10.55-7.3-17.47-15.6-17.47-8.6 0-16 7.03-16 17.47v.21c0 10.44 7.4 17.47 16 17.47m41.8 9.72v-75.48h12.7v75.48zm54 1.25c-15.7 0-28-11.48-28-28.34v-.21c0-15.71 11.1-28.43 26.7-28.43 17.4 0 26.2 13.65 26.2 29.37 0 1.13-.1 2.27-.3 3.51h-40.1c1.4 9 7.6 13.86 15.7 13.86 6.2 0 10.4-2.28 14.8-6.52l7.4 6.52c-5.3 6.2-12.3 10.24-22.4 10.24m-15.6-32.37h28c-.8-7.96-5.5-14.38-13.8-14.38-7.8 0-13 5.8-14.2 14.38m-393.3 147.08c-10.6 0-19.2-3.44-27.3-10.69l4.7-5.54c7 6.4 13.7 9.45 22.9 9.45 9.1 0 14.9-4.77 14.9-11.36v-.19c0-6.2-3.3-9.64-17.3-12.69-15.4-3.34-22.5-8.31-22.5-19.29v-.19c0-10.4 9.3-18.23 22-18.23 9.8 0 16.6 2.77 23.5 8.21l-4.4 5.82c-6.2-5.06-12.4-7.25-19.3-7.25-8.8 0-14.2 4.68-14.2 10.79v.19c0 6.3 3.3 9.92 18.1 12.98 14.9 3.34 21.8 8.68 21.8 18.9v.19c0 11.45-9.6 18.9-22.9 18.9m59.2.19c-14.5 0-25.3-11.74-25.3-25.58v-.19c0-14.03 10.8-25.78 25.3-25.78 9.4 0 15.1 3.82 19.8 8.79l-4.9 5.15c-3.9-4.1-8.2-7.44-15-7.44-10 0-17.7 8.4-17.7 19.09v.19c0 10.69 7.9 19.18 18.2 19.18 6.4 0 11.1-3.15 15.1-7.35l4.6 4.39c-4.9 5.64-10.8 9.55-20.1 9.55m32.5-61.28v-8.12h8.4v8.12zm.5 60.13v-49.35h7.3v49.35zm45.9 1.15c-13.4 0-24.6-10.4-24.6-25.68v-.19c0-14.22 9.9-25.68 23.7-25.68 14.6 0 23 11.65 23 26.06 0 1.05 0 1.53-.1 2.39h-39.1c1 10.69 8.5 16.7 17.3 16.7 6.9 0 11.5-2.76 15.6-6.96l4.6 4.1c-5 5.63-10.9 9.26-20.4 9.26m-17.1-28.54h31.7c-.7-8.88-5.8-16.8-15.7-16.8-8.7 0-15 7.25-16 16.8m52.1 27.39v-49.35h7.3v8.6c3.3-5.35 8.4-9.65 16.9-9.65 11.8 0 18.9 8.02 18.9 19.76v30.64h-7.4v-28.82c0-9.17-4.8-14.89-13.6-14.89-8.5 0-14.8 6.2-14.8 15.46v28.25zm75.3.86c-8 0-13.9-3.91-13.9-13.93v-29.78h-6.9v-6.5h6.9v-14.89h7.3v14.89h15.7v6.5h-15.7v28.82c0 6.11 3.3 8.21 8.3 8.21 2.6 0 4.6-.48 7.2-1.72v6.3c-2.6 1.44-5.4 2.1-8.9 2.1m22.3-60.99v-8.12h8.4v8.12zm.4 60.13v-49.35h7.4v49.35zm27.2 0v-42.85h-6.8v-6.4h6.8v-4.3c0-5.63 1.4-9.83 4.3-12.69 2.6-2.58 6.1-3.82 10.6-3.82 3.4 0 5.7.38 8.1 1.24v6.4c-2.7-.77-4.6-1.24-7.1-1.24-5.8 0-8.6 3.53-8.6 10.5v4.01h15.6v6.3h-15.5v42.85zm33 0v-49.35h7.3v49.35zm-.5-60.13v-8.12h8.4v8.12zm47.2 61.28c-14.5 0-25.3-11.74-25.3-25.58v-.19c0-14.03 10.8-25.78 25.3-25.78 9.4 0 15.1 3.82 19.8 8.79l-4.9 5.15c-3.9-4.1-8.2-7.44-15-7.44-10 0-17.7 8.4-17.7 19.09v.19c0 10.69 7.9 19.18 18.2 19.18 6.4 0 11.1-3.15 15.1-7.35l4.6 4.39c-4.9 5.64-10.8 9.55-20.1 9.55"
    />
    <path fill="#3F4142" d="M14410 1484h-48v60h48z" />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14265.6 1485.64-59.3-227.09h372.6l-56 226.08z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14444 411h-115.8v47.933h115.8zM14612.8 683.695h-51.2v74.135h51.2zM14202.5 683.695h-44.1v74.135h44.1z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14080.5 647.206-.3-64.62 113.9-123.494 373.9-.158 124.1 117.244-2 71.028z"
      clipRule="evenodd"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14605.9 1219.99c0-7.1-5.8-12.85-12.9-12.85h-417c-7.1 0-12.9 5.75-12.9 12.85v25.71c0 7.09 5.8 12.85 12.9 12.85h417c7.1 0 12.9-5.76 12.9-12.85z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14652.6 793.645c0-19.771-16.1-35.815-35.8-35.815h-466.7c-19.8 0-35.8 16.044-35.8 35.815 0 19.763 16 35.814 35.8 35.814h466.7c19.7 0 35.8-16.051 35.8-35.814M14187.3 1084.14l-100.5 123h595.4l-99.1-125.9zM14176.5 958.242l-100.6 122.998h595.5l-99.2-125.892z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14187.3 832.351-100.5 123.001h595.4l-99.1-125.895z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14714.2 634.932H14058v52.817h656.2z"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m14532.1 458.934 119.5 128.622 5.6 47.271 34.9 1.042v-57.698L14570 458.934zM14552.3 831.001l67.1 124.348h62.8l-97.5-125.892zM14545.1 958.894l67.1 124.346h62.8l-97.5-125.89zM14552.3 1082.78l67.1 124.35h62.8l-97.5-125.89zM14545.3 1258.25l-65.5 226.39 42.8 1 54.3-225.04z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      d="M14444 411h-18.6v47.933h18.6zM14710.6 634.932h-30.8v47.933h30.8z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14187.3 1084.14-100.5 123h595.4l-99.1-125.9zm-10.8-125.897-100.6 122.997h595.5l-99.2-125.891zm10.8-125.892-100.5 122.998h595.4l-99.1-125.892zm-106.8-197.42-.3-52.346 113.9-123.494 373.9-.158 124.1 117.244-1.7 58.754h23.8v52.817h-101.4v70.081h3.9c19.8 0 35.9 16.048 35.9 35.814s-16.1 35.814-35.9 35.814h-466.6c-19.8 0-35.8-16.048-35.8-35.814s16-35.814 35.8-35.814h8.3v-70.081H14058v-52.817zm122 52.817v70.081h359.1v-70.081zM14444 411h-115.8v47.933h115.8z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M14714.2 634.932H14058v52.817h656.2z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m14265.6 1485.64-59.3-227.09h372.6l-56 226.08z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M13534 2349.19c0 98.47 852 98.47 852-805.19"
    />
    <path
      fill="#8C8C8C"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.88}
      d="m13780.8 3485.85-2 431.13 14.4 38.64 14.7-41.34v-428.43zM13842.7 3485.85l-2 431.13 14.4 38.64 14.7-41.34v-428.43zM13904.4 3485.85l-2.1 431.13 14.4 38.64 14.8-41.34v-428.43z"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M13876.2 3159h-40v60h40z" />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13967.5 3241.36c0-12.39-10-22.45-22.4-22.45h-179.6c-12.4 0-22.5 10.06-22.5 22.45v293c0 12.39 10.1 22.45 22.5 22.45h179.6c12.4 0 22.4-10.06 22.4-22.45z"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3262.41c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3252.68h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3304.71c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3294.98h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3516.23c0-5.37-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.35-9.7 9.72s4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3506.51h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.65 25.4-19.44"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3347.01c0-5.36-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.36-9.7 9.72 0 5.37 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3337.29h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.73-9.7 9.73h-32.2c18.4-5.01 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3389.32c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3379.59h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3431.62c0-5.36-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.36-9.7 9.72 0 5.37 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3421.9h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.73-9.7 9.73h-32.2c18.4-5.01 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M13944.7 3473.93c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M13928.2 3464.2h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45M13801.1 3556.81l-1.5 356.27-6.3 42.54 14.6-41.9v-356.71zM13863.8 3556.81l-1.6 356.27-6.2 42.54 14.6-41.9v-356.71zM13924.7 3556.81l-1.6 356.27-6.2 42.54 14.6-41.9v-356.71z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M13376 2348.95c0 975.62-.4 970.42-.4 1946.05M13310 2348.95c0 716.52-193.4 659.52-193.4 1376.05M13240 2348.95c0 468.92-382.4 360.12-382.4 829.05M13163 2346c0 139.71-599 107.29-599 247M13454 2349c0 509.14 402 300.86 402 810"
    />
    <path fill="#3F4142" d="M12583 2593h-40v60h40z" />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeWidth={10}
      d="M12514 2801.42v-58.421h98v58.421z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M12584 2797.71h28v-49.76h-28z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={10}
      d="M12514 2801.42v-58.421h98v58.421z"
    />
    <rect
      width={89}
      height={120}
      x={12503}
      y={2747}
      fill="#257676"
      stroke="#3F4142"
      strokeWidth={10}
      rx={15}
      transform="rotate(-90 12503 2747)"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M12596 2745h25v-85h-25z"
      clipRule="evenodd"
    />
    <rect
      width={89}
      height={120}
      x={12503}
      y={2747}
      stroke="#3F4142"
      strokeWidth={10}
      rx={15}
      transform="rotate(-90 12503 2747)"
    />
    <mask id="HardwareFig_svg__a" fill="#fff">
      <path d="M12626 2865h98v126h-322v-126h98v-77h126z" />
    </mask>
    <path fill="#EDEAE0" d="M12626 2865h98v126h-322v-126h98v-77h126z" />
    <path
      fill="#3F4142"
      d="M12626 2865h-10v10h10zm98 0h10v-10h-10zm0 126v10h10v-10zm-322 0h-10v10h10zm0-126v-10h-10v10zm98 0v10h10v-10zm0-77v-10h-10v10zm126 0h10v-10h-10zm0 77v10h98v-20h-98zm98 0h-10v126h20v-126zm0 126v-10h-322v20h322zm-322 0h10v-126h-20v126zm0-126v10h98v-20h-98zm98 0h10v-77h-20v77zm0-77v10h126v-20h-126zm126 0h-10v77h20v-77z"
      mask="url(#HardwareFig_svg__a)"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m12596 2898 25-27.5V2793h-25zM12409 2985.31l311 1.69v-20h-311z"
      clipRule="evenodd"
    />
    <mask id="HardwareFig_svg__b" fill="#fff">
      <path d="M12626 2865h98v126h-322v-126h98v-77h126z" />
    </mask>
    <path
      fill="#3F4142"
      d="M12626 2865h-10v10h10zm98 0h10v-10h-10zm0 126v10h10v-10zm-322 0h-10v10h10zm0-126v-10h-10v10zm98 0v10h10v-10zm0-77v-10h-10v10zm126 0h10v-10h-10zm0 77v10h98v-20h-98zm98 0h-10v126h20v-126zm0 126v-10h-322v20h322zm-322 0h10v-126h-20v126zm0-126v10h98v-20h-98zm98 0h10v-77h-20v77zm0-77v10h126v-20h-126zm126 0h-10v77h20v-77z"
      mask="url(#HardwareFig_svg__b)"
    />
    <circle cx={13379} cy={4597} r={249.5} stroke="red" opacity={0} id="a1"/>
    <circle cx={13116} cy={4027} r={249.5} stroke="red" opacity={0} id="a2"/>
    <circle cx={12860} cy={3455} r={249.5} stroke="red" opacity={0} id="a3"/>
    <circle cx={13855} cy={3434} r={249.5} stroke="red" opacity={0} id="a4"/>
    <circle cx={12565} cy={2851} r={244.5} stroke="red" opacity={0} id="a5"/>
    <circle cx={13356} cy={1844} r={599.5} stroke="red" opacity={0} id="a6"/>
    <circle cx={14394} cy={957} r={599.5} stroke="red" opacity={0} id="a7"/>
  </svg>
);
const ForwardRef = forwardRef(SvgHardwareFig);
export default ForwardRef;

